webpackJsonp([1],{

/***/ "+Dpm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Kmq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+OEc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+R8w":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABqCAYAAABUIcSXAAAAAXNSR0IArs4c6QAAGspJREFUeAHtXAuUXVV53ufcuTOZZGaSyUta5RFIwEB5FKRJAcEYKLDKqrJoBdpaFq5V0aWitl1WwrLGqgi0ikXaVbS1haVW0lZd1ActD0URTMWgAooEBAwFJCRkZjKTedx7dr/vf5xz7iRZ684jD9c6O7ln7/2//+/fe99zz52ZEKpWIVAhUCFQIVAhUCFQIVAhUCFQIVAhUCFQIVAhUCFQIVAhUCFQIVAhUCFQIVAhUCFQIVAhUCFQIVAhUCFQIVAhUCFwkCKQHKRxhZ0Pf+EVaW1sWTMLRyDIw2MS+tDPizGZlyShhtdIDOkw+uEQk+fSWvJUknY83bV8+S+S5DUTB2te043roChUjDfXdz7acUbI4ukxxlVJSFahMEs8KcxDxCRBVXBxsvU2B518/B+D0EMxphvTJNvYndbuTI75w5cmKf3KTSdnvd8SiJu/3rVz+Nk3oAZvjDGcH0NcwIJ4IaQoiAY80EjGRatVFE1YqoMCq0xJjslArwnW/WlSuz3Uw21zl1+6hfRftYYs928b/OGnjw5ZdgVQvwy4L2IB8t2CUPKxFSXnS7U8Vg+bRVKayLkOiLkd8o2eJmkTw6/X0uTmrhWXfAM6mVs82HvPeJ/HOfTDm46LWbI+JOlFMcPBhgL54ifaEggJ0rzHRGg2R0fJogggyIRKtGc8seH1oa7rW09+mj6WhvRD3UdfvOFXoWClyC27We6GNn12SRZHbgAYl2ZZTAlmXiEpAo+sVPB21zngpSIJDUVREgoi41LRqKwV1IIZX2pkdLEPA1psPSpxc/JorV57V/fyi7/p/g/Gfp8WanDTp34vZuEzSHyprGp4c4B9Lj0RzgHk0MOy3uZeLIJPsKWBJ3VQopH2UkjXoVTJJiYRtj/Z3XnIumTZmlExcpBdHJFZDSs+9s+9A0PDn4TRt+SGc/C9EAXQKjN57nJ+uoGf2/BjDrvCwXcee9tBUtg8ALWXLxSXF77ZS8JPOtP0zZ0rLtlUUjsohobO7MUytOmmM5uNxi2A5Qix6oCgV2e6A8iTnQN6fsdWAp2yireHiN5tiWHTh47VhRaVI3JqwY9V4bToqz2VopoWC/OJJE3+es6K2seS5E1NNXjgrxL/bIUx8P0b3oEVeyOSTluOowJJcUXwiKmv7rwgqiQFJI+F4T/cumtRVVvp4LHAXjyV00zEPsuXF0xtKZdkpj0pdaFRQguGs/DOefMXXpgccu6w6x3IHojNThvYeMMHs2a8CfjgzgAgCdKAWPpWH6TpLqIYjy80k8+HGJAe8Sa3WzN9oZs+i8mmRdCx82EFtkhTXxKT+BMJKtnAh4w/O2fX4LZ74rNfWpQzD+CgiHAGQezY+ImP4o5unYJkhix5X726K7AuCJADIz1XsJM1HELqeqyW7xbSVL0UNmhK111nZTd9xiIGJKiyPn2IZTGlZVSfwmAALvHw3K7uM5NlF+4wzgHpZryjBr738XdkWbbOVyxxYbNOJ7aSsUpbGCqz+64rdG0HyG5gMb0MCrM7kR1intwmpEVeyBTHa7Kc+1G7JuR2iunxu8Z2fYVPUox1QLoZFWr7xo9fkMXsRklYViCyy5hhASpBKANkTKEJnVsEjeplWdcpZFSOiKscii62eTRaQW3OeCijIWUYtx6fqg87ZksLxgBEERfTtz6L8axd2Y5/Jf1AtWkXauR7N74qzbJbEDjPMwVDsJRsQVYgLHvJzwHiRMERsvJQ4DJNxlZEApgYiFKAkj6PRfJJ3621kBijCEJMGTwF1KfFL3Ty9MUM8nEMlww//vm37uZjPxGmVSgknI5lo5/DblrI5PliwgJEqQeBREnFZXROCIznMsRbVj7t6Q4QKdcX0ApUBELwKCu2Sn7dF3sfY5AXxQIiSfguw17c2KlgAkX8Mfnk2ONfXFlEsf9G0yrUwAPX/SmSOotJ6YpEwEROWmvRKFGsWhVyYERcmAQoNyDyLABZwpbthEleSAcdfJxvyqZ+YSdmdiSqc3ElheCIvsxviS3qIghiLkv7qo1nyVl3M2aflul+vrTE2Y7v7Q9eOz8ZC5uR6xJDUdWYEF6O957uoPimUaTtauU7riIcsSUiZhdj4cKGjdyA9qQKj1PI5GNhkKi+y3QhQpY1Br3wyal4Ey2KSTMZfE67ZO4xl97m5P3RT31Hjcar8eZqRbIQmRMq1LJTjCXr3KtnMpPlWDxdwZQumkI1ya7Y0N1CSco4pOVdnW8P+sZLQoSAHJWklZsYmOTH+HlcYkBlYta8PsYH62UT+3o8pULF+67rRahXaMwaNAHB1xYaZwlEfZ9RgASHPBPIggCtFh2REX2lEyDiqboYcGLNZcWK6ZBGmwosxU3Hdgbnakttqn2TyW1TXxeBHJ3UUcM07oocHjb6s8cv9nj2Rz+lQu2Ijbcgyj4FwxLPAUD4joRFnoOBuQDggLA3cXSlVj4YyeGttUoURSiKoYrkK63sXvAVP+BbT1tOZ681VPsiowbtPY9qhS+Jg3bY0ONUeY9O9s91SoVCcPxmVuuRx4yBZA+O7Cwy8DJQCmD0vUh4kptAn8spKHYHp+qQojaa2RJdugPCDpz0KgQadgPBxIv0ohCi1EJXfZLAs6Y0i4t5wr2mpmMVVXn4OmX4p58/xXX3dd92oQa/c83RCGalg8DAHIzd7rAsd3ZMW+HWXpJ1cNiD6WCJnAqADB7HJiu+zB4L4kUodBiReuJIGnTdttghu0RTmyy6FniStqi4X05MnUbc/ht1sO+vbReqEeMbGKAmzkD1ZThKpMITbAu+6ugRpnzyrFFZDKi8F5VyJancZ4u+q5Yl/f3Fd1buxuIWu+qriL/wJPahIycDZPUMoK7Fbzm7y5gQk/3T2i4Uwl/LkPLbVgHY17ACoSvSdxCETcZTkaMEQiyDrGJjiJgAozySdfXyjd19yFAvkCWo6o9urGp0UODeIqM7kLZMhjpoQqc9/BN7tGuGvXDqVOMgS6R1MRwfN2/If6zN5fZF33ah8BTiRAZeBhgTCRoXacrnhHJOJAtjyuJDKOlMVm7JjS58SlHH+IWfkg/j06LUBHP14z7tPY4ClGXnvk02j0sQd30RFVsiTy3Tp7raIm1S/JAZixMnqva+vbZVqKFvX7MEeR3CUDQ/BVRCY0Ikakb5ahQeqVx5bCKjQ4LAl9iCnqorsDQgYJlZAYw+zL77ErrZ1M9hKlLYMh3RLdyLddKM3tp7LBonr3n8BUliZ4z01Wg2Tiix9tmwrUKNJY0jGTADU4AZJv45gOh1rHxNTmmGZctnLc3GdIgnGmZyhSEaKdEAMoyU7SvT5EoxeHwu63YoT5rzvVjqU7iFT8i1xJ8noDHlNkUONmNypMRDH/gqZNfTG5b5fDb7tgqVxLiATsuri/EXOdhKLEXmT7uFZCBpkkxYk3YbuV3DIpfLwVXDDrap5960MGrXYyLTzenIFoZpuW/y8sLmFi03+Ndmvc31JsMXUBBsRG75zphNxI0jmzf8dsnUrAzbKhQymV/2xsTkZUnm4DARS4Z80l1WwTIrImd3UnY0qg1fzapHaSmi7WbTzn3TF+2z6Wcr1XO/YrMk4zF4TN6rbxiRuNQeeb6T1YcVywuLmIQesxwb/DDMOH72th+FvGfkiQ2z+uSirULhXaaDy1MD84B11XmSmoxgll8AYz7mgPPd5IgGeQa4THBxuz6nNoREjivatARMsSwFp7/SS2z6nKzS2HyIHZAn+6dfobmKy0yKE4F0UNYbFxaess/Bo4t/G9284e1On2nfVqFqWRhkkg6OgIE5E/EXeXqEMSOUVgkkkiNyqq8hKzAmKzIU5dx6sad61BCe2yzx3D9l1JfKimjZr/lQmSIm0Yec7h7e+FhMalDnctX8qckmveY2oBTQnvoyjsGIRc24swQF+7vxJ//zVOfPpG+rUPjpLwRTgCbJCuqTisdILBN9WoE55ESULFv1BMef6pW4FBADDlqxc0BmEz5dqF/a9Zf7JVdFtS/8TIpfpKAvwUHWbBtZY1UT8FHY5FjjV0lwdrjOWDayhHbI1z6rTzTGv4ibjD6XmW7fVqGSmG1xcHJHHgyTsOCYM+UkkRIAFKUMmwPrcq4rfNPxQooLs+/6YgQXyrS8KMdW8kUdLg6XE/MqpfGYDZWzHWM0lYUxzsWuGBZt8txmGpLn3GQ2ni4pFqPvznjkrmyAP9Y9o9ZWoRa87oPP4M16p4PLIFuaLEsFrgUMCKks5CU7T5C3+oUNUwfTrIp9260GnHBIJ/D+tQqINCs+TccstHbgqXuNsYjfHeZctVXSljKJbSVqgUrxJ/HHLh5jY6nYljgZq+cb37Rz823nutx0+rYKhSIx3kcEEAwkLQQj8UtQXD1sCoSMCCb+txwtaS10LjwqdL/ylFDvXwYxA4g21GheBAFEfJHBBhlruU364z/oqzrHvpKtNx1q1+YsCF1LVoauxXi+3DFHLZbjx1iAhqwCbouAkpQrNZnikqa1H+XkmB2rC1DtMBY/KtOs8YFcbhqDtgoldmN2bxkQAqOAmVfJQ0HF5y4QFTRPmFD2Ll8beo44PXS/4jj0Z4Seo86CFHQozxeGrTZhgyCJLR9TlDRrNiZXvTvD5Ixf73tVmLfsdWEOijQHxeo9cg0KN/mtw+J3n+Xvw2jH/UrPIoXn5xzz5qfdI76lep0ftYyZL1k4cgqE08ce+8K0n2K0XSj8MvPXGKgUS7DVwAvQPChCpo2fbZg6KV39h4V6rzyFMm4InQTv0FVSHNrxZ4GaoFtRP2LJABKbMoak9XSqY5XnWGHH5pm3RHaxzxlAktaxs15d0i/FT9d40af74gIS+/SnE8zD7XLaUJxfzWfhNNrm8ew7yeNjwRr4kTPhT+PSdqH6zzr+fgS1jdHlzpGNJ0LfCoRlCR7l+CI97erdY3hdi5eHuYfhg3zagfzVQost6NMALOW+3CZjER2AQAkVaHXT0ffKMPfQ1WAVtl0irc/Lbbb4pC16LMWvvkBlPPQHc/gh+9vd1q5HfnxqFpvz5G7X9PCBSti6yzCOzfNcfqp924Xir6DgneqzTCFvDMiSYiKSBJiajBdO5xM7X8zVJg+6Fi0P8485P9Sw42Ql8im72FVJtWe+CJT5FBmZm0UbUz6pz5FdJDsWi2BPrblru/kpCkO5PcUv3nPfyA1/MmHu8b95p9uNsbmWYclygJx+PAGBsXguMf7GdH80uu1CMaBaEm5OdU8jAF0tGhih0xWvgWn4cj5bJo3B58PY9p/bbPeu1r0g9C0/O/SsODd09h+Bo4mfGwlgUXCd6M6QYghBfdMvW23uQhTo5NB39Pmhc8ERQtvTJWuMhtEXf2rAEk/uTkpaHhiX4yeHbL4oi99C/nv/exaY47e44+W+c9iLKSph7LsMXxXVxydeWkHyVNuel9perCxY+5EnX7zr6i8hiIvyczqXRQUJFpg8ZiRYO8tFBOOdP/+OHIF1vGfsrdV7lga+YtYIEztfCM3hbaEx8nLIxvFwpDmOl/6tj6RWRzE7Q9I5N3R0LwwsNN8D0/rcvZnO6Vj9YWTLxhAbI6A5pBY/KYhVwSaPu4KqoOkg4LfrR3o6O28mlW3ox5+5AI+MlmmhSXFbLDoBMTvgZEmY1q/xTKlQDGFOqK8bCxNvQCaqK8VBIOwlLB9TmmRfqZw0wtDmu0LfinPwBr9Y+Hu7cEfxZiPwNampp0nENqdcAMPP/m9ojmxjuGhmzfIQYCUXsCQV22Eq7F6uT1ZeBgPaYPNdif1amJqzAkFHi4uDS3BIUM+sx/Wm0k/p6KPhvrPXPw73N8v2txUmDiU5hIVedhaIrUWSZRni+EgY+OnXcOz8TNSmcxF8p6HYHBsMQ0/eHZpDz2uMjFnDYrQCJoFtid/9yFFP4bilZ3H/9U4e2vSPxwL9s7kD1ZgXVu3BmNiVkvFIjOm0/orMlAvFAOOc+Vfh7xA844BpkB66SMha0sBLdCkmDTTD8DPfxVF4b2iOD5cE9s2Q8Y1t2xyGnrgrZCgW4yqOKcxaCsYYCLYUpTUgyCVJ7crk0DftckYzNj8sY9qQD/l8ZMVXUXB5n6IuBbNG/sjJbbTTO9btyLbIbL1r3RokdLfELlmXTBkKctablv5eLSeUIwjoKYff552zdGXo/rUT8P7STYFZa9wd49ufCqO/fBSnLrGlv7J5ncgtfrlyJlTEjwMRfPy/ue/kd7zNLQz+4KYL8IT8vyQPWufvJrPZ7ygzTbWt9DRN47zjT+rymxAVbu/aEnZ7KoXUtrvXfRB30utJEeg9We8dGAtYy+NglXoaQHKd818Z6guXha4FhwfeLEyn0Udz+MUw/vKWMDG4BQUaK2LTAIiemC7e6H3pGBwev/eQxg3EI71Ll/yW76b4o1vnDYzveBSsw9WY6SJnKQ6JeeHyQm/qPfGKaf3Q5pRvJiQouyxae82Htt551Urkf7GsPt1eyBoUSRI9/mOCjlt/Ui88YePszsL4ji1hfODZMJzcj5sN3sktDh243a7N7Q9prQvFw11eR6cAoHeAuAtsTOCOcGfgZ6IGXs0RfDZCcbi66ZO+BTiPSUkSF34uT2M1GX1PBeC5rAYI/efrSbzAi8SMBsa2rYfY4WKbufLYQ1/gACHkJMWiPWnJV2ww5W5GhaK3xfOWXP7SyEu4n45rCu8oCIJkYSR4MBiqA+G9yEOETHwu0YakktAMjaGtobnzpTBeWtUqr4ICEO17oxydsOdQQCJwFBCGxuRyIkRxfTcC0y3RiMVKUjJYS+vnd5/8tmdcYMf3bzg7NLP3yGKQeCkmTuFJP1/Kcwvxq5+p+McC8Bhu2oWa1s2EB8w+Oe3Pdi1e0HkBMruHmPibqBSJAkhEVnYJiLLcnvhaSMKLfwRcEi4D6X70CQblaUfr1jrWeFSefvMm8dC+ytOXYq00lU1eTmvpeT0nvy1/Qj70wA0rs2bjP6DV4bGxLz+JoA/n6TKAdAgP9pxwxcMcTKfNuFB0mrxm/QjuA36fC1ETZGASHKFWECU6gqB3RGXQch0BTwTlInRRV1tiEzICrolRxo8bMAplHwqNu1TD4HdZAqL8mFTJiPihLdKkaM/VQv3MvpPf+YBJhcEH/3ZxM058FcfcfBbGi6x+1YDY5uKiX8bK530Y4i+k/KXbmU4/K4Wi44mx9CSAgG84EBWaJ1HeWcKwi8p5cqrDjHwl5gUV4GjQtRV0BUL9UFZ2g+jTJuWttwrBshVBNx79l2MQ6wIs5ZJv1WPH6t5T3/5I7vWpf5nTGGt8GR9Yj1Qa46APcSa9xm5c8U8eWszu6D3l7ffoZHrXGb9HuVtU6PUWlq5exieJ6Cpl3IK5neWcsIgiw4kI5GWlsltATzkegeBDnwCzp5rI5eoCnRFpkmBSSAVoUlQYC/XZ6JcNU3w2HEXJr55/6rv5Z+uMgR+K+M7H+l/+vxduh70zVI+x0DXXOcT0zw/SKMY8jmlb7cP8YNpZezflZ9JmbUdlWXNtsRsYvIerK5cJauHAYw4qksthKsDKKoeuyGquIiwAqZDiQYBdThCgHx4zFEKHl4JqM/EpVuFei00p8QceyvJQGjtO6V/13k9AT41Adft91x7WDNl9sH2GWqUL+qYT9jIwmhbQaWBmtRj/qO+kdz7OKGbSZqVQW+97Xy+SO1VWL+O2xoT4ErytF6iYnBIhSdCYoMmZbs6mLLnUB3FPNkGkujUOONcX5aWVer8zIy9NkwnU5aPz6z2reldf+RMzIt32b3/0hJiNP4DvlY7V9xrm44vBxuJL45fY5D1JfSPc9X2r3vPVss3pjmfn6BuOZyE03AURTF2t7GXlIjIBi8gbZlKk8hgsYZf0mRALIw10KahNvWPRZe3nchSDf/tMQ7ncrk3EEo4qfF2DL1zDrTHWPty/+r1Pk11uW+9d/9Ysm/g4LPTkcVAASpxLSDqVPD05l5WixfBY2eZMxrNSKPy5z7UCmkWZ48ZsPHJEqXQWkiFrUSV4EEjyIlMnB7ikL7K8iLzpG2h6WuUTEeXqzx/rmDKOkJdR3VtDZ/Kp/te870kj5922ez9yaGyO/RM+J/2Ox64LTePmwwYpAsvD2CRwpXmGkqDyzoHhf8+Nz2AwS4XCt5sITBKyBDgm2NKkMJ5T/EGadNwSaulPsqxxIdK9COxDKKv6mq4Uk8kaXYZKZEUFpBYf8Cb6UJEy84iCnMgkYRzjb+EPJn5hQaxv4Gc/MVy6QC7Z/s2/uhxPNW5APH2yVTGwECApEWoSJT0SmKkULaerLL73YqFmpSkSMzA19N9/sXRXjC8gT8FHLrDH2sgOQY/P5M/j8rm0Vr9l0es/zOdjeYtxfbrjnokzGkm6Fo+RXot3jVVgyrd/qi+WSkBYyOou90ODDhj0gHt8DI9vvgfA71jY0XtHsvpKPjbfrUmB7l53EfbeBzA+QQGHD9rHi2tD48Ac56U25bN4Ku8y4EJH6CwsxrVacvT81e/bbIrT7ma8o3aFZA2TtdIALAKLlqSjuH6lo5besnDtyXfu7c9+Jsl6vhN/214hfnN9x0AWTmim2QpYWo6fTTgKYByKMd4rkh4Ax/eMDvgZwdoYxnvUMOB6Lkvi0/ip1afSGB9vdvY9uGgvhYEfaVwgW+8e/YMX/+f9H4C94wRcgqyVkd4y0cUALb73SWFYAzBxDOLPFOpfntbNrvqU0X2GB8TNwF114AuFIsnv9lr2CD79LtbzLfgj8BsWnnMdfmZ9ai1Zs74BjU32mpryFKS3bww9+KHIOnbSD1DofuD+68gFFgC2Pa8DXarB4vEfv6ZArR6qhfCNmNa+3t8x96EdjeFzUaw/QdF+F0w8NWaRuPZQWOjjBzRZqH8QwgwujGpG7Zff+HO8ISc1xHQrFvqtS8+79okZGTxAylvvuupoQHwYSvWKENOlwHsJijMKpF/AAfZLwP5CV0f3z3vPXLd1TyEObrxmUWO0eQn0L0OxTmXB2HAzM9B/+urFSbKGC3DabUaFio+u73zpFztPW3ze39yL7c7lWDUgMHj/Na8eb2aX4dj+Y0xfFTpqpy867f33V+AcpAjgKE3x+Ons7fdd89qDNMQqrAqBCoEKgQqBCoEKgQqBCoEKgQqBCoEKgQqBCoEKgQqBCoEKgQqBCoEKgQqBCoEKgQqBCoEKgQqBCoEKgQqBCoEKgZkj8P8RVLVyVamckwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "+ahz":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footers",
    class: {
      'newV-footers': (_vm.vipState === 0 || _vm.vipState === 'loginNo')
    }
  }, [_c('div', {
    staticClass: "footer-bg"
  }), _vm._v(" "), _c('p', {
    staticClass: "footer-con"
  }, [_vm._v("开启应聘快车道，与众不同立即开始")])])
},staticRenderFns: []}

/***/ }),

/***/ "+kS2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+wsh":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("4mYs")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("px5W"),
  /* template */
  __webpack_require__("IR0T"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "/49Z":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "/rVf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pri-jlzd.png";

/***/ }),

/***/ "/wR2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_CvipDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hyxyDialog',
  props: {
    stopPrevent: {
      type: Boolean,
      default: true
    }
  },
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_0__common_CvipDialog___default.a
  },
  data: function data() {
    return {
      title: '58招聘求职金卡服务协议',
      btnTxt: '我知道了',
      hyxyMealInfo: [{
        name: '7天体验版',
        price: 18,
        compensate: 100
      }, {
        name: '30天基础版',
        price: 28,
        compensate: 160
      }, {
        name: '30天升级版',
        price: 60,
        compensate: 460
      }, {
        name: '半年卡',
        price: 60,
        compensate: 880
      }]
    };
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-hyxy-tanchuang-show-new');
    this.initMealName();
  },

  methods: {
    close: function close() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-hyxy-close-new');
      this.$emit('closeDialog');
    },
    initMealName: function initMealName() {
      var _this = this;

      this.mealInfo.payset.forEach(function (mealItem, index) {
        _this.hyxyMealInfo[index].name = mealItem.versionName;
        _this.hyxyMealInfo[index].price = mealItem.benefitsPrice;
      });
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    mealInfo: 'mealInfo' })
});

/***/ }),

/***/ "/xXl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-jlzd-big.png";

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0BnJ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("CjJh")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Qt2z"),
  /* template */
  __webpack_require__("TcG2"),
  /* scopeId */
  "data-v-17e3ffc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "0kwd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1C1u":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1nBK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "2OBb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pri-ccaq.png";

/***/ }),

/***/ "2XsK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/header-vipExpri.png";

/***/ }),

/***/ "2buI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2mV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types_js__ = __webpack_require__("Du/2");


var state = {};

var getters = {};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
});

/***/ }),

/***/ "2s2x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "36uJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3NXL":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("px9A")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("mw8X"),
  /* template */
  __webpack_require__("XT4T"),
  /* scopeId */
  "data-v-12f0a829",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "3NyZ":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("6yKs"),
  /* template */
  __webpack_require__("dDI2"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "3oUR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/demo-img-buyvip.png";

/***/ }),

/***/ "4aM2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4it6":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("+Kmq")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("nHvB"),
  /* template */
  __webpack_require__("U8bG"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "4mYs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ufM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-fpaq-small.png";

/***/ }),

/***/ "4wbl":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "55Kt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        var config = {
            method: 'get',
            url: url,
            withCredentials: true,
            params: {
                t: new Date().getTime()
            }
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default()(config).then(function (data) {
            return data.data;
        });
    }
});

/***/ }),

/***/ "5GdW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5LNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ypyxDialog',
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
  },
  data: function data() {
    return {
      title: '应聘优先',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: '',
      btnTxt2: '立即体验'
    };
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-ypyx-tanchuang-show-' + this.cvipMes.cvipstate);
  },

  methods: {
    vipBuy: function vipBuy() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-ypyx-ljkt-' + this.cvipMes.cvipstate);
      this.$emit("buyDialog");
    },
    close: function close() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-ypyx-close-' + this.cvipMes.cvipstate);
      this.$emit("closeDialog");
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed' })
});

/***/ }),

/***/ "5bV0":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("P0uP")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("NhgF"),
  /* template */
  __webpack_require__("wNpd"),
  /* scopeId */
  "data-v-0086ab8f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "5op6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6FVW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6yKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_TipDialog__ = __webpack_require__("mEEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_TipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_TipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TbtsDialog',
    components: {
        TipDialog: __WEBPACK_IMPORTED_MODULE_1__common_TipDialog___default.a
    },
    data: function data() {
        return {
            tipinfo: '网页版暂不提供赔付流程，如需赔付请到手机客户端进行赔付申请。',
            applycourse: '58app--我的--我的求职--会员中心--求职保障险--申请赔付'
        };
    },
    created: function created() {
        window.clickLog && window.clickLog('from=pc-cvip-tbts-tanchuang-show-' + this.cvipMes.cvipstate);
    },

    methods: {
        closeDialog: function closeDialog() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-tbts-close-' + this.cvipMes.cvipstate);
            this.$emit("closeDialog");
        }
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
        cvipMes: 'cvipMes',
        rightUsed: 'rightUsed' })
});

/***/ }),

/***/ "71+3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/header-upgrade.png";

/***/ }),

/***/ "7Lah":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7xeD":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page3"
  }, [_c('div', {
    staticClass: "jobPrivi-privilege"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "job-comment"
  }, [_c('div', {
    staticClass: "job-swiper-pagination"
  }, [_c('div', {
    staticClass: "jobPrivi-icon"
  }, [_c('ul', _vm._l((_vm.commentData), function(item, index) {
    return _c('li', {
      staticClass: "icon-page hover-class",
      on: {
        "mouseenter": function($event) {
          return _vm.enter(index)
        },
        "mouseleave": function($event) {
          return _vm.leave()
        },
        "click": function($event) {
          return _vm.show(item.clickShow, item.actionType)
        }
      }
    }, [_c('div', {
      staticClass: "icon-radius"
    }, [_c('div', {
      staticClass: "icon-box",
      class: {
        'active': index === _vm.currentIndex
      }
    }, [_c('div', {
      staticClass: "icon",
      style: ({
        backgroundImage: 'url(' + item.iconUrl + ')',
        backgroundSize: 'contain'
      })
    })])]), _vm._v(" "), _c('p', {
      staticClass: "detail-text"
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('div', {
      staticClass: "icon-title"
    }, [_vm._v(_vm._s(item.privTitle))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "comment-display"
  }, [_vm._l((_vm.commentData), function(item, index) {
    var _obj;

    return (index === _vm.currentIndex) ? _c('div', {
      key: index,
      staticClass: "comment-box",
      class: ( _obj = {
        'dialog-box-active': index === _vm.currentIndex
      }, _obj[item.itemClass] = index === _vm.currentIndex, _obj )
    }, [_c('div', {
      staticClass: "comment"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "dialog-box"
    }, [_c('p', {
      staticClass: "comment-text"
    }, [_c('span', {
      staticClass: "mark-max"
    }, [_vm._v(" “")]), _vm._v(" "), _c('span', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.comments[_vm.randomIndex].commentText)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "priv-result"
    }, [_vm._v("\n                                " + _vm._s(item.comments[_vm.randomIndex].privResult)), _c('span', {
      staticClass: "result"
    }, [_vm._v(_vm._s(item.comments[_vm.randomIndex].result))])]), _vm._v(" "), _c('p', {
      staticClass: "comment-from"
    }, [_vm._v(_vm._s(item.comments[_vm.randomIndex].commentFrom))])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-bg"
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "btn-buyvip"
  }, [_c('p', {
    staticClass: "btn-text",
    on: {
      "click": function($event) {
        return _vm.buyVipDialog('pc-cvip-huiyuantequan-xiangshouqiuzhitequan')
      }
    }
  }, [_vm._v("开启求职快车道")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "priv-title"
  }, [_vm._v("求职特权")]), _vm._v(" "), _c('div', {
    staticClass: "priv-desc"
  }, [_vm._v("多项求职特权免费使用，面试几率提升300%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('div', {
    staticClass: "hidden-line"
  })])
}]}

/***/ }),

/***/ "8Oyi":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ "9QzW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pri-wxsx.png";

/***/ }),

/***/ "9T7f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-zgbs-big.png";

/***/ }),

/***/ "9dnQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-hjld-big.png";

/***/ }),

/***/ "9ic9":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "numbox",
    attrs: {
      "id": "number-box"
    }
  }, _vm._l((_vm.numArr), function(item, index) {
    var _obj;

    return _c('p', {
      staticClass: "number ",
      class: ( _obj = {}, _obj[_vm.numberData[_vm.numberData.length - (index + 1)].class] = true, _obj ),
      attrs: {
        "id": "lakh"
      }
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v("0")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("1")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("2")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("3")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("4")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("5")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("6")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("7")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("8")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("9")])])
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ "9ifX":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'page7': this.vipState === 0 || this.vipState === 'loginNo'
    }
  }, [_c('div', {
    staticClass: "jobAnalysis",
    class: {
      'new-job-analy': _vm.vipState === 0 || _vm.vipState === 'loginNo'
    }
  }, [(_vm.vipState === 2) ? _c('div', [_c('div', {
    staticClass: "jobAnalysis-no"
  }), _vm._v(" "), _c('div', {
    staticClass: "jobAnalysis-btn-wrap",
    on: {
      "click": _vm.showDialog
    }
  }, [_c('span', {
    staticClass: "jobAnaly-buy"
  }, [_vm._v("开通会员查看数据分析")])])]) : (_vm.vipState === 'loginNo' || _vm.vipState === 0) ? _c('div', {
    staticClass: "newV-jobAnalysis-no"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "demo-img"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.vipState === 'loginNo' || this.vipState === 0) ? _c('div', {
    staticClass: "jobAnalysis-btn-wrap",
    class: {
      'newV-jobAnalysis-btn-wrap': _vm.vipState === 'loginNo' || this.vipState === 0
    },
    on: {
      "click": _vm.showDialog
    }
  }, [(_vm.vipState === 'loginNo' || !(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('p', {
    staticClass: "btn-text",
    on: {
      "click": _vm.showDialog
    }
  }, [_vm._v("马上开始求职指导")]) : _vm._e()]) : _vm._e()]) : _c('div', {
    staticClass: "jobAnalysis-out"
  }, [_c('p', {
    staticClass: "jobAnalysis-tit"
  }, [_vm._v("求职分析")]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-des"
  }, [_vm._v("专属求职分析，让你在求职路上不走弯路！")]), _vm._v(" "), _c('div', {
    staticClass: "jobAnalysis-con"
  }, [_c('ul', {
    staticClass: "jobAnalysis-alldes clearfix"
  }, [_c('li', {
    staticClass: "jobAnalysis-alldes-scors fl"
  }, [_c('span', {
    staticClass: "jobAnalysis-alldes-scorsTit"
  }, [_vm._v("— 综合竞争力 —")]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-scorsSum"
  }, [_c('span', {
    staticClass: "fontW"
  }, [_vm._v(_vm._s(_vm.cvipMes.advice.score))]), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-scorsSumIn"
  }, [_vm._v("分")])]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-scorsBeat"
  }, [_vm._v("击败了" + _vm._s(_vm.cvipMes.advice.exceedPercent) + "%的求职者")])]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-per fl"
  }, [_c('p', {
    staticClass: "jobAnalysis-alldes-perSum"
  }, [_c('span', {
    staticClass: "fontW"
  }, [_vm._v(_vm._s(_vm.cvipMes.advice.resumeAnalysisResult.resumeCompleteRate))]), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-perSumIn"
  }, [_vm._v("%")])]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-perTit"
  }, [_vm._v("简历完善度")]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-perDes"
  }, [_c('span', [_vm._v(_vm._s(_vm.cvipMes.advice.resumeAnalysisResult.resumeAdvice))])]), _vm._v(" "), _c('a', {
    staticClass: "jobAnalysis-alldes-perBtn",
    attrs: {
      "href": _vm.cvipMes.advice.resumeAnalysisResult.resumeLink,
      "onclick": "clickLog('from=pc-cvip-qzfx-jlws-wsjl-hy');",
      "target": "_blank"
    },
    domProps: {
      "textContent": _vm._s(_vm.cvipMes.haveResume ? '完善简历' : '创建简历')
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-per fl"
  }, [_c('p', {
    staticClass: "jobAnalysis-alldes-perSum"
  }, [_c('span', {
    staticClass: "fontW"
  }, [_vm._v(_vm._s(_vm.cvipMes.advice.yesterdayDeliveryAnalysisResult.yesterdayDeliveryCount))]), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-perSumIn"
  }, [_vm._v("次")])]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-perTit"
  }, [_vm._v("昨日投递量")]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-perDes",
    attrs: {
      "title": _vm.cvipMes.advice.yesterdayDeliveryAnalysisResult.deliveryAdvice
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cvipMes.advice.yesterdayDeliveryAnalysisResult.deliveryAdvice))])]), _vm._v(" "), _c('a', {
    staticClass: "jobAnalysis-alldes-perBtn",
    attrs: {
      "href": _vm.cvipMes.advice.yesterdayDeliveryAnalysisResult.deliveryLink,
      "onclick": "clickLog('from=pc-cvip-qzfx-tdl-mstd-hy');",
      "target": "_blank"
    },
    domProps: {
      "textContent": _vm._s(_vm.cvipMes.haveResume ? '马上投递' : '创建简历')
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-pri fl"
  }, [_c('p', {
    staticClass: "jobAnalysis-alldes-priSum"
  }, [_c('span', {
    staticClass: "fontW"
  }, [_vm._v(_vm._s(_vm.getUsedCount) + "/5")])]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-priTit"
  }, [_vm._v("特权使用情况")]), _vm._v(" "), _c('div', {
    staticClass: "jobAnalysis-alldes-priConOut"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priUseIndex <= 0),
      expression: "priUseIndex<=0"
    }],
    staticClass: "jobAnalysis-alldes-priCon clearfix"
  }, [_c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(2), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("尊贵标识")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[10]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[10]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : _vm._e()])])]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(3), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("免费刷新")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[13]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[13]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : _vm._e()])])]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl jobAnalysis-alldes-priConInR"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(4), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("求职分析")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[12]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[12]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : _vm._e()])])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priUseIndex > 0),
      expression: "priUseIndex>0"
    }],
    staticClass: "jobAnalysis-alldes-priCon clearfix"
  }, [_c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(5), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("简历置顶")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[5]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[5]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn",
    domProps: {
      "textContent": _vm._s(_vm.resumeListNum ? '立即置顶' : '创建简历')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.topResume($event)
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl jobAnalysis-alldes-priConInR"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(6), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("黄金亮点")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[4]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[4]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn",
    domProps: {
      "textContent": _vm._s(_vm.resumeListNum ? '选择亮点' : '创建简历')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hightResume($event)
      }
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-priL",
    on: {
      "click": function($event) {
        return _vm.priShow('l')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-priR",
    on: {
      "click": function($event) {
        return _vm.priShow('r')
      }
    }
  })])])])]), _vm._v(" "), _c('resume-chart')], 1), _vm._v(" "), (_vm.showTop) ? _c('resume-top-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "topBtnChange": _vm.topBtnChange,
      "show-alert": _vm.showAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSuccess) ? _c('cvip-alert', {
    attrs: {
      "buttonTxt": "我知道了",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-success"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.alertTxt))])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "analy-title"
  }, [_vm._v("了解职场竞争力，求职分析帮助你")]), _vm._v(" "), _c('div', {
    staticClass: "analy-desc"
  }, [_vm._v("简历石沉大海，原因究竟出在哪里？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-vip-text"
  }, [_c('p', {
    staticClass: "text-line"
  }, [_vm._v("开通正式版会员")]), _vm._v(" "), _c('p', {
    staticClass: "text-line"
  }, [_vm._v("查看完整竞争力，查缺补漏，求职路上不迷茫")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-zgbs"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-wxsx"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-qzfx"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-jlzd"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-hjld"
  })])
}]}

/***/ }),

/***/ "9yWl":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("0kwd")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("mffe"),
  /* template */
  __webpack_require__("DrUF"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ADMS":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ypyx-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("简历投递石沉大海？投递的简历收到的反馈极慢？已经找到工作，之前投递的公司才联系你？加入会员，你主动投递的全职简历将在企业后台置顶展示，让企业在挑选人才时第一时间看到你，让你快速得到企业反馈。")])]), _vm._v(" "), _c('div', {
    staticClass: "ypyx-bg"
  }, [_c('img', {
    staticClass: "ypyx-bg-img",
    attrs: {
      "src": __webpack_require__("aA0H")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("应聘优先")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：简历投递石沉大海？投递的简历收到的反馈极慢？已经找到工作，之前投递的公司才联系你？加入会员，你主动投递的全职简历将在企业后台置顶展示，让企业在挑选人才时第一时间看到你，让你快速得到企业反馈。")])]), _vm._v(" "), _c('div', {
    staticClass: "ypyx-bg"
  }, [_c('img', {
    staticClass: "ypyx-bg-img",
    attrs: {
      "src": __webpack_require__("aA0H")
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "AvFD":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("36uJ")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("wlP2"),
  /* template */
  __webpack_require__("ooJt"),
  /* scopeId */
  "data-v-ffccb154",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "BSwo":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rtop-dialog-wrap"
  }, [_c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.topBtnClick()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("会员可以免费选择任意黄金亮点，使用后将在简历中展现所选择的特长优势。")]), _vm._v(" "), _c('div', {
    staticClass: "resume-chose clear"
  }, [_c('p', {
    staticClass: "tit inline fl"
  }, [_vm._v("选择简历：")]), _vm._v(" "), _c('ul', {
    staticClass: "resume-list fl"
  }, _vm._l((_vm.resumeList), function(item) {
    return _c('li', {
      key: item.confuseResumeId,
      staticClass: "resume",
      class: {
        checked: _vm.resumeChose === item.confuseResumeId
      },
      on: {
        "click": function($event) {
          return _vm.choseResume(item.confuseResumeId)
        }
      }
    }, [_vm._v(_vm._s(item.resumeName))])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "tit inline fl"
  }, [_vm._v("黄金亮点：")]), _vm._v(" "), _c('ul', {
    staticClass: "days-list fl"
  }, _vm._l((_vm.lightList), function(item) {
    return _c('li', {
      key: item.type,
      staticClass: "day",
      class: {
        checked: item.type === _vm.lightChose
      },
      on: {
        "click": function($event) {
          return _vm.choseLight(item.type)
        }
      }
    }, [_vm._v(_vm._s(item.desc))])
  }), 0)]), _vm._v(" "), (_vm.showWarn) ? _c('cvip-alert', {
    attrs: {
      "buttonTxt": "我知道了",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-warn"
  }), _vm._v(" "), _c('span', [_vm._v("请选择简历或者黄金亮点！")])]) : _vm._e(), _vm._v(" "), _c('cvip-toast', {
    attrs: {
      "text": _vm.toastText
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "BXzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		value: Boolean,
		time: {
			type: Number,
			default: 2000
		},
		text: String
	},
	data: function data() {
		return {
			show: this.value
		};
	},
	created: function created() {
		if (this.value) {
			this.show = true;
		}
	},

	watch: {
		show: function show(val) {
			var _this = this;

			if (val) {
				this.$emit('input', true);
				clearTimeout(this.timeout);
				this.timeout = setTimeout(function () {
					_this.show = false;
					_this.$emit('input', false);
				}, this.time);
			}
		},
		value: function value(val) {
			this.show = val;
		}
	}
});

/***/ }),

/***/ "Bf5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'footers',
	props: ['vipState']
});

/***/ }),

/***/ "BmO1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bt0W":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("l5I3"),
  /* template */
  __webpack_require__("TCKV"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "C/Se":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("jPkb")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("VSV6"),
  /* template */
  __webpack_require__("cUUQ"),
  /* scopeId */
  "data-v-4bc165a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "CjJh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cn6v":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pri-qzfx.png";

/***/ }),

/***/ "CrdZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_title_Title__ = __webpack_require__("EUXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_title_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_title_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_header_Header__ = __webpack_require__("YK2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_myPrivileges_MyPrivileges__ = __webpack_require__("rY9p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_myPrivileges_MyPrivileges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_myPrivileges_MyPrivileges__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_jobAnalysis_JobAnalysis__ = __webpack_require__("Fp8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_jobAnalysis_JobAnalysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_jobAnalysis_JobAnalysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_help_Help__ = __webpack_require__("9yWl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_help_Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_help_Help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_footer_Footer__ = __webpack_require__("YrtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dialog_BuyDialog__ = __webpack_require__("Ware");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dialog_BuyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modules_dialog_BuyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dialog_TbtsDialog__ = __webpack_require__("3NyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dialog_TbtsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modules_dialog_TbtsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dialog_AuthDialog__ = __webpack_require__("Bt0W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dialog_AuthDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modules_dialog_AuthDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dialog_ExpriDialog__ = __webpack_require__("UqnG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dialog_ExpriDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modules_dialog_ExpriDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dialog_HyxyDialog__ = __webpack_require__("Rj2D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dialog_HyxyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modules_dialog_HyxyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__js_util_cookies_js__ = __webpack_require__("Kr0m");















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'vipExpir',
	components: {
		Titles: __WEBPACK_IMPORTED_MODULE_0__modules_title_Title___default.a,
		Headers: __WEBPACK_IMPORTED_MODULE_1__modules_header_Header___default.a,
		MyPrivileges: __WEBPACK_IMPORTED_MODULE_2__modules_myPrivileges_MyPrivileges___default.a,

		JobAnalysis: __WEBPACK_IMPORTED_MODULE_3__modules_jobAnalysis_JobAnalysis___default.a,
		Help: __WEBPACK_IMPORTED_MODULE_4__modules_help_Help___default.a,
		Footers: __WEBPACK_IMPORTED_MODULE_5__modules_footer_Footer___default.a,
		BuyDialog: __WEBPACK_IMPORTED_MODULE_6__modules_dialog_BuyDialog___default.a,
		TbtsDialog: __WEBPACK_IMPORTED_MODULE_7__modules_dialog_TbtsDialog___default.a,
		AuthDialog: __WEBPACK_IMPORTED_MODULE_8__modules_dialog_AuthDialog___default.a,
		ExpriDialog: __WEBPACK_IMPORTED_MODULE_9__modules_dialog_ExpriDialog___default.a,
		HyxyDialog: __WEBPACK_IMPORTED_MODULE_10__modules_dialog_HyxyDialog___default.a
	},
	data: function data() {
		return {
			show: false,
			showTbts: false,
			showHyxy: false,
			showAuth: false,
			cardChoose: 58,
			showExpri: ''
		};
	},

	props: ['vipState', 'cardState'],
	created: function created() {
		this.showExprifn();
	},

	methods: {
		closeDialog: function closeDialog() {
			this.show = false;
			this.showTbts = false;
			this.showAuth = false;
			this.showExpri = false;
			this.showHyxy = false;
		},
		showDialog: function showDialog() {
			var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 58;

			this.closeDialog();
			this.cardChoose = type;
			this.show = true;
		},
		showCompensateDialog: function showCompensateDialog() {
			this.closeDialog();
			this.showTbts = true;
		},
		showAuthDialog: function showAuthDialog() {
			this.closeDialog();
			this.showAuth = true;
		},
		showHyxyDialog: function showHyxyDialog() {
			this.showHyxy = true;
		},
		showExprifn: function showExprifn() {
			var mydate = new Date();

			var timeEnd = new Date(mydate.getFullYear() + '/' + (mydate.getMonth() + 1) + '/' + (mydate.getDate() + 1) + ' 00:00:00').getTime();
			var timecha = "s" + (timeEnd - mydate.getTime()) / 1000;
			if (__WEBPACK_IMPORTED_MODULE_11__js_util_cookies_js__["a" /* default */].get('num')) {
				this.showExpri = false;
			} else {
				this.showExpri = true;
				__WEBPACK_IMPORTED_MODULE_11__js_util_cookies_js__["a" /* default */].setCookie('num', 1, timecha);
			}
		}
	}
});

/***/ }),

/***/ "DWx1":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _c('div', [(!_vm.loginIs) ? _c('vip-login', {
    attrs: {
      "pageZoom": _vm.pageZoom
    }
  }) : (_vm.loginIs && _vm.vipState === 0 && _vm.cvipMes) ? _c('vip-no', {
    attrs: {
      "pageZoom": _vm.pageZoom,
      "card-state": _vm.cardState,
      "vipState": _vm.vipState
    }
  }) : (_vm.loginIs && (_vm.vipState === 1 || _vm.vipState === 10) && _vm.cvipMes) ? _c('vip', {
    attrs: {
      "vipState": _vm.vipState,
      "card-state": _vm.cardState
    }
  }) : (_vm.loginIs && _vm.vipState === 2 && _vm.cvipMes) ? _c('vip-expir', {
    attrs: {
      "vipState": _vm.vipState
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "spinner-container container1"
  }, [_c('div', {
    staticClass: "circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle3"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-container container2"
  }, [_c('div', {
    staticClass: "circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle3"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-container container3"
  }, [_c('div', {
    staticClass: "circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle3"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle4"
  })])])
}]}

/***/ }),

/***/ "DeHL":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("kjz7")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("KvRr"),
  /* template */
  __webpack_require__("TLc1"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "DrUF":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help"
  }, [_c('p', {
    staticClass: "help-con"
  }, [_vm._v("©️58帮助中心")])])
}]}

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_CVIP_MES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_CVIP_FROM; });
var CHANGE_CVIP_MES = 'CHANGE_CVIP_MES';
var CHANGE_CVIP_FROM = 'CHANGE_CVIP_FROM';

/***/ }),

/***/ "E+Eo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E/n+":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qzfx-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("成为会员后，我们会将关键求职数据以图表形式呈现给您。同时，我们会针对每日的求职效果给出效果打分和建议，帮助您以最快最省事的方式达到想要的效果。")])]), _vm._v(" "), _c('div', {
    staticClass: "qzfx-bg"
  }, [_c('img', {
    staticClass: "qzfx-bg-img",
    attrs: {
      "src": __webpack_require__("Cn6v")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("求职分析")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：成为会员后，我们会将关键求职数据以图表形式呈现给您。同时，我们会针对每日的求职效果给出效果打分和建议，帮助您以最快最省事的方式达到想要的效果。")])]), _vm._v(" "), _c('div', {
    staticClass: "qzfx-bg"
  }, [_c('img', {
    staticClass: "qzfx-bg-img",
    attrs: {
      "src": __webpack_require__("Cn6v")
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "E4J+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "EUXP":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("gAnO")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("TdR/"),
  /* template */
  __webpack_require__("pPzb"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "EZFi":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zskf-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "des"
  }, [_vm._v("尊贵的会员：\n      "), _c('div', {
    staticClass: "des-inline"
  }, [_c('p', {
    staticClass: "des-in"
  }, [_vm._v("遇到问题怎么办？")]), _vm._v(" "), _c('p', {
    staticClass: "des-in"
  }, [_vm._v("新功能不理解？不会用？")]), _vm._v(" "), _c('p', {
    staticClass: "des-light"
  }, [_vm._v("开通会员即刻享受58专属客服，保证24小时内解答您的疑问？")])])]), _vm._v(" "), _c('div', {
    staticClass: "zskf-bg"
  }, [_c('img', {
    staticClass: "zskf-bg-img",
    attrs: {
      "src": __webpack_require__("Xngv")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "des"
  }, [_vm._v("尊贵的会员：\n      "), _c('div', {
    staticClass: "des-inline"
  }, [_c('p', {
    staticClass: "des-in"
  }, [_vm._v("网页版暂不支持问题反馈，如有问题请前往手机客户端进行反馈。")]), _vm._v(" "), _c('p', {
    staticClass: "des-light"
  }, [_vm._v("反馈路径：58APP-我的-我的求职-会员中心-专属客服-填写反馈")])])]), _vm._v(" "), _c('div', {
    staticClass: "downloadQRcode"
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "EpZs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "F97/":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expir-dialog-wrap"
  }, [_c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt,
      "widthnew": "450px",
      "heightnew": "520px"
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "expir-bg"
  }, [_c('img', {
    staticClass: "expir-bg-img",
    attrs: {
      "src": __webpack_require__("vAXI")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "expri-tit"
  }, [_vm._v("尊贵的会员")]), _vm._v(" "), _c('p', {
    staticClass: "expri-tit"
  }, [_vm._v("您的会员卡已失效" + _vm._s(_vm.cvipMes.outdates) + "天")]), _vm._v(" "), _c('p', {
    staticClass: "expri-des"
  }, [_vm._v("该功能需要续费后才可使用哦")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "FJcN":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("4aM2")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("rVy6"),
  /* template */
  __webpack_require__("iuUc"),
  /* scopeId */
  "data-v-76931d61",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "FbRI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fp8r":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("ai0D")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("NulO"),
  /* template */
  __webpack_require__("9ifX"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "FsC6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABqCAYAAABUIcSXAAAAAXNSR0IArs4c6QAABWBJREFUeAHtnN1uG0UUx8/ueh3biZ2QukmI2yoNJBVqkVD6GBBuuCovADdw06fh45pKlSoh2qfgAnEV2kArgkNIXZqU2Nhrr+1lp9UmJrXXs653fWb8H8myvXO8u/P7ec7sjD+IUEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABNQgYCR9mic/f73pdt1t0+vmkz522PFmi5eP7CvWt4axXQ+Lm1SdmfSBOUoSDOx0drFdNm47T+5eS5qJzPESF8WtJ/VCStm2Zc/kb7Wf3Pu4dzuHx4mL4tDosHMwTZOs7NxWa+/7Lz3vfi4sNsk6iBpAm1sqhKgBosRmTqkQokJEiSouqRCihogKqiedCmObRzm7dz70iL4izysFjeVwb8+vHTmVnW9ct+H0nk9hZd3vPaneTX0fd7td8pr1n1Lrn/zQNyCmjbGJauze2ecmSTDMLH9AXsdpO89/u9usPv014JpbWKV0bi54OvTebTUSnSDHl/qY9aRe8oaVSWWXrt/KXdzYDrbXaxUSvUW2JJ0K4xMl2+KJxRlGunBlK1+6+YVtZzPUbtPJ379Tq17zhbWlziq4KnQSmCAPT8pSp6xukJVZWMyVtm4HqbD+4mCUxmz5L4p1zJriHnXmo18qPKvl8QiiTj2cS4Wn23k8gKhzHoJUOJNf3jhXNdGnUyfKk7hQ4JgKp05Ut1WV7Bm8UuHUiXJrB/48XO7yWxjlkgqnThR1XGo+f0Qd55hk0qCQdZYKNz8SzydRpnMe5cty/9mLylsst930bw+ivnAc8dPXo8ZBbQL7gKgJQB/lkBA1CrUJvEbpMap6dEiVg9NPKobim5sv0vLl94bGcQxQtkc1G1V69tdjaaaWZVNx9V3peG6BSorqdNp0WP7Fnw/Jf35UXH2HhCxVi4KiPKrsP6R2qynNXKS8ufmL0vEcA5UTdVz5g+rVY2mWqqe8oKFKiRKCjnxRUYrqKS9oqzKiRKoTKS9K0SHlBe1VQpS4aDgs75C4iJAtuqS8oL1KiHp28JiajVpwzlL3uqS8oLHsRVWPD0ncohSdUl7QbtaiRC8SvSlK0S3lBW1nK+rVpHYn0qRWNEq3lBeIYrrWF31SGzToafkhiVtYubBylRaKl8JC2NWxFBV1UhuF6lJpg/JvrUR5CYtYdqJeTWrLY4djGObLlfPZwuLY953EDlmJOpvU+j/YGWMxTYtW1q5TNjc/xr0muys2okaZ1MqgSqXS9PbaDUpnZmXC2cawETXKpHYY1ZSdodLV9ymVzgwLZV/PRpQY5MWtXxEpcW/3x35VA7eJHiR6kuhROhQ2osJgNuovwqpfq8vmCv6YdMP/qaf1Wp2qG5QQ5dTkRYmrOvG9CHGVp1NRQlTj3xMp5vmFZVq6tCkVq1oQe1FifHLd//2AvS9jsdIgVhx0LexFyYxPKi4JRX1DsRc1bHxSdUlIO1GDxifVl4S0EjVofNJhSUgrUf3GJ12WhLQSdX58erkktO6vNtjZqO1UPp71xUTv+KTbklDUdw5bUb3jk/h4QnxModOSkDaigvFJ1yUhbUSJ8UnnJSFtRM1k81S4sBq1PdrGs11iVkqSYcitGr/B24itqDdoU6Iv7Rpm1TLTsf+lQXx/Vfrou/F+QyVR/IMPlr32aWzMBh/V/7fosErU8SEAUXxchJ4JRIXi4VMJUXxchJ4JRIXi4VMZnyjD+JNPM8d0Jgbtj2lPkXcTmyj/GvYz/ztb+sjy22KQ8XlkwngBCIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACIDAyAT+A2jHfbiQJNIoAAAAAElFTkSuQmCC"

/***/ }),

/***/ "FzMj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G0mj":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cvip-alert-wrap"
  }, [_c('div', {
    staticClass: "cvip-alert",
    style: ({
      width: _vm.widthnew,
      height: _vm.heightnew,
      margin: _vm.marginnew
    })
  }, [_c('div', {
    staticClass: "alert-hd"
  }, [(_vm.title) ? _c('span', {
    staticClass: "alert-title"
  }, [_vm._v(_vm._s(_vm.title || ''))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "close-btn",
    on: {
      "click": _vm.onHide
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "alert-bd"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.buttonTxt) ? _c('div', {
    staticClass: "alert-ft"
  }, [(_vm.cancelBtnTxt) ? _c('span', {
    staticClass: "alert-btn cancel-btn",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelBtnTxt))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "alert-btn",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.buttonTxt || ''))])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ "GY3a":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("FzMj")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("LZ26"),
  /* template */
  __webpack_require__("9ic9"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Gzcb":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("+Dpm")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("SV+2"),
  /* template */
  __webpack_require__("7xeD"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "IFq7":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'page1': _vm.vipState === 0 || _vm.vipState === 'loginNo'
    }
  }, [_c('div', {
    staticClass: "headers",
    class: {
      'newV-header': _vm.vipState === 0 || _vm.vipState === 'loginNo'
    }
  }, [_c('div', {
    staticClass: "headers-con",
    class: {
      'newV-header-con': _vm.vipState === 0 || _vm.vipState === 'loginNo'
    }
  }, [(_vm.vipState === 0 || _vm.vipState === 'loginNo') ? _c('div', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "header-tip"
  }, [_vm._v("大数据显示")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "header-des"
  }, [_vm._v("增强简历曝光、快速获得企业反馈、没有效果可获得6倍赔偿等N项特权")]), _vm._v(" "), _c('div', {
    staticClass: "header-card"
  }, [_c('span', {
    staticClass: "header-card-tip"
  }, [_vm._v("尚未开通")]), _vm._v(" "), _c('div', {
    staticClass: "header-buyBtn",
    on: {
      "click": function($event) {
        return _vm.showDialog('pc-cvip-kapian-kthy-fhy')
      }
    }
  }, [_c('p', {
    staticClass: "buyBtn-text"
  }, [_vm._v("开通会员尊享特权")])])]), _vm._v(" "), _c('p', {
    staticClass: "header-vipProtocol"
  }, [_vm._v("\n\t\t\t\t\t查看"), _c('span', {
    staticClass: "headers-agreement",
    on: {
      "click": _vm.showHyxy
    }
  }, [_vm._v("《"), _c('i', [_vm._v("会员服务协议")]), _vm._v("》")])])]) : _vm._e(), _vm._v(" "), (_vm.vipState === 1 || _vm.vipState === 10) ? _c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "fl header-vipCard"
  }, [_c('img', {
    attrs: {
      "src": _vm.cardState === 20 ? __webpack_require__("71+3") : __webpack_require__("cK7G")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-cardtype"
  }, [_vm._v(_vm._s(_vm._f("cardType")(_vm.cardState)))]), _vm._v(" "), _c('span', {
    staticClass: "header-vipUser"
  }, [_vm._v(_vm._s(_vm.cvipMes.nickname))])]), _vm._v(" "), _c('li', {
    staticClass: "fr header-mes"
  }, [_c('p', {
    staticClass: "headers-tit"
  }, [_vm._v("开启应聘快车道")]), _vm._v(" "), _c('p', {
    staticClass: "headers-tit"
  }, [_vm._v("与众不同立即开始")]), _vm._v(" "), _c('div', {
    staticClass: "headers-btn-wrap",
    on: {
      "click": function($event) {
        return _vm.showDialog('pc-cvip-kapian-ljxf-hy')
      }
    }
  }, [_c('span', {
    staticClass: "headers-buyBtn"
  }, [_vm._v(_vm._s(_vm.renew ? '立即续费' : '立即开通'))])]), _vm._v(" "), _c('p', {
    staticClass: "headers-expri"
  }, [_c('span', [_vm._v("会员卡有效期：" + _vm._s(_vm.cvipMes.expireDate) + "前有效")]), _vm._v(" "), _c('span', {
    staticClass: "headers-agreement",
    on: {
      "click": _vm.showHyxy
    }
  }, [_vm._v("《"), _c('i', [_vm._v("会员协议")]), _vm._v("》")])])])]) : _vm._e(), _vm._v(" "), (_vm.vipState === 2) ? _c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "fl header-vipCard"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("2XsK")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-vipUser header-vipUserExpri"
  }, [_vm._v(_vm._s(_vm.cvipMes.nickname))])]), _vm._v(" "), _c('li', {
    staticClass: "fr header-mes"
  }, [_c('p', {
    staticClass: "headers-tit"
  }, [_vm._v("开启应聘快车道")]), _vm._v(" "), _c('p', {
    staticClass: "headers-tit"
  }, [_vm._v("与众不同立即开始")]), _vm._v(" "), _c('div', {
    staticClass: "headers-btn-wrap",
    on: {
      "click": function($event) {
        return _vm.showDialog('pc-cvip-kapian-ljxf-gqhy')
      }
    }
  }, [_c('span', {
    staticClass: "headers-buyBtn"
  }, [_vm._v(_vm._s(_vm.renew ? '立即续费' : '立即开通'))])]), _vm._v(" "), _c('p', {
    staticClass: "headers-expri"
  }, [_c('span', [_vm._v("您的会员卡已失效" + _vm._s(_vm.cvipMes.outdates) + "天"), (_vm.renew) ? _c('span', [_vm._v("，现在续费立减10元")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "headers-agreement",
    on: {
      "click": _vm.showHyxy
    }
  }, [_vm._v("《"), _c('i', [_vm._v("会员协议")]), _vm._v("》")])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "header-title"
  }, [_vm._v("“ VIP金卡用户求职成功速度快"), _c('span', {
    staticClass: "header-day"
  }, [_vm._v("3倍")]), _vm._v(" ”")])
}]}

/***/ }),

/***/ "IR0T":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip-chart clearfix"
  }, [_c('div', {
    staticClass: "vip-chartsResume fl"
  }, [_c('div', {
    staticClass: "vip-chartsResumeSee"
  }, [_c('p', {
    staticClass: "vip-chartsResumeSeeTit"
  }, [_vm._v("简历被查看次数（昨日:" + _vm._s(_vm.analysis.yesterdayBrowseCount) + "）")]), _vm._v(" "), _c('p', {
    staticClass: "vip-chartsResumeSeeP"
  }, [_vm._v(_vm._s(_vm.analysis.browseCountAdvice))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "vip-chartsCompany fr"
  }, [_c('div', {
    staticClass: "vip-chartsCompanySee"
  }, [_c('p', {
    staticClass: "vip-chartsCompanySeeTit"
  }, [_vm._v("对您感兴趣的企业（昨日:" + _vm._s(_vm.analysis.yesterdayDownloadCount) + "）")]), _vm._v(" "), _c('p', {
    staticClass: "vip-chartsCompanySeeP"
  }, [_vm._v(_vm._s(_vm.analysis.downloadCountAdvice))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip-charts"
  }, [_c('div', {
    attrs: {
      "id": "chartResume"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip-chartsResumeNote"
  }, [_c('div', {
    staticClass: "vip-chartsResumeNoteIn"
  }, [_c('span', {
    staticClass: "vip-chartsResumeNoteMe"
  }, [_vm._v("我")]), _vm._v(" "), _c('span', {
    staticClass: "vip-chartsResumeNoteLocal"
  }, [_vm._v("行业平均")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip-charts"
  }, [_c('div', {
    attrs: {
      "id": "chartCompany"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip-chartsCompanyNote"
  }, [_c('div', {
    staticClass: "vip-chartsCompanyNoteIn"
  }, [_c('span', {
    staticClass: "vip-chartsCompanyNoteMe"
  }, [_vm._v("我")]), _vm._v(" "), _c('span', {
    staticClass: "vip-chartsCompanyNoteLocal"
  }, [_vm._v("行业平均")])])])
}]}

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_common_js__ = __webpack_require__("fAsG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_index_js__ = __webpack_require__("2mV7");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
	modules: {
		common: __WEBPACK_IMPORTED_MODULE_2__modules_common_js__["a" /* default */],
		index: __WEBPACK_IMPORTED_MODULE_3__modules_index_js__["a" /* default */]
	}
}));

/***/ }),

/***/ "IoQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return query; });
/* unused harmony export queryAll */

var loc = window.location;

var search = loc.search;

var reQueryAll = /([^=&?]+)=([^=&?]*)/g;

var query = function query(name) {
    var reQuery, matches, cache;
    if (!search) {
        return null;
    }
    reQuery = new RegExp(name + '=([^=&?]*)', 'g');
    cache = [];
    while (matches = reQuery.exec(search)) {
        cache.push(decodeURIComponent(matches[1]));
    }
    if (cache.length) {
        return cache.length === 1 ? cache[0] : cache;
    }
    return null;
};

var queryAll = function queryAll() {
    var matches, key, value;
    var params = {};

    if (!search) {
        return null;
    }

    while (matches = reQueryAll.exec(search)) {
        key = matches[1];
        value = decodeURIComponent(matches[2]);

        if (!params[key]) {
            params[key] = value;
        } else {
                if (!Array.isArray(params[key])) {
                    params[key] = [params[key], value];
                } else {
                        params[key].push(value);
                    }
            }
    }
    return params;
};


/***/ }),

/***/ "JJUd":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cvip-dialog-wrap",
    on: {
      "mousewheel": _vm.stopMouseWheel
    }
  }, [_c('div', {
    staticClass: "cvip-dialog",
    style: ({
      width: _vm.widthnew,
      height: _vm.heightnew
    })
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showBtn === true) ? _c('div', {
    staticClass: "dialog-btm"
  }, [_c('div', {
    staticClass: "btn-wrap",
    on: {
      "click": function($event) {
        return _vm.btnClick();
      }
    }
  }, [_c('p', {
    staticClass: "btn",
    class: {
      'disabled': _vm.disabled, oldVerVip: _vm.oldVerVip
    },
    domProps: {
      "textContent": _vm._s(_vm.disabled ? '不能' + _vm.btnTxt : _vm.btnTxt)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ "Jf1+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pri-hjld.png";

/***/ }),

/***/ "K81n":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "title-header"
  }, [_vm._v("尊敬的会员：")]), _vm._v(" "), _c('p', {
    staticClass: "tipinfo"
  }, [_vm._v(_vm._s(_vm.tipinfo) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "applycourse"
  }, [_vm._v("申请路径:" + _vm._s(_vm.applycourse))]), _vm._v(" "), _c('p', {
    staticClass: "downapp"
  }, [_vm._v("app下载二维码")]), _vm._v(" "), _c('div', {
    staticClass: "downloadQRcode"
  })])
},staticRenderFns: []}

/***/ }),

/***/ "KDpj":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("+OEc")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Pc/A"),
  /* template */
  __webpack_require__("OHt5"),
  /* scopeId */
  "data-v-7ee8e960",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "KLmi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kr0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cookie = {
    setCookie: function setCookie(name, value, time) {
        var strsec = cookie.getsec(time);
        var exp = new Date();
        exp.setTime(exp.getTime() + strsec * 1);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    },
    set: function set(name, value) {
        var Days = 30;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    },
    get: function get(name) {
        var arr,
            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
    },
    delCookie: function delCookie(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.get(name);
        if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },
    getsec: function getsec(str) {
        var str1 = str.substring(1, str.length) * 1;
        var str2 = str.substring(0, 1);
        if (str2 == "s") {
            return str1 * 1000;
        } else if (str2 == "h") {
            return str1 * 60 * 60 * 1000;
        } else if (str2 == "d") {
            return str1 * 24 * 60 * 60 * 1000;
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (cookie);

/***/ }),

/***/ "KvRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_data_js__ = __webpack_require__("cK/P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_numscroll_NumScroll_vue__ = __webpack_require__("GY3a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_numscroll_NumScroll_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_numscroll_NumScroll_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_index_js__ = __webpack_require__("gyMJ");








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            show: true,
            number: 923451,
            numArr: [],
            activeIndex: 0,
            privileges: '',
            hoverIndex: 0,
            cardData: __WEBPACK_IMPORTED_MODULE_0__data_data_js__["a" /* cardData */]
        };
    },

    components: {
        NumScroll: __WEBPACK_IMPORTED_MODULE_1__components_numscroll_NumScroll_vue___default.a
    },
    mounted: function mounted() {
        this.getVipPerson();
        this.initMealInfo();
    },

    methods: {
        buyVip: function buyVip(actionType, cardType) {
            this.$emit('showDialog', cardType);
            window.clickLog && window.clickLog('from=' + actionType + '-new');
        },
        getVipBroadcastfn: function getVipBroadcastfn() {
            var _this = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["n" /* getVipBroadcast */])().then(function (result) {
                if (result.isSuccess) {
                    _this.number = result.entity.num;
                } else {
                    console.log(result.returnMessage);
                }
            }).catch(function (err) {
                console.log('网络异常');
            });
        },
        getVipPerson: function getVipPerson() {
            setInterval(this.getVipBroadcastfn, 5000);
        },
        initMealInfo: function initMealInfo() {
            var _this2 = this;

            if (this.mealInfo) {
                var paySet = this.mealInfo.payset;
                paySet.forEach(function (mealItem, index) {
                    _this2.cardData[index].cardTitle = mealItem.versionName;
                    _this2.cardData[index].cardPrice = mealItem.benefitsPrice;
                    _this2.cardData[index].type = mealItem.vid;
                    _this2.cardData[index].cardType = mealItem.vid;
                    _this2.cardData[index].originPrice = mealItem.oldPrice;
                    _this2.cardData[index].cardDiscounts = mealItem.desc;
                });
            }
        },
        handleMouseEnter: function handleMouseEnter(index) {
            this.hoverIndex = index;
        },
        handleMouseLeave: function handleMouseLeave(index) {
            this.hoverIndex = index;
        }
    },
    watch: {
        mealInfo: function mealInfo() {
            this.initMealInfo();
        }
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
        mealInfo: 'mealInfo' })
});

/***/ }),

/***/ "LZ26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        number: {
            type: Number,
            default: 923451
        }
    },
    data: function data() {
        return {
            num: 239092,
            numArr: [],
            numberData: [{
                class: 'hunTh' }, {
                class: 'lakh' }, {
                class: 'tenTh' }, {
                class: 'thousand' }, {
                class: 'hundred' }, {
                class: 'decade' }, {
                class: 'util' }]
        };
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        getNumArr: function getNumArr(num) {
            return num.toString().split('').map(function (item) {
                return parseInt(item);
            });
        },
        arrEquals: function arrEquals(newArr, oldArr) {
            var changeIndex = [];
            for (var i = 0; i <= newArr.length; i++) {
                if (newArr[i] != oldArr[i]) {
                    changeIndex.push(i);
                }
            }
            return changeIndex;
        },
        init: function init() {
            this.numArr = this.getNumArr(this.number);
            document.getElementById('number-box').style.width = this.numArr.length * 32 + 'px';
        }
    },
    watch: {
        number: function number(newVal, oldVal) {
            newVal = this.getNumArr(newVal);
            oldVal = this.getNumArr(oldVal);
            var changeIndex = this.arrEquals(newVal, oldVal);
            var top;

            var numbers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('.number')).reverse();

            document.getElementById('number-box').style.width = this.numArr.length * 32 + 'px';

            for (var i = 0; i < changeIndex.length; i++) {
                numbers[changeIndex[i]].style.top = newVal[changeIndex[i]] * -50 + 'px';
            }
        }
    }

});

/***/ }),

/***/ "M93x":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("FbRI")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xJD8"),
  /* template */
  __webpack_require__("8Oyi"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "MjTV":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "toast"
  }, [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}

/***/ }),

/***/ "N993":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_title_Title__ = __webpack_require__("EUXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_title_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_title_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_header_Header__ = __webpack_require__("YK2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_myPrivileges_MyPrivileges__ = __webpack_require__("rY9p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_myPrivileges_MyPrivileges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_myPrivileges_MyPrivileges__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_jobAnalysis_JobAnalysis__ = __webpack_require__("Fp8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_jobAnalysis_JobAnalysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_jobAnalysis_JobAnalysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_help_Help__ = __webpack_require__("9yWl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_help_Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_help_Help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_footer_Footer__ = __webpack_require__("YrtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dialog_BuyDialog__ = __webpack_require__("Ware");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dialog_BuyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modules_dialog_BuyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dialog_TbtsDialog__ = __webpack_require__("3NyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dialog_TbtsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modules_dialog_TbtsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dialog_AuthDialog__ = __webpack_require__("Bt0W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dialog_AuthDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modules_dialog_AuthDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dialog_HyxyDialog__ = __webpack_require__("Rj2D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dialog_HyxyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modules_dialog_HyxyDialog__);













/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'vip',
	components: {
		Titles: __WEBPACK_IMPORTED_MODULE_0__modules_title_Title___default.a,
		Headers: __WEBPACK_IMPORTED_MODULE_1__modules_header_Header___default.a,
		MyPrivileges: __WEBPACK_IMPORTED_MODULE_2__modules_myPrivileges_MyPrivileges___default.a,

		JobAnalysis: __WEBPACK_IMPORTED_MODULE_3__modules_jobAnalysis_JobAnalysis___default.a,
		Help: __WEBPACK_IMPORTED_MODULE_4__modules_help_Help___default.a,
		Footers: __WEBPACK_IMPORTED_MODULE_5__modules_footer_Footer___default.a,
		BuyDialog: __WEBPACK_IMPORTED_MODULE_6__modules_dialog_BuyDialog___default.a,
		TbtsDialog: __WEBPACK_IMPORTED_MODULE_7__modules_dialog_TbtsDialog___default.a,
		AuthDialog: __WEBPACK_IMPORTED_MODULE_8__modules_dialog_AuthDialog___default.a,
		HyxyDialog: __WEBPACK_IMPORTED_MODULE_9__modules_dialog_HyxyDialog___default.a
	},
	data: function data() {
		return {
			show: false,
			showHyxy: false,
			showTbts: false,
			showAuth: false,
			cardChoose: 58
		};
	},

	props: ['vipState', 'cardState'],
	created: function created() {},

	methods: {
		closeDialog: function closeDialog() {
			this.show = false;
			this.showHyxy = false;
			this.showTbts = false;
			this.showAuth = false;
		},
		showCompensateDialog: function showCompensateDialog() {
			this.closeDialog();
			this.showTbts = true;
		},
		showAuthDialog: function showAuthDialog() {
			this.closeDialog();
			this.showAuth = true;
		},
		showDialog: function showDialog() {
			var cardType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 58;

			this.show = true;
			this.cardChoose = cardType;
		},
		showHyxyDialog: function showHyxyDialog() {
			this.showHyxy = true;
		}
	}
});

/***/ }),

/***/ "NFxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'CvipDialog',
	props: {
		title: {
			type: String,
			default: function _default() {
				return "提示信息";
			}
		},
		btnTxt: {
			type: String,
			default: function _default() {
				return "确认";
			}
		},
		disabled: {
			type: Boolean,
			default: function _default() {
				return false;
			}
		},
		widthnew: {},
		heightnew: {},
		stopPrevent: {
			type: Boolean,
			default: true
		}
	},
	data: function data() {
		return {
			showBtn: true,
			oldVerVip: false,
			noboxshadow: false
		};
	},
	created: function created() {
		if (this.btnTxt == "") {
			this.showBtn = false;
		}
		if (this.btnTxt == '仅新版会员可享受' || this.btnTxt == '已申请赔付' || this.btnTxt == '已投保') {
			this.oldVerVip = true;
		}
	},

	methods: {
		close: function close() {
			this.$emit("close");
		},
		btnClick: function btnClick() {
			if (this.disabled) return;
			if (this.oldVerVip) return;
			if (this.btnTxt === '知道了') {
				document.getElementsByTagName('body')[0].style.overflow = 'auto';
				this.$emit("close");
				return;
			}
			this.btnTxt === '申请赔付' || this.btnTxt === '立即投保' ? this.$emit('applyCompensate') : this.$emit("btnClick");
		},
		stopMouseWheel: function stopMouseWheel(e) {
			if (this.stopPrevent) {
				e.preventDefault();
				e.stopPropagation();
			}
		}
	}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__58fe_ems_plugins_lib_vue__ = __webpack_require__("wHuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__58fe_ems_plugins_lib_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__58fe_ems_plugins_lib_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_fullpage_js__ = __webpack_require__("9yT1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_fullpage_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_fullpage_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_fullpage_js_dist_vue_fullpage_min_js__ = __webpack_require__("AzNg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_fullpage_js_dist_vue_fullpage_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_fullpage_js_dist_vue_fullpage_min_js__);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_fullpage_js___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__58fe_ems_plugins_lib_vue___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
	router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
	template: '<App/>',
	components: {
		App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
	}
});

/***/ }),

/***/ "NhgF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'jlzdDialog',
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
  },
  data: function data() {
    return {
      title: '简历置顶',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: ''
    };
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-jlzd-tanchuang-show-' + this.cvipMes.cvipstate);
  },

  methods: {
    vipBuy: function vipBuy() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-jlzd-ljkt-' + this.cvipMes.cvipstate);
      this.$emit('buyDialog');
    },
    close: function close() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-jlzd-close-' + this.cvipMes.cvipstate);
      this.$emit('closeDialog');
    },
    topResumefn: function topResumefn() {
      this.$emit('topResume');
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed',
    resumeListNum: 'resumeListNum'
  })
});

/***/ }),

/***/ "Nqoy":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myPrivileges"
  }, [_c('div', {
    staticClass: "myPrivileges-out"
  }, [_c('p', {
    staticClass: "myPrivileges-tit"
  }, [_vm._v("我的特权")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-des"
  }, [_vm._v("加快求职速度，快人一步")]), _vm._v(" "), _c('div', {
    staticClass: "privileges-category"
  }, [_vm._l((_vm.privilegesCategorys), function(category, index) {
    return _c('span', {
      class: {
        'now-privilege': index === _vm.nowIndex
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goto(index)
        }
      }
    }, [_vm._v(_vm._s(category))])
  }), _vm._v(" "), (_vm.cardState === 20) ? _c('span', {
    class: {
      'now-privilege': _vm.nowIndex === 2
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goto(2)
      }
    }
  }, [_c('i', {
    staticClass: "icon-upgrade"
  }), _vm._v(" 专属客服")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "index-wrap"
  }, [_c('div', {
    staticClass: "slide-show",
    on: {
      "mouseover": _vm.clearInv
    }
  }, [_c('div', {
    staticClass: "slide-img"
  }, [_c('transition', {
    attrs: {
      "name": "slide-trans"
    }
  }, [(_vm.isShow) ? _c('div', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nowIndex === 0),
      expression: "nowIndex===0"
    }],
    key: "0",
    staticClass: "myPrivileges-in clearfix",
    class: {
      'upgrade-privileges': _vm.cardState === 20
    }
  }, [_c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show('ypyx')
      }
    }
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("j1Cc")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("应聘优先")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("投递简历优先展示")]), _vm._v(" "), (_vm.vipState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("立即使用")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.topResume($event)
      }
    }
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("/xXl")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("简历置顶")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("可使用" + _vm._s(_vm.leftTop) + "天")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v(_vm._s(_vm.resumeListNum ? '立即置顶' : '创建简历'))])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show('tdtq')
      }
    }
  }, [_c('dl', [_c('dt', [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("pd5+")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("投递特权")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("可投递25次")]), _vm._v(" "), (_vm.vipState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("立即使用")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        return _vm.show('wxsx')
      }
    }
  }, [_c('dl', [_c('dt', [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("RCEy")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("免费刷新")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("任性刷刷刷")]), _vm._v(" "), (_vm.vipState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("立即使用")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), (_vm.cardState === 20) ? _c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("RCEy")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("直通服务")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("直接面试直通名企")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nowIndex === 1),
      expression: "nowIndex===1"
    }],
    key: "1",
    staticClass: "myPrivileges-in clearfix"
  }, [_c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show('qzbz')
      }
    }
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("nAjm")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("求职保障")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("无面试58包赔")]), _vm._v(" "), (_vm.vipState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("立即使用")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show('ccaq')
      }
    }
  }, [_c('dl', [_c('dt', [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("ossX")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("财产安全险")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("为您的财产保驾护航")]), _vm._v(" "), (_vm.insuranceState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("申请投保")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])])]), _vm._v(" "), (_vm.cardState === 20) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nowIndex === 2),
      expression: "nowIndex===2"
    }],
    key: "2",
    staticClass: "myPrivileges-in clearfix"
  }, [_c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("UH5s")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("专属客服")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("24小时解疑答惑")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card"
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("9dnQ")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("面试技巧")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("面试技巧相关培训")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("4ufM")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("防骗安全提醒")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("规避面试风险")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("9T7f")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("简历服务")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("提供优秀简历模板")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": __webpack_require__("j1Cc")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("用户关怀")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("贴心定制化服务")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])])]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _c('ul', {
    staticClass: "slide-pages myPrivileges-slide-bar"
  }, _vm._l((_vm.slides), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goto(index)
        }
      }
    }, [_c('span', {
      key: index,
      staticClass: "bar-com",
      class: {
        'bar-active': index === _vm.nowIndex
      }
    })])
  }), 0)])])]), _vm._v(" "), (_vm.showTop) ? _c('resume-top-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "topBtnChange": _vm.topBtnChange,
      "show-alert": _vm.showAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showLight) ? _c('gold-light-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "lightBtnChange": _vm.lightBtnChange,
      "show-alert": _vm.showAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZgbs) ? _c('zgbs-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWxsx) ? _c('wxsx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQzfx) ? _c('qzfx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGrrz) ? _c('grrz-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog,
      "authDialog": _vm.showAuthDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showJlzd) ? _c('jlzd-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog,
      "topResume": _vm.topResume
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHjld) ? _c('hjld-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog,
      "hightResume": _vm.hightResume
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTdtq) ? _c('tdtq-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQzbz) ? _c('qzbz-dialog', {
    attrs: {
      "vipState": _vm.vipVersionState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "compensateDialog": _vm.compensateDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCcaq) ? _c('ccaq-dialog', {
    attrs: {
      "vipState": _vm.vipVersionState,
      "insuranceState": _vm.insuranceState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "compensateDialog": _vm.compensateDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showYpyx) ? _c('ypyx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZskf) ? _c('zskf-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSuccess) ? _c('cvip-alert', {
    attrs: {
      "buttonTxt": "我知道了",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-success"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.alertTxt))])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "NulO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialog_ResumeTopDialog_vue__ = __webpack_require__("pUfj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialog_ResumeTopDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dialog_ResumeTopDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dialog_GoldLightDialog_vue__ = __webpack_require__("ZvIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dialog_GoldLightDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dialog_GoldLightDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jobAnalysis_resumeChart_ResumeChart_vue__ = __webpack_require__("+wsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jobAnalysis_resumeChart_ResumeChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jobAnalysis_resumeChart_ResumeChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_alert_Alert__ = __webpack_require__("oOGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_alert_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_alert_Alert__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'jobAnalysis',
	components: {
		ResumeChart: __WEBPACK_IMPORTED_MODULE_4__jobAnalysis_resumeChart_ResumeChart_vue___default.a,
		ResumeTopDialog: __WEBPACK_IMPORTED_MODULE_2__dialog_ResumeTopDialog_vue___default.a,
		GoldLightDialog: __WEBPACK_IMPORTED_MODULE_3__dialog_GoldLightDialog_vue___default.a,
		CvipAlert: __WEBPACK_IMPORTED_MODULE_5__components_alert_Alert___default.a
	},
	props: ['vipState'],
	data: function data() {
		return {
			priUseIndex: 0,
			showTop: false,
			showLight: false,
			alertTxt: '',
			showSuccess: false };
	},
	mounted: function mounted() {},

	methods: {
		showDialog: function showDialog() {
			this.$emit('showDialog');
			window.clickLog && window.clickLog('from=pc-cvip-qiuzhifenxi-ljkt' + this.vipState);
		},
		priShow: function priShow(type) {
			this.priUseIndex = this.priUseIndex ? 0 : 1;
		},
		certification: function certification() {
			window.open("//my.58.com/pro/jianlicert/");
			window.clickLog && window.clickLog('from=pc-cvip-qzfx-grrz-sy-hy');
		},
		hightResume: function hightResume() {
			this.closeDialog();
			if (!this.resumeListNum) {
				window.open("//jianli.58.com/resumepost/view/fulltime/");
				return;
			}
			this.showLight = true;
			window.clickLog && window.clickLog('from=pc-cvip-qzfx-hjbq-sy-hy');
		},
		topResume: function topResume() {
			this.closeDialog();
			if (!this.resumeListNum) {
				window.open("//jianli.58.com/resumepost/view/fulltime/");
				return;
			}
			this.showTop = true;
			window.clickLog && window.clickLog('from=pc-cvip-qzfx-jlzd-sy-hy');
		},
		closeDialog: function closeDialog() {
			this.showTop = false;
			this.showLight = false;
		},
		lightBtnChange: function lightBtnChange() {
			this.$store.commit('RIGHT_USED', {
				'4': true
			});
		},
		topBtnChange: function topBtnChange() {
			this.$store.commit('RIGHT_USED', {
				'5': true
			});
		},
		showAlert: function showAlert(txt) {
			var _this = this;

			this.alertTxt = txt;
			setTimeout(function () {
				_this.showSuccess = true;
			}, 500);
		},
		onHide: function onHide() {
			this.showSuccess = false;
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		cvipMes: 'cvipMes',
		rightUsed: 'rightUsed',
		resumeListNum: 'resumeListNum'
	}), {
		getUsedCount: function getUsedCount() {
			var res = 0;
			for (var i in this.rightUsed) {
				if (+i < 14 && this.rightUsed[i]) {
					res++;
				}
			}
			return res;
		}
	})
});

/***/ }),

/***/ "O5TR":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("yH38")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("iKnY"),
  /* template */
  __webpack_require__("E/n+"),
  /* scopeId */
  "data-v-40be959e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "OHt5":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("心仪职位太多，每天申请次数不够用？非会员每天只有15次全职职位申请机会，会员拥有25次全职职位申请机会，求职效率翻倍提升！")])]), _vm._v(" "), _c('div', {
    staticClass: "tdtq-bg"
  }, [_c('img', {
    staticClass: "tdtq-bg-img",
    attrs: {
      "src": "https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/r9o96ilm__w1068_h1108.png"
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("投递翻倍")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("非会员每天只有15次全职职位申请机会，会员拥有25次全职职位申请机会，求职效率翻倍提升！")])]), _vm._v(" "), _c('div', {
    staticClass: "tdtq-bg"
  }, [_c('img', {
    staticClass: "tdtq-bg-img",
    attrs: {
      "src": "https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/r9o96ilm__w1068_h1108.png"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ "OcmK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_CvipDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_alert_Alert__ = __webpack_require__("oOGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_alert_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_alert_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toast_Toast__ = __webpack_require__("zsV4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toast_Toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toast_Toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_index_js__ = __webpack_require__("gyMJ");






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GoldLightDialog',
  data: function data() {
    return {
      toastShow: false,
      toastText: '网络异常',
      title: '黄金亮点',
      btnTxt: '立即使用',
      resume: '',
      resumeList: [],
      addbaseresumeUrl: '',
      resumeListNum: '',
      lightList: [{
        type: 'tswd',
        desc: '踏实稳定'
      }, {
        type: 'cknl',
        desc: '吃苦耐劳'
      }, {
        type: 'jyff',
        desc: '经验丰富'
      }, {
        type: 'jksg',
        desc: '即刻上岗'
      }],
      resumeChose: '',
      lightChose: '',
      showWarn: false,
      allResumes: [],
      hjbqMap: {} };
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-hjbqsz-tanchuang-show-hy');

    this.getResumeHighlightFn('pc', 4);
  },

  methods: {
    close: function close() {
      this.$emit('closeDialog');
      window.clickLog && window.clickLog('from=pc-cvip-hjbqsz-tanchuang-close');
    },
    choseResume: function choseResume(index) {
      if (index === this.resumeChose) {
        return;
      }
      this.resumeChose = index;
      this.lightChose = this.getHjldMap.filter(function (el) {
        return el.hjbqResumeId === index;
      })[0].hjbqTagId;
    },
    choseLight: function choseLight(type) {
      window.clickLog && window.clickLog('from=pc-cvip-hjbqsz-tanchuang-' + type + '-dj');
      if (type === this.lightChose) {
        return;
      }
      this.lightChose = type;
    },
    getResumeHighlightFn: function getResumeHighlightFn(ft, productid) {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["g" /* getResumeHighlight */])(ft, productid).then(function (result) {
        if (result.isSuccess === true) {
          _this.resume = result;
          _this.resumeList = result.entity.resumes && result.entity.resumes;
          _this.resumeListNum = result.entity.resumes && result.entity.resumes.length;
          _this.addbaseresumeUrl = result.entity.addResumeLink && result.entity.addResumeLink;

          _this.hjbqMap = result.entity.qzbTypeMap || {};
          _this.allResumes = result.entity.resumes.map(function (el) {
            return el.confuseResumeId;
          });
          for (var i = 0; i < _this.getHjldMap.length; i++) {
            if (_this.allResumes.indexOf(_this.getHjldMap[i].hjbqResumeId) !== -1) {
              _this.resumeChose = _this.getHjldMap[i].hjbqResumeId;
              _this.lightChose = _this.getHjldMap[i].hjbqTagId;
              return;
            }
          }
        } else {
          console.log('网络异常');
        }
      }).catch(function (err) {
        console.log('网络异常');
      });
    },
    topBtnClick: function topBtnClick() {
      this.postResumeFn(4, this.resumeChose, this.resume.entity.keyid, '', this.lightChose);
    },
    postResumeFn: function postResumeFn(type, rid, keyid, number, lt) {
      var _this2 = this;

      if (!rid || !lt) {
        this.showWarn = true;
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["k" /* postHighLight */])(type, rid, keyid, number, lt).then(function (result) {
        if (result.isSuccess) {
          _this2.$emit('show-alert', '恭喜您，黄金亮点设置成功！');
          _this2.lightBtn();

          _this2.$emit('closeDialog');
        } else {
          _this2.toastShow = true;
          _this2.toastText = result.returnMessage;
        }
      }).catch(function (err) {
        _this2.toastShow = true;
        _this2.toastText = '网络异常';
      });
    },
    lightBtn: function lightBtn() {
      this.$emit('lightBtnChange');
    },
    onHide: function onHide() {
      this.showWarn = false;
      this.showSuccess = false;
    }
  },
  computed: {
    getHjldMap: function getHjldMap() {
      var hjbqMaps = [];
      for (var item in this.hjbqMap) {
        hjbqMaps.push({
          hjbqResumeId: item,
          hjbqTagId: this.hjbqMap[item]
        });
      }
      return hjbqMaps;
    }
  },
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_0__common_CvipDialog___default.a,
    CvipAlert: __WEBPACK_IMPORTED_MODULE_1__components_alert_Alert___default.a,
    CvipToast: __WEBPACK_IMPORTED_MODULE_2__components_toast_Toast___default.a
  }
});

/***/ }),

/***/ "P0uP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pc/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tdtqDialog',
    components: {
        CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
    },
    data: function data() {
        return {
            title: '投递翻倍',
            btnTxt: '开通会员尊享特权',
            title1: '',
            btnTxt1: '',
            title2: '',
            btnTxt2: '立即体验'
        };
    },
    created: function created() {
        window.clickLog && window.clickLog('from=pc-cvip-tdtq-tanchuang-show-' + this.cvipMes.cvipstate);
    },

    methods: {
        vipBuy: function vipBuy() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-tdtq-ljkt-' + this.cvipMes.cvipstate);
            this.$emit("buyDialog");
        },
        close: function close() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-tdtq-close-' + this.cvipMes.cvipstate);
            this.$emit("closeDialog");
        }
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
        cvipMes: 'cvipMes',
        rightUsed: 'rightUsed' })
});

/***/ }),

/***/ "QEZq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qt2z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hjldDialog',
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
  },
  data: function data() {
    return {
      title: '黄金亮点',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: '',
      btnTxt2: '立即体验'
    };
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-hjld-tanchuang-show-' + this.cvipMes.cvipstate);
  },

  methods: {
    vipBuy: function vipBuy() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-hjld-ljkt-' + this.cvipMes.cvipstate);
      this.$emit('buyDialog');
    },
    close: function close() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-hjld-close-' + this.cvipMes.cvipstate);
      this.$emit('closeDialog');
    },
    hightResumefn: function hightResumefn() {
      this.$emit('hightResume');
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed',
    resumeListNum: 'resumeListNum'
  })
});

/***/ }),

/***/ "RCEy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-wxsx-big.png";

/***/ }),

/***/ "Rj2D":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("2s2x")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/wR2"),
  /* template */
  __webpack_require__("jDRM"),
  /* scopeId */
  "data-v-fe5c6816",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "SEwu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_index_js__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qrcodejs2__ = __webpack_require__("MJLE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qrcodejs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qrcodejs2__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'BuyDialog',
	props: {
		cardChoose: {
			type: Number,
			default: 19
		},
		controlShow: {
			type: Boolean
		}
	},
	data: function data() {
		return {
			title: '开通求职黄金VIP卡',
			btnTxt: '',
			cardData: [{
				type: 22,
				name: '7天体验版',
				price: 18,
				originPrice: 18,
				privilegesText: '简历置顶等多项特权',
				dateUnit: '',
				discount: ''
			}, {
				type: 19,
				name: '30天基础版',
				price: 28,
				originPrice: 72,
				privilegesText: '简历置顶等多项特权',
				recommend: true,
				dateUnit: '',
				discount: '4折'
			}, {
				type: 20,
				name: '30天升级版',
				price: 60,
				originPrice: 216,
				privilegesText: '简历置顶等多项特权',
				dateUnit: '',
				discount: '3折'
			}, {
				type: 20,
				name: '30天升级版',
				price: 60,
				originPrice: 216,
				privilegesText: '简历置顶等多项特权',
				dateUnit: '',
				discount: '3折'
			}],
			priceInfo: {},
			calculateObj: {
				total: '72.00',
				preferntial: '10.00',
				preReeson: '20',
				totalPref: '43',
				finalPrice: 18
			},
			payTypes: [{
				type: 121,
				desc: '微信支付'
			}, {
				type: 33,
				desc: '支付宝支付'
			}, {
				type: 'other',
				desc: '其它支付方式'
			}],
			chooseType: this.cardChoose,
			active: 1,
			qrcode: null,
			expire: false,
			timer: 0,
			expireTime: 1800000,
			orderStateTime: 3000,
			getOrderStateTimer: 1,
			firstTime: 0,
			payChoose: 'other',
			state: '',
			ft: 'pc',
			showPrice: 28 };
	},
	created: function created() {
		this.getPriceFn();

		this.firstTimeRender();

		window.clickLog && window.clickLog('from=pc-cvip-buy-show-new');
	},
	destroyed: function destroyed() {
		window.clearInterval(this.getOrderStateTimer);
	},

	methods: {
		orderState: function orderState(orderId) {
			clearInterval(this.getOrderStateTimer);

			this.getOrderStateTimer = setInterval(function () {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["i" /* getOrderState */])(orderId).then(function (res) {
					if (res.returnMessage === '支付成功') document.location.reload();
				});
			}, this.orderStateTime);
		},
		chooseCard: function chooseCard(index, type) {
			if (index === this.active) return;
			window.clickLog && window.clickLog('from=pc-cvip-buyshow-' + type + '-dj-new');
			this.chooseType = type;

			this.active = index;

			this.showPrice = this.cardData[index].price;
			this.getpaycviporderFn(this.state, this.cardData[this.active].type, 'pc', this.fromSource, 'https://cvip.58.com/view/pc');
		},
		firstTimeRender: function firstTimeRender() {
			this.getQRCode();
		},
		useQRCode: function useQRCode(url) {
			var _this = this;

			this.qrcode = new __WEBPACK_IMPORTED_MODULE_4_qrcodejs2___default.a('payqrcode', {
				text: url,
				width: 120,
				height: 120,
				correctLevel: __WEBPACK_IMPORTED_MODULE_4_qrcodejs2___default.a.CorrectLevel.L
			});

			this.timer = setTimeout(function () {
				_this.expire = true;
			}, this.expireTime);
		},
		refreshCode: function refreshCode() {
			var _this2 = this;

			this.getQRCode();

			this.expire = false;
			this.timer = setTimeout(function () {
				_this2.expire = true;
			}, this.expireTime);
		},
		getQRCode: function getQRCode() {
			this.getpaycviporderFn(this.state, this.cardData[this.active].type, 'pc', this.fromSource, 'https://cvip.58.com/view/pc');
		},
		newQRCode: function newQRCode(url) {
			var _this3 = this;

			this.expire = false;

			clearTimeout(this.timer);
			this.timer = setTimeout(function () {
				_this3.expire = true;
			}, this.expireTime);

			this.qrcode.clear();

			this.qrcode.makeCode(url);
		},
		chosePayWay: function chosePayWay(type) {
			window.clickLog && window.clickLog('from=pc-cvip-buyshow-' + type + '-dj-new');
			if (type === this.payChoose) {
				return;
			}
			this.payChoose = type;
		},
		initCoupon: function initCoupon() {
			var couponData = {
				adSource: 30,
				source: 0,
				CateLevel: 1,
				isdisplayCate: 1,
				cityLevel: 0,
				callBack: this.couponCallback
			};
			this.coupon = new window.Coupon(couponData);
		},
		showArgument: function showArgument() {
			window.clickLog && window.clickLog('from=pc-cvip-chooseCoupon-new');

			window.open('https://helps.58.com/rules/detail?siteId=5502&terminal=PC&contentId=316237&sourceType=58pc-about&spReturn=1');
		},
		calculate: function calculate(type) {
			switch (type) {
				case 7:
					this.calculateObj.total = '18.00';
					this.calculateObj.finalPrice = this.Cards[0].price;
					this.calculateObj.totalPref = this.calculateObj.total - this.calculateObj.finalPrice;
					break;
				case 8:
					this.calculateObj.total = '72.00';
					this.calculateObj.finalPrice = this.Cards[1].price;
					this.calculateObj.totalPref = this.calculateObj.total - this.calculateObj.finalPrice;
					break;
				case 9:
					this.calculateObj.total = '216.00';
					this.calculateObj.finalPrice = this.Cards[2].price;
					this.calculateObj.totalPref = this.calculateObj.total - this.calculateObj.finalPrice;
					break;
				case 10:
					this.calculateObj.total = '432.00';
					this.calculateObj.finalPrice = this.Cards[3].price;
					this.calculateObj.totalPref = this.calculateObj.total - this.calculateObj.finalPrice;
					break;
				default:
					this.calculateObj.total = '00.00';
					this.calculateObj.totalPref = '0';
					this.calculateObj.finalPrice = 0;
			}
		},
		payNow: function payNow() {
			window.clickLog && window.clickLog('from=pc-cvip-buyshow-ljzf-dj-new');
		},
		close: function close() {
			this.$emit('closeDialog');
			window.clickLog && window.clickLog('from=pc-cvip-buyshow-close-new');
		},
		getPriceFn: function getPriceFn() {
			var _this4 = this;

			var paySet = this.mealInfo.payset;
			paySet.forEach(function (mealItem, index) {
				_this4.cardData[index].name = mealItem.versionName;
				_this4.cardData[index].price = mealItem.benefitsPrice;
				_this4.cardData[index].type = mealItem.vid;
				_this4.cardData[index].originPrice = mealItem.oldPrice;
				_this4.cardData[index].discount = mealItem.desc;
			});

			this.showPrice = this.cardData[this.active].price;
		},
		getpaycviporderFn: function getpaycviporderFn(state, vid, ft, from, rtnurl) {
			var _this5 = this;

			var couponCode = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["j" /* getpaycviporder */])(state, vid, ft, from, rtnurl, couponCode).then(function (result) {
				if (result.isSuccess) {
					var url = '';

					if (result.entity.reqStatus === 'success') {
						url = result.entity.reqUrl;
					} else {
						_this5.expire = true;
						return;
					}

					if (_this5.firstTime === 0) {
						_this5.useQRCode(url);
						_this5.orderState(result.entity.orderId);
						_this5.firstTime++;
					} else {
						_this5.orderState(result.entity.orderId);
						_this5.showPrice = result.entity.orderMoney.toString().split('.')[0];

						_this5.newQRCode(url);
					}
				} else {
					console.log('网络异常------getpaycviporder---result ');
				}
			}).catch(function (err) {
				console.error(err, '网络异常------getpaycviporder');
			});
		},
		goToPCPayCenter: function goToPCPayCenter(data) {
			document.getElementById('formid').action = data.action;
			document.getElementById('starttime').value = data.startTime;
			document.getElementById('endtime').value = data.endTime;
			document.getElementById('buyAccountId').value = data.buyAccountId;
			document.getElementById('merId').value = data.merId;
			document.getElementById('orderId').value = data.orderId;
			document.getElementById('orderMoney').value = data.orderMoney;
			document.getElementById('isBill').value = data.isBill;
			document.getElementById('platfrom').value = data.platFrom;
			document.getElementById('payfrom').value = data.payFrom;
			document.getElementById('productName').value = data.productName;
			document.getElementById('productDesc').value = data.productDesc;
			document.getElementById('returnUrl').value = data.returnUrl;
			document.getElementById('notifyUrl').value = data.notifyUrl;
			document.getElementById('balancePaid').value = data.balancePaid;
			document.getElementById('sign').value = data.sign;
			document.getElementById('balanceType').value = data.balanceType;
			document.getElementById('IAPProductID').value = data.IAPProductID;
			document.getElementById('buyAccountId').value = data.buyAccountId;
			document.getElementById('extensionInfo').value = data.extensionInfo;
			document.getElementById('cityId').value = data.cityId;
			document.getElementById('channelId').value = this.payChoose;
			if (data.accountType && data.accountType != 0) {
				document.getElementById('accountType').value = data.accountType;
			}
			document.getElementById('formid').submit();
		}
	},
	components: {
		CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		fromSource: 'fromSource',
		cvipMes: 'cvipMes',
		mealInfo: 'mealInfo' }), {
		discountMoney: function discountMoney() {
			var _cardData$active = this.cardData[this.active],
			    originPrice = _cardData$active.originPrice,
			    price = _cardData$active.price;

			return originPrice - price;
		}
	})
});

/***/ }),

/***/ "SNgt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SV+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_data_js__ = __webpack_require__("cK/P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_index_js__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'jobPrivilege',
    components: {},
    data: function data() {
        return {
            currentIndex: 4,
            prevIndex: 0,
            nextIndex: 0,
            randomIndex: 0,
            commentData: __WEBPACK_IMPORTED_MODULE_1__data_data_js__["b" /* commentData */].jobPrivData,
            jobPTimer: null };
    },
    mounted: function mounted() {
        this.randomIndex = this.randomNum();
        this.autoplay();
    },

    methods: {
        autoplay: function autoplay() {
            this.play();
            this.jobPTimer = setInterval(this.play, 5000);
        },
        randomNum: function randomNum() {
            return Math.floor(Math.random() * 3);
        },
        play: function play() {
            this.currentIndex++;

            this.prevIndex = this.currentIndex === 0 ? 5 : this.currentIndex - 1;
            this.nextIndex = this.currentIndex === 5 ? 0 : this.currentIndex + 1;

            if (this.currentIndex === this.commentData.length) {
                this.currentIndex = 0;
                this.nextIndex = this.currentIndex + 1;
            }
        },
        enter: function enter(index) {
            this.currentIndex = index - 1;
            this.play();
            clearInterval(this.jobPTimer);
        },
        leave: function leave(index) {
            this.jobPTimer = setInterval(this.play, 5000);
        },
        show: function show(type, actionType) {
            window.clickLog && window.clickLog('from=' + actionType + '-new');
            this.$emit('showPrivilDialog', type, actionType);
        },
        buyVipDialog: function buyVipDialog(actionType) {
            this.$emit('buyDialog');
            window.clickLog && window.clickLog('from=pc-' + actionType + '-new');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
        cvipMes: 'cvipMes',
        rightUsed: 'rightUsed',
        resumeListNum: 'resumeListNum',
        getinsurance: ''
    }), {
        vipState: function vipState() {
            return this.$store.getters.getinsurance.code;
        },
        insuranceState: function insuranceState() {
            return this.$store.getters.getAccidentInsuranceState.code;
        }
    })
});

/***/ }),

/***/ "TCKV":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TipDialog', {
    attrs: {
      "tipinfo": _vm.tipinfo,
      "applycourse": _vm.applycourse
    },
    on: {
      "closeDialog": _vm.closeDialog
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "TLc1":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page6"
  }, [_c('div', {
    staticClass: "vip-card"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('span', [_vm._v("今日已有 ")]), _vm._v(" "), _c('NumScroll', {
    attrs: {
      "number": _vm.number
    }
  }), _vm._v(" "), _c('span', [_vm._v("人使用求职金卡找到了工作")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-desc"
  }, [_vm._v("开通立即享受12项求职特权")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "trans"
    }
  }, [_c('div', {
    staticClass: "vip-cards"
  }, [_c('ul', {
    staticClass: "cards",
    attrs: {
      "id": "cards"
    }
  }, _vm._l((_vm.cardData), function(item, index) {
    return _c('li', {
      staticClass: "card",
      on: {
        "mouseenter": function($event) {
          return _vm.handleMouseEnter(index)
        },
        "mouseleave": function($event) {
          return _vm.handleMouseLeave(index)
        }
      }
    }, [_c('div', {
      staticClass: "card-box"
    }, [_c('div', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(item.cardTitle))]), _vm._v(" "), _c('div', {
      staticClass: "card-desc",
      domProps: {
        "innerHTML": _vm._s(item.hoverText)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "card-price"
    }, [_c('span', [_vm._v("￥")]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.cardPrice))]), _vm._v(" "), _c('span', {
      staticClass: "origin-price"
    }, [_vm._v(_vm._s(item.originPrice))])]), _vm._v(" "), _c('p', {
      staticClass: "card-discount"
    }, [_c('span', {
      staticClass: "discount",
      class: {
        'dicount-bg': (item.cardDiscounts === '')
      }
    }, [_vm._v(_vm._s(item.cardDiscounts))])]), _vm._v(" "), _c('div', {
      staticClass: "btn-radiu"
    }, [_c('div', {
      staticClass: "card-btn",
      on: {
        "click": function($event) {
          return _vm.buyVip(item.actionType, item.cardType)
        }
      }
    }, [_vm._v("立即开通")])])]), _vm._v(" "), _c('div', {
      class: {
        'hot-sell': item.hotSellClass !== ''
      }
    })])
  }), 0)])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "TcG2":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hjld-dialog-wrap"
  }, [((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[4]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("黄金亮点")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：会员可以免费选择任意黄金亮点，使用后将在简历中展现所选择的特长优势。")])]), _vm._v(" "), _c('div', {
    staticClass: "hjld-bg"
  }, [_c('img', {
    staticClass: "hjld-bg-img",
    attrs: {
      "src": __webpack_require__("Jf1+")
    }
  })])]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[4]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.resumeListNum ? '立即体验' : '创建简历'
    },
    on: {
      "btnClick": function($event) {
        return _vm.hightResumefn()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit tit-nouse"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("黄金亮点")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：会员可以免费选择任意黄金亮点，使用后将在简历中展现所选择的特长优势。")])]), _vm._v(" "), _c('div', {
    staticClass: "hjld-bg"
  }, [_c('img', {
    staticClass: "hjld-bg-img",
    attrs: {
      "src": __webpack_require__("Jf1+")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("会员可以免费选择任意黄金亮点，使用后将在简历中展现所选择的特长优势。")])]), _vm._v(" "), _c('div', {
    staticClass: "hjld-bg"
  }, [_c('img', {
    staticClass: "hjld-bg-img",
    attrs: {
      "src": __webpack_require__("Jf1+")
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "TdR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_index_js__ = __webpack_require__("gyMJ");




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'titles',
	props: ['vipState'],
	data: function data() {
		return {
			noVip: false
		};
	},
	mounted: function mounted() {
		if (this.vipState === 0 || this.vipState === 'loginNo') {
			this.noVip = true;
		}
	},

	methods: {
		handleSkipPage: function handleSkipPage() {
			window.clickLog && window.clickLog('from=cvip-job-trust');

			window.location.href = "https://certify.58.com/self/index?utm_source=cvip-pctopbar";
		},
		toLogin: function toLogin(path, log) {
			window.clickLog && window.clickLog('from=' + log);
			window.location.href = 'https://passport.58.com/v2/login?appid=wxa9a9dec97e6ee639&source=58-applet-pc&path=' + encodeURIComponent(path);
		}
	},
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
		userInfo: 'userInfo'
	})
});

/***/ }),

/***/ "TfLx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TkdE":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("gJql")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("NFxk"),
  /* template */
  __webpack_require__("JJUd"),
  /* scopeId */
  "data-v-53f5b53b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "U8bG":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('titles', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    }
  }), _vm._v(" "), _c('full-page', {
    ref: "fullpage",
    attrs: {
      "options": _vm.options,
      "id": "fullpage"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('headers', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.buyVipDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('vip-introduce', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('job-privilege', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.buyVipDialog,
      "showPrivilDialog": _vm.showPrivilDialog,
      "buyDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('job-safeguard', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.buyVipDialog,
      "showPrivilDialog": _vm.showPrivilDialog,
      "buyDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('iden-privilege', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.buyVipDialog,
      "showPrivilDialog": _vm.showPrivilDialog,
      "buyDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('vip-card', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('job-analysis', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.buyVipDialog
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "controller"
  }, [_c('ul', [_vm._l((_vm.pageNum), function(index) {
    return _c('li', {
      key: 'controller-' + index,
      staticClass: "controller-item",
      class: {
        current: index === _vm.currentPage + 1
      },
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          return _vm.changePage(index, _vm.actionType[index])
        }
      }
    }, [_vm._v(_vm._s(index > 10 ? index : '0' + index))])
  }), _vm._v(" "), _c('li', {
    staticClass: "ciecle-svg-wrap"
  }, [_c('div', {
    staticClass: "ciecle-svg"
  }), _vm._v(" "), _c('div', {
    staticClass: "arror-top",
    on: {
      "click": function($event) {
        return _vm.nextPrev('prev')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arror-down",
    on: {
      "click": function($event) {
        return _vm.nextPrev('next')
      }
    }
  })])], 2)]), _vm._v(" "), (_vm.buyDialog === true) ? _c('BuyDialog', {
    attrs: {
      "card-chose": _vm.cardChose
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHyxy) ? _c('hyxy-dialog', {
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showJlzd) ? _c('jlzd-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showYpyx) ? _c('ypyx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWxsx) ? _c('wxsx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTdtq) ? _c('tdtq-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQzfx) ? _c('qzfx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWxbp) ? _c('qzbz-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCcaq) ? _c('ccaq-dialog', {
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZskf) ? _c('zskf-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZgbs) ? _c('zgbs-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGrrz) ? _c('grrz-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHjld) ? _c('hjld-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "UH5s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-zskf-big.png";

/***/ }),

/***/ "UJcf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pri-grrz.png";

/***/ }),

/***/ "UXLM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pri-zgbs.png";

/***/ }),

/***/ "UqnG":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("aAzd")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("X2Pv"),
  /* template */
  __webpack_require__("F97/"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "VSV6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'qzbzDialog',
    components: {
        CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
    },
    props: {
        vipState: {
            type: Number,
            default: function _default() {
                return 0;
            }
        }
    },
    data: function data() {
        return {
            title: '无效包赔',
            btnTxt: '开通会员尊享特权',
            title1: '',
            btnTxt1: '',
            title2: '',
            btnTxt2: '申请赔付',
            compensateData: [{
                time: '7天试用版',
                price: '18元',
                money: '100元'
            }, {
                time: '30天基础版',
                price: '28元',
                money: '160元'
            }, {
                time: '30天升级版',
                price: '60元',
                money: '460元'
            }, {
                time: '30天升级版',
                price: '60元',
                money: '880元'
            }]
        };
    },
    created: function created() {
        window.clickLog && window.clickLog('from=pc-cvip-qzbz-tanchuang-show-' + this.cvipMes.cvipstate);
        this.initMealName();
    },

    methods: {
        vipBuy: function vipBuy() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-qzbz-ljkt-' + this.cvipMes.cvipstate);
            this.$emit("buyDialog");
        },
        initMealName: function initMealName() {
            var _this = this;

            console.log(this.mealInfo.payset);
            this.compensateData[0].time = this.mealInfo.payset.experienceName;
            this.compensateData[1].time = this.mealInfo.payset.basicName;
            this.compensateData[2].time = this.mealInfo.payset.upgradeName;
            this.mealInfo.payset.forEach(function (mealItem, index) {
                _this.compensateData[index].time = mealItem.versionName;
                _this.compensateData[index].price = mealItem.benefitsPrice + '元';
            });
        },
        applyCompensate: function applyCompensate() {
            this.$emit("compensateDialog");
        },
        close: function close() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-qzbz-close-' + this.cvipMes.cvipstate);
            this.$emit("closeDialog");
        }
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
        cvipMes: 'cvipMes',
        mealInfo: 'mealInfo',
        rightUsed: 'rightUsed' })
});

/***/ }),

/***/ "WXzV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ware":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("BmO1")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("SEwu"),
  /* template */
  __webpack_require__("brQr"),
  /* scopeId */
  "data-v-242a3003",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "WvM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_title_Title__ = __webpack_require__("EUXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_title_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_title_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_header_Header__ = __webpack_require__("YK2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_vipIntroduce_VipIntroduce__ = __webpack_require__("s1Tl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_vipIntroduce_VipIntroduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_vipIntroduce_VipIntroduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_privileges_JobPrivilege__ = __webpack_require__("Gzcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_privileges_JobPrivilege___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_privileges_JobPrivilege__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_privileges_JobSafeguard__ = __webpack_require__("ub8e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_privileges_JobSafeguard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_privileges_JobSafeguard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_privileges_IdenPrivilege__ = __webpack_require__("wfM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_privileges_IdenPrivilege___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modules_privileges_IdenPrivilege__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_vipCards_VipCard__ = __webpack_require__("DeHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_vipCards_VipCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modules_vipCards_VipCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_jobAnalysis_JobAnalysis__ = __webpack_require__("Fp8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_jobAnalysis_JobAnalysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modules_jobAnalysis_JobAnalysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_footer_Footer__ = __webpack_require__("YrtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modules_footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dialog_BuyDialog__ = __webpack_require__("Ware");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dialog_BuyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modules_dialog_BuyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_dialog_HyxyDialog__ = __webpack_require__("Rj2D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_dialog_HyxyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modules_dialog_HyxyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_dialog_JlzdDialog__ = __webpack_require__("5bV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_dialog_JlzdDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modules_dialog_JlzdDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_dialog_YpyxDialog__ = __webpack_require__("gqJ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_dialog_YpyxDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modules_dialog_YpyxDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_dialog_WxsxDialog__ = __webpack_require__("3NXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_dialog_WxsxDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__modules_dialog_WxsxDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_dialog_TdtqDialog__ = __webpack_require__("KDpj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_dialog_TdtqDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__modules_dialog_TdtqDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_dialog_QzfxDialog__ = __webpack_require__("O5TR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_dialog_QzfxDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__modules_dialog_QzfxDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_dialog_QzbzDialog__ = __webpack_require__("C/Se");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_dialog_QzbzDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__modules_dialog_QzbzDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_dialog_CcaqDialog__ = __webpack_require__("p+Y0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_dialog_CcaqDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__modules_dialog_CcaqDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_dialog_ZskfDialog__ = __webpack_require__("cEZJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_dialog_ZskfDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__modules_dialog_ZskfDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_dialog_ZgbsDialog__ = __webpack_require__("FJcN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_dialog_ZgbsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__modules_dialog_ZgbsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_dialog_GrrzDialog__ = __webpack_require__("AvFD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_dialog_GrrzDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__modules_dialog_GrrzDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_dialog_HjldDialog__ = __webpack_require__("0BnJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_dialog_HjldDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__modules_dialog_HjldDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuex__ = __webpack_require__("NYxO");




























/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Titles: __WEBPACK_IMPORTED_MODULE_1__modules_title_Title___default.a,
        Headers: __WEBPACK_IMPORTED_MODULE_2__modules_header_Header___default.a,
        VipIntroduce: __WEBPACK_IMPORTED_MODULE_3__modules_vipIntroduce_VipIntroduce___default.a,
        JobPrivilege: __WEBPACK_IMPORTED_MODULE_4__modules_privileges_JobPrivilege___default.a,
        JobSafeguard: __WEBPACK_IMPORTED_MODULE_5__modules_privileges_JobSafeguard___default.a,
        IdenPrivilege: __WEBPACK_IMPORTED_MODULE_6__modules_privileges_IdenPrivilege___default.a,
        VipCard: __WEBPACK_IMPORTED_MODULE_7__modules_vipCards_VipCard___default.a,
        JobAnalysis: __WEBPACK_IMPORTED_MODULE_8__modules_jobAnalysis_JobAnalysis___default.a,
        Footers: __WEBPACK_IMPORTED_MODULE_9__modules_footer_Footer___default.a,
        BuyDialog: __WEBPACK_IMPORTED_MODULE_10__modules_dialog_BuyDialog___default.a,
        HyxyDialog: __WEBPACK_IMPORTED_MODULE_11__modules_dialog_HyxyDialog___default.a,
        JlzdDialog: __WEBPACK_IMPORTED_MODULE_12__modules_dialog_JlzdDialog___default.a,
        YpyxDialog: __WEBPACK_IMPORTED_MODULE_13__modules_dialog_YpyxDialog___default.a,
        WxsxDialog: __WEBPACK_IMPORTED_MODULE_14__modules_dialog_WxsxDialog___default.a,
        TdtqDialog: __WEBPACK_IMPORTED_MODULE_15__modules_dialog_TdtqDialog___default.a,
        QzfxDialog: __WEBPACK_IMPORTED_MODULE_16__modules_dialog_QzfxDialog___default.a,
        QzbzDialog: __WEBPACK_IMPORTED_MODULE_17__modules_dialog_QzbzDialog___default.a,
        CcaqDialog: __WEBPACK_IMPORTED_MODULE_18__modules_dialog_CcaqDialog___default.a,
        ZskfDialog: __WEBPACK_IMPORTED_MODULE_19__modules_dialog_ZskfDialog___default.a,
        ZgbsDialog: __WEBPACK_IMPORTED_MODULE_20__modules_dialog_ZgbsDialog___default.a,
        GrrzDialog: __WEBPACK_IMPORTED_MODULE_21__modules_dialog_GrrzDialog___default.a,
        HjldDialog: __WEBPACK_IMPORTED_MODULE_22__modules_dialog_HjldDialog___default.a },
    props: ['vipState', 'pageZoom'],
    data: function data() {
        var _this = this;
        return {
            cardChoose: 58,
            currentPage: 0,

            options: {
                licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
                scrollBar: false,
                sectionsColor: ['#232020', '#232020', '#232020', '#232020', '#232020', '#232020', '#232020'],
                onLeave: _this.onLeave
            },

            actionType: ['one', 'two', 'three', 'four', 'five', 'six', 'seven'],
            buyDialog: false,
            showHyxy: false,
            showJlzd: false,
            showWxsx: false,
            showYpyx: false,
            showQzfx: false,
            showTdtq: false,
            showWxbp: false,
            showCcaq: false,
            showZskf: false,
            showZgbs: false,
            showGrrz: false,
            showHjld: false };
    },
    mounted: function mounted() {},

    methods: {
        closeDialog: function closeDialog() {
            this.showHyxy = false;
            this.buyDialog = false;

            this.showWxsx = false;
            this.showYpyx = false;
            this.showQzfx = false;
            this.showJlzd = false;
            this.showJsgt = false;
            this.showTdtq = false;

            this.showWxbp = false;

            this.showCcaq = false;
            this.showZskf = false;

            this.showZgbs = false;
            this.showGrrz = false;
            this.showHjld = false;
        },
        showDialog: function showDialog() {
            var cardType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 58;

            this.buyDialog = true;
            this.cardChoose = cardType;
        },
        buyVipDialog: function buyVipDialog() {
            this.closeDialog();
            this.showDialog();
        },
        showHyxyDialog: function showHyxyDialog() {
            this.showHyxy = true;
        },
        showPrivilDialog: function showPrivilDialog(type) {

            switch (type) {
                case 'ypyx':
                    this.showYpyx = true;
                    break;
                case 'tdfb':
                    this.showTdtq = true;
                    break;
                case 'wxsx':
                    this.showWxsx = true;
                    break;
                case 'jlzd':
                    this.showJlzd = true;
                    break;
                case 'qzfx':
                    this.showQzfx = true;
                    break;

                case 'wxbp':
                    this.showWxbp = true;
                    break;

                case 'ccaq':
                    this.showCcaq = true;
                    break;
                case 'zskf':
                    this.showZskf = true;
                    break;

                case 'zgbs':
                    this.showZgbs = true;
                    break;
                case 'grrz':
                    this.showGrrz = true;
                    break;
                case 'hjld':
                    this.showHjld = true;
                    break;
            };
        },
        onLeave: function onLeave(origin, destination, direction) {
            this.currentPage = destination.index;
        },
        changePage: function changePage(index, actionType) {
            fullpage_api.moveTo(index);
            window.clickLog && window.clickLog('from=pc-cvip-louti--' + actionType + '-new');
        },
        nextPrev: function nextPrev(actionType) {
            window.clickLog && window.clickLog('from=pc-cvip-louti--' + actionType + '-new');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        pageNum: function pageNum() {
            return this.options.sectionsColor.length;
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_vuex__["a" /* mapGetters */])({
        mealInfo: 'mealInfo' }))

});

/***/ }),

/***/ "X2Pv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "expirDialog",
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
  },
  data: function data() {
    return {
      title: '',
      btnTxt: "立即续费",
      expir: ''
    };
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-shixiao-show-new');
  },

  methods: {
    vipBuy: function vipBuy() {
      this.$emit('buyDialog');
      window.clickLog && window.clickLog('from=pc-cvip-shixiao-ljxf-new');
    },
    close: function close() {
      this.$emit('closeDialog');
      window.clickLog && window.clickLog('from=pc-cvip-shixiao-close-new');
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    cvipMes: 'cvipMes'
  })
});

/***/ }),

/***/ "XT4T":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxsx-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("非会员每天只能刷新一次，会员可享受免费刷新权限。")])]), _vm._v(" "), _c('div', {
    staticClass: "wxsx-bg"
  }, [_c('img', {
    staticClass: "wxsx-bg-img",
    attrs: {
      "src": __webpack_require__("9QzW")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("免费刷新")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：非会员每天只能刷新一次，会员可享受免费刷新权限。")])]), _vm._v(" "), _c('div', {
    staticClass: "wxsx-bg"
  }, [_c('img', {
    staticClass: "wxsx-bg-img",
    attrs: {
      "src": __webpack_require__("9QzW")
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "Xngv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pri-zskf.png";

/***/ }),

/***/ "YK2I":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("6FVW")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("cpaA"),
  /* template */
  __webpack_require__("IFq7"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_index_Index_vue__ = __webpack_require__("tlXl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_index_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_index_Index_vue__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		name: 'Index',
		component: __WEBPACK_IMPORTED_MODULE_2__views_index_Index_vue___default.a
	}]
}));

/***/ }),

/***/ "YrtY":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("oTdE")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Bf5s"),
  /* template */
  __webpack_require__("+ahz"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ZYjv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZvIu":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("5GdW")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("OcmK"),
  /* template */
  __webpack_require__("BSwo"),
  /* scopeId */
  "data-v-49f8ec53",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "aA0H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pri-ypyx.png";

/***/ }),

/***/ "aAzd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ai0D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aqof":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'CvipAlert',
	props: {
		title: String,
		buttonTxt: String,
		widthnew: {
			type: String,
			default: '640px'
		},
		heightnew: {
			type: String,
			default: '360px'
		},
		marginnew: {
			type: String,
			default: '-180px auto'
		},
		cancelBtnTxt: {
			type: String
		}
	},
	methods: {
		onHide: function onHide() {
			this.$emit('on-hide');
			this.$emit('on-close');
		},
		onConfirm: function onConfirm() {
			this.$emit('on-confirm');
			this.$emit('on-hide');
		},
		onCancel: function onCancel() {
			this.$emit("on-cancel");
			this.$emit('on-hide');
		}
	}
});

/***/ }),

/***/ "aqsg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_CvipDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_alert_Alert__ = __webpack_require__("oOGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_alert_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_alert_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_toast_Toast__ = __webpack_require__("zsV4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_toast_Toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_toast_Toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_index__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_index_js__ = __webpack_require__("gyMJ");




var _name$data$computed$c;







/* harmony default export */ __webpack_exports__["default"] = (_name$data$computed$c = {
	name: 'RessumeTopDialog',
	data: function data() {
		return {
			showDialog: false,
			title: '简历置顶',
			btnTxt: '立即置顶',
			resume: '',
			resumeList: [],
			dayList: [{
				daysid: 1,
				text: '1天'
			}, {
				daysid: 3,
				text: '3天'
			}, {
				daysid: 5,
				text: '5天'
			}, {
				daysid: 7,
				text: '7天'
			}],
			choseIndex: -1,
			resumeChose: '',
			dayChose: '',
			daysUse: 1,
			resumeListNum: '',
			addbaseresumeUrl: '',
			showCancelWarn: false,
			cancelWarnTipText: "",
			showWarn: false,
			showDayUseWarn: false,
			show: false,
			toastText: ""
		};
	},

	computed: {
		resumeChose: function resumeChose() {
			return this.resumeList[this.choseIndex].confuseResumeId;
		}
	},
	created: function created() {
		this.init();
	},

	methods: {
		init: function init() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _this.getResumeHighlightFn('pc', 5);

							case 2:

								_this.initChoseIndex();
								console.log("");

								_this.showDialog = true;

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		initChoseIndex: function initChoseIndex() {
			for (var i = 0; i < this.resumeList.length; i++) {
				if (!this.resumeList[i].resumeTopState) {
					this.choseIndex = i;
					this.resumeChose = this.resumeList[this.choseIndex].confuseResumeId;
					return;
				}
			}
		},
		close: function close() {
			window.clickLog && window.clickLog('from=pc-cvip-jlzdsz-tanchuang-close');
			this.$emit('closeDialog');
		},
		closeConfirm: function closeConfirm() {
			window.clickLog && window.clickLog('from=pccvip_zhdiingnewclickno');
			this.$emit('closeDialog');
		},
		handleGetResumeTopInfo: function handleGetResumeTopInfo(resumeId) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var resumeTopInfo, isSuccess, entity, returnMessage, days;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_index__["l" /* getResumeTopInfo */])(resumeId);

							case 2:
								resumeTopInfo = _context2.sent;
								isSuccess = resumeTopInfo.isSuccess, entity = resumeTopInfo.entity, returnMessage = resumeTopInfo.returnMessage;

								if (isSuccess) {
									_context2.next = 7;
									break;
								}

								_this2.handleToast(returnMessage);
								return _context2.abrupt("return", false);

							case 7:
								days = entity.leftTime < 24 && entity.leftTime >= 0 ? entity.leftTime + "\u5C0F\u65F6" : parseInt(entity.leftTime / 24) + "\u5929";


								_this2.cancelWarnTipText = "\u5F53\u524D\u7B80\u5386\u6B63\u5728\u7F6E\u9876\u4E2D\uFF0C\u82E5\u53D6\u6D88\uFF0C\u5269\u4F59" + days + "\u5929\u4E0D\u8FD4\u8FD8";

							case 9:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		choseResume: function choseResume(index, resumeId) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:

								_this3.resumeChose = _this3.resumeList[index].confuseResumeId;

								if (!_this3.resumeList[index].resumeTopState) {
									_context3.next = 6;
									break;
								}

								_context3.next = 4;
								return _this3.handleGetResumeTopInfo(_this3.resumeChose);

							case 4:

								_this3.showCancelWarn = true;

								return _context3.abrupt("return");

							case 6:
								if (!(index === _this3.choseIndex)) {
									_context3.next = 8;
									break;
								}

								return _context3.abrupt("return");

							case 8:
								_this3.choseIndex = index;

							case 9:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		cancelResumeTop: function cancelResumeTop() {
			this.setCancelResumeTop();
		},
		handleToast: function handleToast(text) {
			var _this4 = this;

			this.show = true;
			this.toastText = text;
			setTimeout(function () {
				_this4.show = false;
			}, 1500);
		},
		setCancelResumeTop: function setCancelResumeTop(resumeId) {
			var _this5 = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var res, isSuccess;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.next = 2;
								return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_index__["m" /* cancelResumeTop */])(resumeId || _this5.resumeChose);

							case 2:
								res = _context4.sent;
								isSuccess = res.isSuccess;

								if (isSuccess) {
									_context4.next = 7;
									break;
								}

								_this5.handleToast("取消置顶失败");
								return _context4.abrupt("return", false);

							case 7:

								_this5.getResumeHighlightFn('pc', 5);

								_this5.handleToast("取消置顶成功");

							case 9:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, _this5);
			}))();
		},
		choseDay: function choseDay(day) {
			if (day > this.daysUse) {
				this.showDayUseWarn = true;
				return;
			}

			if (day === this.dayChose) {
				return;
			}
			this.dayChose = day;
		},
		goRecharge: function goRecharge() {
			window.open("https://my.58.com/pro/myjob/index/?autoshowtop=1&PGTID=0d100000-0000-1a0e-61f4-748f61838c3f&ClickID=2");
			this.showDayUseWarn = false;
		},
		getResumeHighlightFn: function getResumeHighlightFn(ft, productid) {
			var _this6 = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var data, isSuccess, entity, returnMessage;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.next = 2;
								return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_index_js__["g" /* getResumeHighlight */])(ft, productid);

							case 2:
								data = _context5.sent;
								isSuccess = data.isSuccess, entity = data.entity, returnMessage = data.returnMessage;

								if (isSuccess) {
									_context5.next = 7;
									break;
								}

								_this6.$p5.toast({ content: returnMessage });
								return _context5.abrupt("return");

							case 7:

								_this6.resume = data;
								_this6.resumeList = data.entity.resumes && data.entity.resumes;
								_this6.resumeListNum = data.entity.resumes && data.entity.resumes.length;
								_this6.addbaseresumeUrl = data.entity.addResumeLink && data.entity.addResumeLink;
								_this6.daysUse = data.entity.remain;

							case 12:
							case "end":
								return _context5.stop();
						}
					}
				}, _callee5, _this6);
			}))();
		},
		topBtnClick: function topBtnClick() {
			window.clickLog && window.clickLog('from=pc-cvip-jlzdsz-tanchuang-ljsy-dj');
			this.postResumeFn(5, this.resumeChose, this.resume.entity.keyid, this.dayChose);
		},
		postResumeFn: function postResumeFn(type, rid, keyid, number) {
			var _this7 = this;

			if (!rid || !number) {
				this.handleToast("请选择置顶天数");
				return;
			}
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_index_js__["k" /* postHighLight */])(type, rid, keyid, number).then(function (result) {
				console.log(result);
				if (result.isSuccess) {
					_this7.$store.commit('LEFT_TOP', _this7.daysUse - _this7.dayChose);
					_this7.$emit('show-alert', '恭喜您，简历置顶设置成功！');

					_this7.topBtn();

					_this7.$emit('closeDialog');
				} else {
					console.log('网络异常');
				}
			}).catch(function (err) {
				console.log('网络异常');
			});
		},
		topBtn: function topBtn() {
			this.$emit('topBtnChange');
		},
		onHide: function onHide() {
			this.showWarn = false;
			this.showCancelWarn = false;
			this.showDayUseWarn = false;
		},
		onConfirm: function onConfirm() {
			window.clickLog && window.clickLog('from=pccvip_zhidingnewclick');
			window.location.href = '//my.58.com/pro/myseekjob/11/';
		}
	}
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$computed$c, "computed", {
	stickDaysText3: function stickDaysText3() {
		return [{
			daysid: 1,
			text: '1天'
		}, {
			daysid: 2,
			text: '2天'
		}, {
			daysid: this.daysUse,
			text: this.daysUse + "\u5929"
		}];
	}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$computed$c, "components", {
	CvipDialog: __WEBPACK_IMPORTED_MODULE_3__common_CvipDialog___default.a,
	CvipAlert: __WEBPACK_IMPORTED_MODULE_4__components_alert_Alert___default.a,
	Toast: __WEBPACK_IMPORTED_MODULE_5__components_toast_Toast___default.a
}), _name$data$computed$c);

/***/ }),

/***/ "axTv":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipExpir"
  }, [_c('titles'), _vm._v(" "), _c('headers', {
    attrs: {
      "vipState": _vm.vipState,
      "card-state": _vm.cardState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  }), _vm._v(" "), _c('my-privileges', {
    attrs: {
      "vipState": _vm.vipState,
      "card-state": _vm.cardState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showCompensateDialog": _vm.showCompensateDialog,
      "showAuthDialog": _vm.showAuthDialog
    }
  }), _vm._v(" "), _c('job-analysis', {
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.showDialog
    }
  }), _vm._v(" "), _c('footers'), _vm._v(" "), _c('help'), _vm._v(" "), (_vm.show === true) ? _c('BuyDialog', {
    attrs: {
      "cardChoose": _vm.cardChoose
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTbts) ? _c('TbtsDialog', {
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAuth) ? _c('AuthDialog', {
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showExpri === true) ? _c('ExpriDialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.showDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHyxy) ? _c('hyxy-dialog', {
    attrs: {
      "stopPrevent": false
    },
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "bbc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cardType: function cardType(type) {
    var res = '';
    switch (type) {
      case 1:
      case 4:
      case 5:
        res = '年卡';
        break;
      case 2:
      case 3:
      case 6:
      case 8:
        res = '月卡';
        break;
      case 7:
        res = '周卡';
        break;
      case 9:
        res = '季度卡';
        break;
      case 10:
        res = '半年卡';
        break;
      case 19:
        res = '基础版';
        break;
      case 20:
        res = '升级版';
        break;
      default:
        res = '会员卡';
        break;
    }
    return res;
  }
});

/***/ }),

/***/ "brQr":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-dialog-wrap"
  }, [_c('CvipDialog', {
    attrs: {
      "widthnew": '790px',
      "heightnew": '570px',
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.payNow()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("选择会员卡套餐：")]), _vm._v(" "), _c('ul', {
    staticClass: "card-list"
  }, _vm._l((_vm.cardData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "card",
      class: {
        active: item.type === _vm.chooseType
      },
      on: {
        "click": function($event) {
          return _vm.chooseCard(index, item.type)
        }
      }
    }, [(item.recommend) ? _c('div', {
      staticClass: "recommend-icon"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('p', {
      staticClass: "now-price"
    }, [_vm._v("￥"), _c('em', [_vm._v(_vm._s(item.price))]), _c('span', {
      staticClass: "date-unit"
    }, [_vm._v(_vm._s(item.dateUnit))])]), _vm._v(" "), (item.originPrice > item.price) ? _c('span', {
      staticClass: "original"
    }, [_vm._v("原价￥" + _vm._s(item.originPrice))]) : _c('span', {
      staticClass: "original-icon"
    }), _vm._v(" "), (item.discount) ? _c('span', {
      staticClass: "price-discount"
    }, [_vm._v(_vm._s(item.discount))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "dotted-line"
    }), _vm._v(" "), _c('p', {
      staticClass: "enjoy-privileges"
    }, [_vm._v(_vm._s(item.privilegesText))])])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "tit pay-type-tit"
  }, [_vm._v("请扫码支付：")]), _vm._v(" "), _c('div', {
    staticClass: "pay-center"
  }, [_c('div', {
    staticClass: "pay-qrcode"
  }, [_c('div', {
    attrs: {
      "id": "payqrcode"
    }
  }), _vm._v(" "), (_vm.expire) ? _c('div', {
    staticClass: "refresh-code",
    on: {
      "click": function($event) {
        return _vm.refreshCode()
      }
    }
  }, [_c('div', {
    staticClass: "refresh-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "refresh-text"
  }, [_vm._v("点击刷新")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pay-info"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discountMoney > 0),
      expression: "discountMoney > 0"
    }],
    staticClass: "discount-txt"
  }, [_c('span', [_vm._v("折扣:")]), _vm._v(" "), _c('span', [_vm._v("已优惠" + _vm._s(_vm.discountMoney) + "元")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discountMoney > 0),
      expression: "discountMoney > 0"
    }],
    staticClass: "dotted-line"
  }), _vm._v(" "), _c('p', {
    staticClass: "discount-coupun"
  }), _vm._v(" "), _c('p', {
    staticClass: "meal-price"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.showPrice) + ".00")])]), _vm._v(" "), _c('p', {
    staticClass: "pay-type"
  }, [_c('i', {
    staticClass: "pay pay-wx"
  }), _vm._v(" "), _c('i', {
    staticClass: "pay pay-alipay"
  }), _vm._v(" "), _c('span', {
    staticClass: "pay-text"
  }, [_vm._v("均可扫码支付")])]), _vm._v(" "), _c('p', {
    staticClass: "vip-agreement"
  }, [_vm._v("\n\t\t\t\t\t支付即表示同意\n\t\t\t\t\t《"), _c('span', {
    staticClass: "argument",
    on: {
      "click": _vm.showArgument
    }
  }, [_vm._v("会员用户协议")]), _vm._v("》\n\t\t\t\t")])])])]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "formid",
      "name": "form1",
      "method": "post",
      "target": "_self",
      "action": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "starttime",
      "id": "starttime",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "endtime",
      "id": "endtime",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyAccountId",
      "id": "buyAccountId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "merId",
      "id": "merId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderId",
      "id": "orderId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderMoney",
      "id": "orderMoney",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "isBill",
      "id": "isBill",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "productName",
      "id": "productName",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "productDesc",
      "id": "productDesc",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "returnUrl",
      "id": "returnUrl",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "notifyUrl",
      "id": "notifyUrl",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "sign",
      "id": "sign",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "platfrom",
      "id": "platfrom",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "payfrom",
      "id": "payfrom",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "wapbanklist",
      "id": "wapbanklist",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "balancePaid",
      "id": "balancePaid",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "resumeTag",
      "id": "resumeTag",
      "value": "self_resume"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "accountType",
      "id": "accountType",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "balanceType",
      "id": "balanceType",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "IAPProductID",
      "id": "IAPProductID",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyAccountId",
      "id": "buyAccountId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "extensionInfo",
      "id": "extensionInfo"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cityId",
      "id": "cityId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "channelId",
      "id": "channelId",
      "value": ""
    }
  })])
}]}

/***/ }),

/***/ "cEZJ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("etiM")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("g65/"),
  /* template */
  __webpack_require__("EZFi"),
  /* scopeId */
  "data-v-5a5927f7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "cK/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return commentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cardData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return introData; });
/* unused harmony export privilegesData */

var commentData = {
    jobPrivData: [{
        privTitle: '简历置顶',
        iconUrl: __webpack_require__("uLCS"),
        itemClass: 'item-jlzd',
        clickShow: 'jlzd',
        actionType: 'pc-cvip-huiyuantequan-jlzd-dj-0',
        comments: [{
            commentText: '应聘文员工作竞争压力大，购买会员以前总是隔几天才会有人联系我面试，自从使用了<span class="mark-light">简历置顶</span>之后，每天都会收到5-6个面试电话，真是太好了。',
            privResult: '该用户简历日均被下载：',
            result: '20次',
            commentFrom: '——来自河北的用户'
        }, {
            commentText: '因为没上过大学，虽然经验丰富，还是匹配不了高薪。<span class="mark-light">使用简历置顶后</span>，我的简历能被企业HR直接搜索到，今天就有三家公司邀请我去面试！',
            privResult: '该用户简历日均被下载：',
            result: '32次',
            commentFrom: '——来自深圳的用户'
        }, {
            commentText: '想找个工作真不容易，投了几十个工作都没人联系，前天买了会员，这几天好几个公司联系我，说<span class="mark-light">看到我的简历在最上面</span>，让我去面试。',
            privResult: '该用户简历日均被下载：',
            result: '15次',
            commentFrom: '——来自辽宁的用户'
        }]
    }, {
        privTitle: '应聘优先',
        iconUrl: __webpack_require__("FsC6"),
        itemClass: 'item-ypyx',
        clickShow: 'ypyx',
        actionType: 'pc-cvip-huiyuantequan-ypyx-dj-0',
        comments: [{
            commentText: '以前投递总感觉企业没有看，自从开通了会员，投递的简历几乎都是当天就有反馈，研究了一下会员特权，才知是<span class="mark-light">应聘优先</span>。希望这类特权越来越多',
            privResult: '该用户简历当天被查率为：',
            result: '70%',
            commentFrom: '——来自北京的用户'
        }, {
            commentText: '我干货车司机有二十多年了，但找工作总是快不过比我年轻很多的小伙子，他们比我手机玩的好啊！自从我使用了<span class="mark-light">应聘优先特权</span>，不到3天就签了新单位。',
            privResult: '该用户使用特权前后，简历查看率提升了：',
            result: '340%',
            commentFrom: '——来自河南的用户'
        }, {
            commentText: '以前投完简历之后总是将时间耗费在无谓的等待中，那天听室友说她充了会员以后收到好多电话，我也试了试，果然<span class="mark-light">投完简历当天就有人联系</span>，开心。',
            privResult: '该用户简历当天被查率为：',
            result: '80%',
            commentFrom: '——来自天津的用户'
        }]

    }, {
        privTitle: '免费刷新',
        iconUrl: __webpack_require__("E4J+"),
        itemClass: 'item-wxsx',
        clickShow: 'wxsx',
        actionType: 'pc-cvip-huiyuantequan-wxsx-dj-0',
        comments: [{
            commentText: '作为学生党，在第一次就把简历写好了之后就不会再有更新了，幸好会员可以让我<span class="mark-light">每天免费的刷刷刷</span>，简历的排名也会实时调整，开心',
            privResult: '当天该用户简历排名上升：',
            result: '108名',
            commentFrom: '——来自吉林的用户'
        }, {
            commentText: '这几天找工作，没面试的时候<span class="mark-light">我就在家刷简历</span>，确实联系我的企业比之前多了不少，哈哈哈，没白刷有效果我就知足了，为自己开心！',
            privResult: '该用户刷新简历后，简历查看率提升了：',
            result: '280%',
            commentFrom: '——来自辽宁的用户'
        }, {
            commentText: '听公司hr说投递的时间决定你的简历位置，但HR一般只会看前面一两页，所以每天最好都刷新简历，<span class="mark-light">刷新以后就能排在前面，更容易被看到。</span>',
            privResult: '当天该用户简历排名上升：',
            result: '180名',
            commentFrom: '——来自福建的用户'
        }]
    }, {
        privTitle: '投递翻倍',
        iconUrl: __webpack_require__("1C1u"),
        itemClass: 'item-tdfb',
        clickShow: 'tdfb',
        actionType: 'pc-cvip-huiyuantequan-tdfb-dj-0',
        comments: [{
            commentText: '做我们商务司机这一行的，用人单位要求都很高，为了可以快速找工作，我都会投递好多个职位，<span class="mark-light">会员每天可投递25次</span>，简直是我们这类人群的福音啊~',
            privResult: '该用户日均面试邀请：',
            result: '3家公司',
            commentFrom: '——来自上海的用户'
        }, {
            commentText: '找工作两周了，每天都投满15次，差不多两天才一个面试。买完会员我<span class="mark-light">能投25次了</span>，现在天天都能去面试了，效果不错，大家可以一试！',
            privResult: '该用户日均面试邀请：',
            result: '1.5家公司',
            commentFrom: '——来自广西的用户'
        }, {
            commentText: '有些公司投了简历没有答复，也不知道是不合适，还是已经招到人了，所以还是得海投啊，但是投多了就不让投了，开通会员以后<span class="mark-light">每天能投25个岗位</span>，够用了。',
            privResult: '该用户日均面试邀请：',
            result: '3家公司',
            commentFrom: '——来自黑龙江的用户'
        }]
    }, {
        privTitle: '求职分析',
        iconUrl: __webpack_require__("4wbl"),
        itemClass: 'item-qzfx',
        clickShow: 'qzfx',
        actionType: 'pc-cvip-huiyuantequan-qzfx-dj-0',
        comments: [{
            commentText: '我主要想找保安之类的工作，之前没有使用过58同城，不知道怎么能快速找到工作，幸好会员中的<span class="mark-light">求职分析</span>，告诉我每天应该做什么，按指示操作，一点都不操心',
            privResult: '该用户求职竞争力分数：',
            result: '90分',
            commentFrom: '——来自青海的用户'
        }, {
            commentText: '以前不好找工作，每天随便投投面面，越来越失落。看完求职分析。我<span class="mark-light">按照软件提示挨个操作完再去投递职位</span>，终于有几家心仪公司联系我了。',
            privResult: '该用户求职竞争力分数：',
            result: '90分',
            commentFrom: '——来自黑龙江的用户'
        }, {
            commentText: '第一次找工作，也不知道应该怎么找，在58上看会员有个求职分析就试了试，感觉不错，从写简历到搜工作到投简历都有提示，<span class="mark-light">一步步跟着做顺利找到工作了</span>。',
            privResult: '该用户求职竞争力分数：',
            result: '90分',
            commentFrom: '——来自广东的用户'
        }]
    }],

    jobSafeData: [{
        privTitle: '无效包赔',
        iconUrl: __webpack_require__("EpZs"),
        itemClass: 'item-wxbp',
        clickShow: 'wxbp',
        actionType: 'pc-cvip-huiyuantequan-wxbp-dj-0',
        comments: [{
            commentText: '本来对购买金卡很犹豫，但是看到<span class="mark-light">没有面试6倍赔付</span>之后果断入手，当时想：能找到工作最好，如果不行也可以得到赔偿。我得到了赔偿还找到了工作~',
            privResult: '该用户最终获得赔偿：',
            result: '160元',
            commentFrom: '——来自浙江的用户'
        }, {
            commentText: '在职找工作一周还没找到，最后买了求职金卡，主要是抱着有效果最好，没有还可以得赔偿的想法买的，不过我在短时间内找到了工作，没有机会去<span class="mark-light">申请赔付</span>~',
            privResult: '该用户在会员购买10内找到了工作',
            result: '',
            commentFrom: '——来自东莞的用户'
        }, {
            commentText: '本来就是冲着能有更好的求职效果来的，最后也通过会员如愿找到了工作，不过我有个朋友买了会员但是通过其他渠道找到了工作，最后<span class="mark-light">申请赔付也给赔了</span>',
            privResult: '该用户朋友最终获得赔偿：',
            result: '160元',
            commentFrom: '——来自江西的用户'
        }]
    }, {
        privTitle: '财产安全',
        iconUrl: __webpack_require__("g7A2"),
        itemClass: 'item-ccaq',
        clickShow: 'ccaq',
        actionType: 'pc-cvip-huiyuantequan-ccaq-dj-0',
        comments: [{
            commentText: '前段时间去一家商贸公司面试，顺利通过，但当场需要缴纳150块钱体检费，最后才发现这是一家靠骗取求职者体检费用的公司，<span class="mark-light">举报给58后，58很快下线了该企业，我也顺利从58获得损失赔偿！<span>',
            privResult: '',
            result: '',
            commentFrom: '——来自新疆的用户'
        }, {
            commentText: '前段时间去一家商贸公司面试，顺利通过，但当场需要缴纳150块钱体检费，最后才发现这是一家靠骗取求职者体检费用的公司，<span class="mark-light">举报给58后，58很快下线了该企业，我也顺利从58获得损失赔偿！<span>',
            privResult: '',
            result: '',
            commentFrom: '——来自新疆的用户'
        }, {
            commentText: '前段时间去一家商贸公司面试，顺利通过，但当场需要缴纳150块钱体检费，最后才发现这是一家靠骗取求职者体检费用的公司，<span class="mark-light">举报给58后，58很快下线了该企业，我也顺利从58获得损失赔偿！<span>',
            privResult: '',
            result: '',
            commentFrom: '——来自新疆的用户'
        }]
    }, {
        privTitle: '专属客服',
        iconUrl: __webpack_require__("+R8w"),
        itemClass: 'item-zskf',
        clickShow: 'zskf',
        actionType: 'pc-cvip-huiyuantequan-zskf-dj-0',
        comments: [{
            commentText: '我身边的人从来没用过58同城，导致我每次遇到问题都不知道问谁，<span class="mark-light">幸好会员的24小时回复特权</span>，可以快速的解决我的问题，终于不用因为不懂而发愁了',
            privResult: '',
            result: '',
            commentFrom: '——来自江西的用户'
        }, {
            commentText: '有一次在投递的时候总是投递失败，后来找了客服才知道是因为我的手机号验证出了问题，<span class="mark-light">客服小姐姐耐心的告诉我要怎么去操作</span>~给客服小姐姐打call！',
            privResult: '',
            result: '',
            commentFrom: '——来自天津的用户'
        }, {
            commentText: '第一次用58求职，操作都不是特别了解，看到<span class="mark-light">会员有24小时回复特权</span>，把问题都反馈了一下，当天客服给我回复告诉我该如何操作，之后有好多企业给我打电话',
            privResult: '',
            result: '',
            commentFrom: '——来自河北的用户'
        }]
    }],

    idenPrivData: [{
        privTitle: '尊贵标识',
        iconUrl: __webpack_require__("/49Z"),
        itemClass: 'item-zgbs',
        clickShow: 'zgbs',
        actionType: 'pc-cvip-huiyuantequan-zgbs-dj-0',
        comments: [{
            commentText: '以前在企业做hr时，对<span class="mark-light">有标识的简历</span>特别容易产生信赖感，现在轮到自己求职了，也希望我的简历可以获得hr的信赖，为自己赢得更多机会',
            privResult: '该用户日均接到面试电话：',
            result: '5次',
            commentFrom: '——来自武汉的用户'
        }, {
            commentText: '在求职时无时无刻都能看的自己的<span class="mark-light">会员标识</span>，大大满足了自己的“虚荣心”，最主要是价格很便宜。',
            privResult: '',
            result: '',
            commentFrom: '——来自上海的用户'
        }, {
            commentText: '我这个人吧好面子，qq、游戏啥的都想显示皇冠，这次看到在58<span class="mark-light">会员简历有皇冠标识</span>，心想，找工作这么重要的事情那必须整一个，很快就找到了工作',
            privResult: '该用户日均接到面试邀请：',
            result: '3次',
            commentFrom: '——来自吉林的用户'
        }]
    }, {
        privTitle: '黄金亮点',
        iconUrl: __webpack_require__("1nBK"),
        itemClass: 'item-hjld',
        clickShow: 'hjld',
        actionType: 'pc-cvip-huiyuantequan-hjld-dj-0',
        comments: [{
            commentText: '入职之后，我的hr跟我说，当时是因为在海量简历中，看到了我的一个特点跟这个工作很匹配才会找我入职，后来才知道是<span class="mark-light">黄金亮点</span>~还是挺感谢58的工作人员的~',
            privResult: '该用户日均简历被查看：',
            result: '30次',
            commentFrom: '——来自沈阳的用户'
        }, {
            commentText: '我朋友说，在58招人，<span class="mark-light">在筛简历时总会注意到添加了亮点的简历</span>，也会优先查看这些简历，所以我写完简历会立即设置符合自己的亮点。',
            privResult: '',
            result: '',
            commentFrom: '——来自莱芜的用户'
        }, {
            commentText: '我是个司机，有一天接到了面试的通知，当天只有我一个人，老板跟我说，简历差不多，但是我的简历有一个<span class="mark-light">黄金亮点</span>写的开车从未延误，所以优先约我来面试',
            privResult: '该用户从50份简历中被选中面试最后入职',
            result: '',
            commentFrom: '——来自广西的用户'
        }]
    }]
};

var cardData = [{
    cardTitle: '7天体验版',
    cardDesc: '简历置顶等多项特权',
    cardPrice: 18,
    originPrice: '',
    cardDiscounts: '',
    hotSellClass: '',
    cardValid: '1周',
    actionType: 'pc-cvip-taocan-tiyanban-ljkt-fhy',
    cardType: 19,
    hoverText: '\n            <p>\u7B80\u5386\u7F6E\u9876\u7B49\u591A\u9879\u7279\u6743</p>\n            <p>\u7B80\u5386\u7F6E\u9876</p>\n            <p>\u5E94\u8058\u4F18\u5148</p>\n            <p>\u514D\u8D39\u5237\u65B0\u7B80\u5386</p>\n            <p>\u514D\u8D39\u6C42\u804C\u8BCA\u65AD\u7B49</p>\n        ',
    tempText: ''
}, {
    cardTitle: '30天基础版',
    cardDesc: '简历置顶等多项特权',
    cardPrice: 28,
    originPrice: '￥72',
    cardDiscounts: '4折优惠',
    hotSellClass: 'hot-sell',
    cardValid: '1个月',
    actionType: 'pc-cvip-taocan-jichuban-ljkt-fhy',
    cardType: 19,
    hoverText: '\n            <p>\u7B80\u5386\u7F6E\u9876\u7B49\u591A\u9879\u7279\u6743</p>\n            <p>\u7B80\u5386\u7F6E\u9876</p>\n            <p>\u5E94\u8058\u4F18\u5148</p>\n            <p>\u514D\u8D39\u5237\u65B0\u7B80\u5386</p>\n            <p>\u514D\u8D39\u6C42\u804C\u8BCA\u65AD\u7B49</p>\n        ',
    tempText: ''
}, {
    cardTitle: '30天升级版',
    cardDesc: '基础版特权+专属客服等特权',
    cardPrice: 60,
    originPrice: '￥216',
    cardDiscounts: '3折优惠',
    hotSellClass: '',
    cardValid: '1个月',
    actionType: 'pc-cvip-taocan-shengjiban-ljkt-fhy',
    cardType: 20,
    hoverText: '\n            <p>\u7B80\u5386\u7F6E\u9876\u7B49\u591A\u9879\u7279\u6743</p>\n            <p>\u7B80\u5386\u7F6E\u9876</p>\n            <p>\u5E94\u8058\u4F18\u5148</p>\n            <p>\u514D\u8D39\u5237\u65B0\u7B80\u5386</p>\n            <p>\u514D\u8D39\u6C42\u804C\u8BCA\u65AD\u7B49</p>\n        ',
    tempText: ''
}, {
    cardTitle: '30天升级版',
    cardDesc: '基础版特权+专属客服等特权',
    cardPrice: 60,
    originPrice: '￥216',
    cardDiscounts: '3折优惠',
    hotSellClass: '',
    cardValid: '1个月',
    actionType: 'pc-cvip-taocan-shengjiban-ljkt-fhy',
    cardType: 20,
    hoverText: '\n            <p>\u7B80\u5386\u7F6E\u9876\u7B49\u591A\u9879\u7279\u6743</p>\n            <p>\u7B80\u5386\u7F6E\u9876</p>\n            <p>\u5E94\u8058\u4F18\u5148</p>\n            <p>\u514D\u8D39\u5237\u65B0\u7B80\u5386</p>\n            <p>\u514D\u8D39\u6C42\u804C\u8BCA\u65AD\u7B49</p>\n        ',
    tempText: ''
}];

var introData = [{
    introTitle: '如何让你的简历脱颖而出？',
    introDesc: ['黄金亮点：个人专属优势标签，脱颖而出', '简历置顶：优先展示在简历库列表顶部', '刷新简历：免费刷新简历，提升简历排名', '应聘优先：会员投递的简历均会被企业优先处理'],
    introBtnText: '我要脱颖而出',
    actionType: 'pc-cvip-video-tuoyingerchu',
    tabActionType: 'pc-cvip-video-tab-baoguang',
    introDemoImg: __webpack_require__("xTQa")
}, {
    introTitle: '如何快速与企业取得联系？',
    introDesc: ['每天25次投递机会，心仪职位一网打尽', '详情页点击电话，无障碍查看企业电话', '在线沟通，简单高效，实时回复'],
    introBtnText: '我要快速联系企业',
    actionType: 'pc-cvip-video-kuaisulianxiqiye',
    tabActionType: 'pc-cvip-video-tab-lianxi',
    introDemoImg: 'https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/c407vbhe__w2004_h1600.png'
}, {
    introTitle: '购买会员后没有效果怎么办？',
    introDesc: ['无效包赔，会员期间，5天内未收到面试邀请，可获得会员价格的6倍赔偿！', '专属客服，24小时及时解疑答惑', '赠送求职意外险，求职路上为您保驾护航'],
    introBtnText: '我要享受保障',
    actionType: 'pc-cvip-video-xiangshoubaozhang',
    tabActionType: 'pc-cvip-video-tab-baozhang',
    introDemoImg: __webpack_require__("3oUR")
}];

var privilegesData = {
    thead: [{
        width: 200,
        title: '特权列表',
        desc: ''
    }, {
        width: 249,
        title: '7天体验版',
        desc: '简历置顶等多项特权',
        using: false
    }, {
        width: 249,
        title: '30天基础版',
        desc: '简历置顶等多项特权',
        using: false
    }, {
        width: 249,
        title: '30天升级版',
        desc: '基础版特权+专属客服',
        using: false
    }],
    tbody: [{
        data: ['简历置顶', '会员标识', '应聘优先', '免费刷新', '投递特权', '求职诊断', '财产安全险', '无效包赔', '直通卡', '专属客服', '面试技巧', '防骗安全提醒', '简历服务', '用户关怀']
    }, {
        class: 'icon',
        data: ['able', 'able', 'able', 'able', 'able', 'able', 'able', 'able', 'disabled', 'disabled', 'disabled', 'disabled', 'disabled', 'disabled']
    }, {
        class: 'icon',
        data: ['able', 'able', 'able', 'able', 'able', 'able', 'able', 'able', 'disabled', 'disabled', 'disabled', 'disabled', 'disabled', 'disabled']
    }, {
        class: 'icon',
        data: ['able', 'able', 'able', 'able', 'able', 'able', 'able', 'able', 'able', 'able', 'able', 'able', 'able', 'able']
    }]
};

/***/ }),

/***/ "cK7G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/header-all.png";

/***/ }),

/***/ "cUUQ":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("开通会员，保障求职效果！若开始找工作（有投递、权益使用、微聊沟通等行为，具体以会员协议中要求为准）后30天之内收不到面试邀请，你将获得高额赔偿！")])]), _vm._v(" "), _c('div', {
    staticClass: "qzbz-bg"
  }, [_c('p', {
    staticClass: "des-title"
  }, [_vm._v("— 理赔说明 —")]), _vm._v(" "), _c('p', {
    staticClass: "des-text"
  }, [_vm._v("不同市场会员赔付金额如下（全额赔付）：")]), _vm._v(" "), _c('ul', {
    staticClass: "items"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "des-time"
  }, [_vm._v("会员套餐")]), _vm._v(" "), _c('div', {
    staticClass: "desc price"
  }, [_vm._v("价格")]), _vm._v(" "), _c('div', {
    staticClass: "desc money"
  }, [_vm._v("赔付价格")])]), _vm._v(" "), _vm._l((_vm.compensateData), function(item, index) {
    return _c('li', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "des-time"
    }, [_vm._v(_vm._s(item['time']))]), _vm._v(" "), _c('div', {
      staticClass: "desc money"
    }, [_vm._v(_vm._s(item['price']))]), _vm._v(" "), _c('div', {
      staticClass: "desc money"
    }, [_vm._v(_vm._s(item['money']))])])
  })], 2)])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.vipState === 3 ? '仅新版会员可享受' : _vm.vipState === 2 ? '已申请赔付' : _vm.btnTxt2
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "applyCompensate": function($event) {
        return _vm.applyCompensate()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("求职保障")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("苦苦等不到面试和电话？若开始找工作（有投递、权益使用、微聊沟通等行为，具体以会员协议中要求为准）后30天之内收不到面试邀请，你将获得高额赔偿！")])]), _vm._v(" "), _c('div', {
    staticClass: "qzbz-bg"
  }, [_c('p', {
    staticClass: "des-title"
  }, [_vm._v("— 理赔说明 —")]), _vm._v(" "), _c('p', {
    staticClass: "des-text"
  }, [_vm._v("不同市场会员赔付金额如下（全额赔付）：")]), _vm._v(" "), _c('ul', {
    staticClass: "items"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "des-time"
  }, [_vm._v("会员套餐")]), _vm._v(" "), _c('div', {
    staticClass: "desc price"
  }, [_vm._v("价格")]), _vm._v(" "), _c('div', {
    staticClass: "desc money"
  }, [_vm._v("赔付价格")])]), _vm._v(" "), _vm._l((_vm.compensateData), function(item, index) {
    return _c('li', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "des-time"
    }, [_vm._v(_vm._s(item['time']))]), _vm._v(" "), _c('div', {
      staticClass: "desc price"
    }, [_vm._v(_vm._s(item['price']))]), _vm._v(" "), _c('div', {
      staticClass: "desc money"
    }, [_vm._v(_vm._s(item['money']))])])
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ "cZgk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cpaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_index_js__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter_index_js__ = __webpack_require__("bbc5");






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'headers',
	props: ['vipState', 'cardState'],
	filters: __WEBPACK_IMPORTED_MODULE_3__filter_index_js__["a" /* default */],
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		cvipMes: 'cvipMes'
	}), {
		renew: function renew() {
			return this.$store.state.common.renew;
		}
	}),
	data: function data() {
		return {
			num: '',
			timerBroad: null
		};
	},
	created: function created() {
		if (this.vipState === 0 || this.vipState === 1 || this.vipState === 10 || this.vipState === 'loginNo') {}
		if (this.vipState === 1 || this.vipState === 10) {}
	},

	methods: {
		getVipBroadcastfn: function getVipBroadcastfn() {
			var _this = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_index_js__["n" /* getVipBroadcast */])().then(function (result) {
				if (result.isSuccess) {
					_this.num = result.entity.num;
				} else {
					console.log('网络异常', result.returnMessage);
				}
			}).catch(function (err) {
				console.log('网络异常');
			});
		},
		showDialog: function showDialog(actionType) {
			this.$emit('showDialog');
			window.clickLog && window.clickLog('from=' + actionType + '-new');
		},
		showHyxy: function showHyxy() {
			window.open('https://helps.58.com/rules/detail?siteId=5502&terminal=PC&contentId=316237&sourceType=58pc-about&spReturn=1');
		}
	}
});

/***/ }),

/***/ "dDI2":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TipDialog', {
    attrs: {
      "tipinfo": _vm.tipinfo,
      "applycourse": _vm.applycourse
    },
    on: {
      "closeDialog": _vm.closeDialog
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "etiM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fAsG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_util_urlSearch_js__ = __webpack_require__("IoQn");



var _mutations;




var state = {
    fromSource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_util_urlSearch_js__["a" /* query */])('from') || '',
    cvipMes: '',
    getinsurance: '',
    getAccidentInsuranceState: '',
    leftTop: 0,
    loginIs: false,
    userInfo: {
        nickname: '',
        profile: ''
    },
    rightUsed: {
        4: false,
        5: false,
        10: false,
        11: false,
        12: false,
        13: false,
        14: false,
        15: false
    },
    resumeListNum: 0,
    mealInfo: '',
    renew: false
};

var getters = {
    fromSource: function fromSource(state) {
        return state.fromSource;
    },
    cvipMes: function cvipMes(state) {
        return state.cvipMes;
    },
    getinsurance: function getinsurance(state) {
        return state.getinsurance;
    },
    getAccidentInsuranceState: function getAccidentInsuranceState(state) {
        return state.getAccidentInsuranceState;
    },
    leftTop: function leftTop(state) {
        return state.leftTop;
    },
    loginIs: function loginIs(state) {
        return state.loginIs;
    },
    userInfo: function userInfo(state) {
        return state.userInfo;
    },
    rightUsed: function rightUsed(state) {
        return state.rightUsed;
    },
    resumeListNum: function resumeListNum(state) {
        return state.resumeListNum;
    },
    mealInfo: function mealInfo(state) {
        return state.mealInfo;
    }
};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["b" /* CHANGE_CVIP_FROM */], function (state, payload) {
    state.fromSource = payload.state;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["a" /* CHANGE_CVIP_MES */], function (state, payload) {
    state.cvipMes = payload.state;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'CVIP_STATE', function CVIP_STATE(state, data) {
    state.getinsurance = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'INSURANCE_STATE', function INSURANCE_STATE(state, data) {
    state.getAccidentInsuranceState = data.entity;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'IS_LOGIN', function IS_LOGIN(state, data) {
    state.loginIs = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'LEFT_TOP', function LEFT_TOP(state, data) {
    state.leftTop = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'USER_INFO', function USER_INFO(state, data) {
    state.userInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.userInfo, data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'RIGHT_USED', function RIGHT_USED(state, data) {
    state.rightUsed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.rightUsed, data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'RESUME_NUM', function RESUME_NUM(state, data) {
    state.resumeListNum = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'RENEW_STATE', function RENEW_STATE(state, data) {
    state.renew = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'MEAL_INFO', function MEAL_INFO(state, data) {
    state.mealInfo = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "fzEA":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("找工作担心违规收费、拖欠工资？您来举报，经济损失58赔偿，再也不担心上当受骗。财产安全有保障，让您安心找工作！")])]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("如何举报："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("点击职位详情页“举报”按钮，举报信息核实有效后即可获得您所损失的全额赔偿")])]), _vm._v(" "), _c('div', {
    staticClass: "ccaq-bg"
  }, [_c('img', {
    staticClass: "ccaq-bg-img",
    attrs: {
      "src": __webpack_require__("2OBb")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "applyCompensate": function($event) {
        return _vm.applyCompensate()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("财产安全险")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in"
  }, [_vm._v("找工作担心违规收费、拖欠工资？您来举报，经济损失58赔偿，再也不担心上当受骗。财产安全有保障，让您安心找工作！")])]), _vm._v(" "), _c('div', {
    staticClass: "ccaq-bg"
  }, [_c('img', {
    staticClass: "ccaq-bg-img",
    attrs: {
      "src": __webpack_require__("2OBb")
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ "g65/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'zskfDialog',
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
  },
  data: function data() {
    return {
      title: '专属客服',
      btnTxt: '开通会员尊享特权',
      title1: '专属客服',
      btnTxt1: '知道了',
      title2: '',
      btnTxt2: '立即体验'
    };
  },
  mounted: function mounted() {
    window.clickLog && window.clickLog('from=pc-cvip-zskf-tanchuang-show-' + this.cvipMes.cvipstate);
  },

  methods: {
    vipBuy: function vipBuy() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-zskf-ljkt-' + this.cvipMes.cvipstate);
      this.$emit("buyDialog");
    },
    close: function close() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-zskf-close-' + this.cvipMes.cvipstate);
      this.$emit("closeDialog");
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed' })
});

/***/ }),

/***/ "g7A2":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "g9Mj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_data_js__ = __webpack_require__("cK/P");



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'vipIntroduce',
    components: {},
    data: function data() {
        var _this = this;
        return {
            total: 3,
            currentIndex: 1,
            introData: __WEBPACK_IMPORTED_MODULE_0__data_data_js__["c" /* introData */]
        };
    },
    mounted: function mounted() {
        this.autoPlay();
    },

    methods: {
        changeIndex: function changeIndex(index, actionType) {
            this.currentIndex = index;
            window.clickLog && window.clickLog('from=' + actionType);
        },
        autoPlay: function autoPlay() {
            this.play();
            setInterval(this.play, 10000);
        },
        play: function play() {
            this.currentIndex++;
            if (this.currentIndex === this.introData.length) {
                this.currentIndex = 0;
            }
        },
        showDialog: function showDialog(actionType) {
            this.$emit('showDialog');
            window.clickLog && window.clickLog('from=' + actionType);
        }
    }
});

/***/ }),

/***/ "gAnO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gJql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqJ2":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("KLmi")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("5LNg"),
  /* template */
  __webpack_require__("ADMS"),
  /* scopeId */
  "data-v-de8430ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserMes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getResumeHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCvipinfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCvipMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return postHighLight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getVipBroadcast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getpaycviporder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getinsurance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAccidentInsuranceState; });
/* unused harmony export goToMPayCenter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getEnterCvip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getOrderState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return cancelResumeTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getResumeTopInfo; });
/* unused harmony export getCouponCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__ = __webpack_require__("55Kt");


var ORIGIN =  false ? '' : 'https://cvipapi.58.com';

function getUserMes() {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/getUserInfo');
}

function getResumeHighlight(ft, productid) {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/productview?ft=' + ft + '&productid=' + productid);
}

function getCvipinfo() {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/cvipinfo');
}

function getCvipMain(ft) {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/cvipmain?ft=' + ft);
}

function postHighLight(type, confuseResumeId, keyid, number, lt) {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/use?type=' + type + '&rid=' + confuseResumeId + '&keyid=' + keyid + '&number=' + number + '&lt=' + lt);
}

function getVipBroadcast() {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/broadnum');
}

function getPrice() {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/getVersionList');
}

function getEnterCvip(from) {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/enterCvip?from=' + from + '&ft=pc');
}
/**
 * @Author    Hybrid
 * @DateTime  2017-09-28
 * @copyright [copyright]
 * @license   [license]
 * @version   [version]
 * @param     {[type]}    state  	[description]
 * @param     {[type]}    vid    	[套餐版本ID0:申请(购买)可不传;3:预约续费]
 * @param     {[type]}    ft     	[来源app,m,pc]
 * @param     {[type]}    from     	[来源页面标记统计]
 * @param     {[type]}    rtnurl 	[成功回跳页面]
 * @param 	  {[type]}	  couponId  [优惠券code 已下线]
 * @return    {[type]}           [description]
 */
function getpaycviporder(state, vid, ft, from, rtnurl) {
	var couponId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
	var couponCode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';

	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + "/ajax/getpaycviporder?s=" + state + "&vid=" + vid + "&ft=" + ft + "&from=" + from + "&rtnurl=" + rtnurl + "&couponId=" + couponId + '&couponCode=' + couponCode);
}

function getinsurance() {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + "/ajax/insurance/");
}

function getAccidentInsuranceState() {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + "/ajax/accidentInsurance");
}

function goToMPayCenter(data) {
	var url = '//paycenter.58.com/wb/pay?sign=' + data.sign + '&merId=' + data.merId + '&orderId=' + data.orderId + '&accountType=' + data.accountType + '&balanceType=' + data.balanceType + '&notifyUrl=' + data.notifyUrl + '&productName=' + data.productName + '&productDesc=' + data.productDesc + '&orderMoney=' + data.orderMoney + '&IAPProductID=' + data.iapproductID + '&starttime=' + data.starttime + '&endtime=' + data.endtime + '&returnUrl=' + data.returnUrl + '&buyAccountId=' + data.buyAccountId + '&isBill=' + data.isBill + '&platfrom=' + data.platFrom + '&payfrom=' + data.payFrom + '&extensionInfo=' + data.extensionInfo + '&cityId=' + data.cityId;
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(url);
}

function getOrderState(orderId) {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + ('/ajax/getPayStatus?orderId=' + orderId));
}

function getCouponCount() {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/coupon/getAvailableCouponsSource');
}

function cancelResumeTop(resumeId) {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/cancelResumeTop/' + resumeId);
}

function getResumeTopInfo(resumeId) {
	return __WEBPACK_IMPORTED_MODULE_0__js_util_http_axios__["a" /* default */].get(ORIGIN + '/ajax/getResumeTopInfo/' + resumeId);
}



/***/ }),

/***/ "hj+5":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("2buI")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("WvM7"),
  /* template */
  __webpack_require__("vEX7"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "hscH":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("jWZ6")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("CrdZ"),
  /* template */
  __webpack_require__("axTv"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "iI1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tbtsDialog',
    components: {
        CvipDialog: __WEBPACK_IMPORTED_MODULE_1__CvipDialog___default.a
    },
    props: {
        tipinfo: {
            type: String,
            default: function _default() {
                return 'Hello';
            }
        },
        applycourse: {
            type: String,
            default: function _default() {
                return '申请路径';
            }
        }
    },
    data: function data() {
        return {
            title: '温馨提示',
            btnTxt: '知道了',
            title1: '',
            btnTxt1: '',
            title2: '',
            btnTxt2: '立即体验'
        };
    },
    created: function created() {
        window.clickLog && window.clickLog('from=pc-cvip-tbts-tanchuang-show-' + this.cvipMes.cvipstate);
    },

    methods: {
        close: function close() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-tbts-close-' + this.cvipMes.cvipstate);
            this.$emit("closeDialog");
        }
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
        cvipMes: 'cvipMes',
        rightUsed: 'rightUsed' })
});

/***/ }),

/***/ "iJWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_data_js__ = __webpack_require__("cK/P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_index_js__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'idenPrivilege',
    props: ['cvipstate'],
    data: function data() {
        return {
            currentIndex: 0,
            prevIndex: 0,
            nextIndex: 0,
            randomIndex: 0,
            commentData: __WEBPACK_IMPORTED_MODULE_1__data_data_js__["b" /* commentData */].idenPrivData,
            idenPTimer: null };
    },
    mounted: function mounted() {
        this.autoplay();
    },

    methods: {
        autoplay: function autoplay() {
            this.play();
            this.idenPTimer = setInterval(this.play, 5000);
        },
        randomNum: function randomNum() {
            return Math.floor(Math.random() * 3);
        },
        play: function play() {
            this.randomIndex = this.randomNum();
            this.currentIndex++;

            this.prevIndex = this.currentIndex === 0 ? 5 : this.currentIndex - 1;
            this.nextIndex = this.currentIndex === 2 ? 0 : this.currentIndex + 1;

            if (this.currentIndex === this.commentData.length) {
                this.currentIndex = 0;
                this.nextIndex = this.currentIndex + 1;
            }
        },
        enter: function enter(index) {
            this.currentIndex = index - 1;
            this.play();
            clearInterval(this.idenPTimer);
        },
        leave: function leave(index) {
            this.idenPTimer = setInterval(this.play, 5000);
        },
        show: function show(type, actionType) {
            window.clickLog && window.clickLog('from=' + actionType + '-new');
            this.$emit('showPrivilDialog', type, actionType);
        },
        buyVipDialog: function buyVipDialog(actionType) {
            this.$emit('buyDialog');
            window.clickLog && window.clickLog('from=' + actionType + '-new');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
        cvipMes: 'cvipMes',
        rightUsed: 'rightUsed',
        resumeListNum: 'resumeListNum',
        getinsurance: ''
    }), {
        vipState: function vipState() {
            return this.$store.getters.getinsurance.code;
        },
        insuranceState: function insuranceState() {
            return this.$store.getters.getAccidentInsuranceState.code;
        }
    })
});

/***/ }),

/***/ "iJb9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iKnY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'qzfxDialog',
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
  },
  data: function data() {
    return {
      title: '求职分析',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: '',
      btnTxt2: '立即体验',
      qzfx: ''
    };
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-qzfx-tanchuang-show-' + this.cvipMes.cvipstate);
  },

  methods: {
    vipBuy: function vipBuy() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-qzfx-ljkt-' + this.cvipMes.cvipstate);
      this.$emit('buyDialog');
    },
    close: function close() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-qzfx-close-' + this.cvipMes.cvipstate);
      this.$emit('closeDialog');
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    cvipMes: 'cvipMes'
  })
});

/***/ }),

/***/ "iuUc":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zgbs-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("多场景展示："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("在您的求职中心、简历页面、全职招聘页面增加皇冠标识，让您的身份与众不同。")])]), _vm._v(" "), _c('div', {
    staticClass: "zgbs-bg"
  }, [_c('img', {
    staticClass: "zgbs-bg-img",
    attrs: {
      "src": __webpack_require__("UXLM")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("尊贵标识")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("多场景展示：在您的求职中心、简历页面、全职招聘页面增加皇冠标识，让您的身份与众不同。")])]), _vm._v(" "), _c('div', {
    staticClass: "zgbs-bg"
  }, [_c('img', {
    staticClass: "zgbs-bg-img",
    attrs: {
      "src": __webpack_require__("UXLM")
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "j1Cc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-ypyx-big.png";

/***/ }),

/***/ "jDRM":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hyxy-dialog-wrap"
  }, [_c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt,
      "stopPrevent": _vm.stopPrevent
    },
    on: {
      "btnClick": function($event) {
        return _vm.close()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "hyxy-agreement"
  }, [_c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("欢迎您使用58招聘求职金卡服务。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("《58招聘求职金卡服务协议》是您在使用58招聘求职金卡服务时必须遵守的协议（以下简称“本协议”）。您勾选同意或实际接受了58（指58同城（www.58.com）的网络服务提供者，包括58同城网（www.58.com）的所有者及其关联服务提供方）招聘求职金卡服务，就表示您已接受了本协议的全部约定并愿意受其约束。"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("请您仔细阅读本协议，充分理解本协议的各条款内容。如果您不同意本规则或其中任何条款约定，应立即停止使用58求职金卡服务。如发生纠纷，您不能以未经仔细阅读为由进行抗辩。甲方除应遵守本协议约定外，还应遵守58同城线上《58同城使用协议》（http://about.58.com/home/announcement.html）、《58推广用户服务协议》（http://tuiguang.58.com/agreement）、《58同城隐私权条款》（http://about.58.com/395.html）的相关规定。")])])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-title"
  }, [_vm._v("一、招聘求职金卡服务的内容")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("1、您首先应该清楚地了解58招聘求职金卡服务的业务模式。您购买招聘求职金卡服务套餐后即成为58同城的黄金会员用户。在招聘求职金卡套餐有效期内，您将根据所购买套餐的类型享有以下几项或全部求职特权，包括应聘优先、简历置顶、投递特权、免费刷新、黄金亮点、竞争力分析、面试无忧、尊贵标识、专属客服等，具体以58同城平台公示为准。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("2、您可通过在线支付或用您在58同城开立的交易宝账户、58现金账户（具体以58同城平台公示的为准）内的余额购买招聘求职金卡服务套餐。"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("您知悉并同意，因“58招聘求职金卡服务”为在线即时服务产品，一经购买开通，非法定情形，您不得擅自要求提前终止服务，否则，您前期已支付的服务费用将被扣除作为违约金以及对58同城已做工作的补偿。")])])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-title"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("二、面试无忧专有条款")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("您在购买招聘求职金卡服务套餐时可获得58同城额外提供的面试无忧服务，即当您在58同城创建简历且投递简历后5-30天内（具体以申请页面提示为准）包括但不限于通过短信、电话、微聊消息、站内信等方式收到来自招聘单位的面试邀约的，您可以获得赔偿。具体赔偿判别的依据及申请的流程还以下述约定的为准。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("1. 赔偿判别依据")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("当您符合以下所有条件时，将获得按照本条款第2项所述的标准的赔偿。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（1）您购买求职金卡且截至申请赔付时，您发布的简历状态需保持一直为“公开”；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（2）您购买求职金卡且截至申请赔付时，您在58平台的求职状态显示为“求职中”；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（3）在招聘求职金卡服务有效期内"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("必需要使用完毕会员金卡提供的所有求职的特权功能（如投递简历、刷新简历、置顶简历、微聊特权等功能，具体以58同城届时展示的功能为准）；")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（4）在招聘求职金卡服务有效期内首次投递简历时起算，在5-30个自然日内您未收到过企业的任何面试邀请、电话或微聊信息；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（5）同一用户（包括但不限于同一ID会员、同一身份证、同一账户、同一IP、同一手机或同一电脑操作均视为同一用户）只能申请赔付1次，即无论您申请赔付的结果是被拒绝赔付还是同意赔付。鉴于此，58同城提示您，在申请赔付前需详细认真的阅读本协议，以防您申请的结果不符合赔付要求。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（6）在58平台完成“我的认证”-“个人认证”-"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("“人脸认证”")]), _vm._v("里完成实名认证且简历名字需与认证通过的身份证姓名一致；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（7）所购买的会员卡有效期内投递30个不同的真实企业（具体判定标准以58同城认定的为准）的岗位；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（8）简历完整度"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("（以平台显示的完整度为准）")]), _vm._v("需达到90%以上；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（9）国家法定节假日提交的赔付申请，58同城将在节假日后的工作日进行处理；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("（10）以上符合条件的用户会进入人工复核，若经人工核验发现用户存在虚假求职（1、包括但不限于学历、薪资或职位类别等信息与招聘方或一般公众理解的要求相差较多；2、涉嫌虚假求职；3、涉嫌通过黑产等非法利益链条而使用求职金卡；4、未使用金卡权益，非常规工作日时间内投递等；5、涉嫌诈骗嫌疑（最终判定的标准以58同城为准），基于58同城已经在平安投保平台责任险，58同城会连同平安保险公司拉黑处理；")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("2. 申请流程")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（1）当您满足本条款第1项的赔付条件时，需在招聘求职金卡有效期内，在线点击“申请赔付”，由58同城判别您是否符合上述赔付条件，如逾期点击“申请赔付”的，58同城将不再提供此求职保障服务；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（2）如经判别符合，您需要按照58同城的要求如实提供信息资料（包括但不限姓名、身份证号、手机号、银行卡信息等），因您填写的信息有误或不真实，导致您未收到赔付款项的，58同城不承担任何责任。如经判别不符合的，您将无法获得赔偿。因判别是否符合出现争议的，最终以58同城判别的为准。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（3）赔付金额具体以58招聘求职金卡服务套餐购买页面会员特权介绍中展示的为准。")]), _vm._v(" "), _c('table', {
    staticClass: "hyxy-table"
  }, [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.hyxyMealInfo), function(mealName) {
    return _c('td', [_vm._v(_vm._s(mealName.name))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("卡面价值（元）")]), _vm._v(" "), _vm._l((_vm.hyxyMealInfo), function(mealName) {
    return _c('td', [_vm._v(_vm._s(mealName.price))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("赔偿金额（元）")]), _vm._v(" "), _vm._l((_vm.hyxyMealInfo), function(mealName) {
    return _c('td', [_vm._v(_vm._s(mealName.compensate))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（4）平安偿付能力数据和综合评级结果的链接：")]), _vm._v(" "), _c('a', {
    staticClass: "hyxy-link-pingan",
    attrs: {
      "href": "http://property.pingan.com/gongkaixinxipilu/changfunenglixinxipilubaogao.shtml",
      "target": "_blank"
    }
  }, [_vm._v("http://property.pingan.com/gongkaixinxipilu/changfunenglixinxipilubaogao.shtml")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-title"
  }, [_vm._v("三、招聘求职金卡服务规则")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("1、您应按照58同城页面显示信息字段填写或完善您的求职意向信息，且保证所填写的信息真实、有效、合法、不得 冒用、盗用、仿造、变造。如因您提供的信息不符合上述要求，58同城有权拒绝为您提供招聘求职金卡服务。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("2、您知悉并确认58同城提供的招聘求职金卡服务中的竞争力分析服务，仅为您的求职过程中提供参考，58同城在任何情况下并不对竞争力分析结果的真实性、准确性、有效性、客观性或相应的任何后果（包括但不限于您依据分析结果、资料或服务而做出的决定或者采取的行动等）承担任何责任。")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("3、您知悉并授权58同城有权通过您填写的简历信息请第三方认证机构核实您的身份信息以便完成您的“个人认证”服务。")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("4、您知悉58同城仅对您填写的信息进行形式审核，如服务开通后经由第三方（包括但不限于与您有交易的用户、国家监管机关或司法机关的通知、裁决等）投诉举证您存在资质冒用、伪造等情形 且您也未能及时自证的，58同城有权冻结您的账号及至终止提供服务并要求您向58同城承担违约责任。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("5、您知悉58同城仅为互联网信息发布平台，推荐给您的招聘信息来源于58同城网站上推广用户自行发布的招聘信息。58同城不对推荐给您的招聘单位的信息的真实、合法性承担任何责任也不对推荐的行为做效果承诺，您应自行谨慎选择招聘单位，最终是否录用以您自行与招聘单位进行沟通确认的为准。如您与招聘单位发生纠纷，您需与招聘单位自行协商解决，58同城不承担任何责任。")])])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-title"
  }, [_vm._v("四、其他")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("1、58同城有权根据国家法律法规的更新、产品和服务规则的调整需要不时地制订、修改本协议涉及的招聘求职金卡服务及求职保障服务，并以网站公示的方式进行公示。如您继续使用58同城招聘求职金卡服务的，即表示您接受经修订的规则和条款。如发生有关争议时，以最新的58招聘求职金卡服务协议为准。")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("2、"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("本规则采用电子文本形式制成")]), _vm._v("，由用户通过58同城平台签署并永久保存在58同城为此设立的专用服务器上备查，同时，双方均认可该形式的规则效力。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("3、本规则的订立、执行、解释及争议解决均适用中华人民共和国法律。因本规则的履行或本规则引起的任何争议双方应通过友好协商方式解决，如无法通过友好协商方式解决的，双方一致同意通过"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("北京市朝阳区人民法院")]), _vm._v("以诉讼方式解决。")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "jPkb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jWZ6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kg7A":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("ZYjv")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("N993"),
  /* template */
  __webpack_require__("mrRV"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "kjz7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l5I3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_TipDialog__ = __webpack_require__("mEEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_TipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_TipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'authDialog',
    components: {
        TipDialog: __WEBPACK_IMPORTED_MODULE_1__common_TipDialog___default.a
    },
    data: function data() {
        return {
            tipinfo: '网页版暂不提供认证流程，如需认证请到手机客户端进行认证。',
            applycourse: '58app-我的-我的求职-会员中心-个人认证-进行个人认证'
        };
    },
    created: function created() {
        window.clickLog && window.clickLog('from=pc-cvip-tbts-tanchuang-show-' + this.cvipMes.cvipstate);
    },

    methods: {
        closeDialog: function closeDialog() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-tbts-close-' + this.cvipMes.cvipstate);
            this.$emit("closeDialog");
        }
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
        cvipMes: 'cvipMes',
        rightUsed: 'rightUsed' })
});

/***/ }),

/***/ "lNgb":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page5"
  }, [_c('div', {
    staticClass: "idenP-privilege"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "job-comment"
  }, [_c('div', {
    staticClass: "job-swiper-pagination"
  }, [_c('div', {
    staticClass: "jobPrivi-icon"
  }, [_c('ul', _vm._l((_vm.commentData), function(item, index) {
    return _c('li', {
      staticClass: "icon-page hover-class",
      on: {
        "mouseenter": function($event) {
          return _vm.enter(index)
        },
        "mouseleave": function($event) {
          return _vm.leave()
        },
        "click": function($event) {
          return _vm.show(item.clickShow, item.actionType)
        }
      }
    }, [_c('div', {
      staticClass: "icon-radius"
    }, [_c('div', {
      staticClass: "icon-box",
      class: {
        'active': index === _vm.currentIndex
      }
    }, [_c('div', {
      staticClass: "icon",
      style: ({
        backgroundImage: 'url(' + item.iconUrl + ')',
        backgroundSize: 'contain'
      })
    })])]), _vm._v(" "), _c('p', {
      staticClass: "detail-text"
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('div', {
      staticClass: "icon-title"
    }, [_vm._v(_vm._s(item.privTitle))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "comment-display"
  }, [_vm._l((_vm.commentData), function(item, index) {
    var _obj;

    return (index === _vm.currentIndex) ? _c('div', {
      key: index,
      staticClass: "comment-box",
      class: ( _obj = {
        'dialog-box-active': index === _vm.currentIndex
      }, _obj[item.itemClass] = index === _vm.currentIndex, _obj )
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.currentIndex || index === _vm.prevIndex || index === _vm.nextIndex),
        expression: "index === currentIndex || index === prevIndex || index === nextIndex"
      }],
      staticClass: "comment"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "dialog-box"
    }, [_c('p', {
      staticClass: "comment-text"
    }, [_c('span', {
      staticClass: "mark-max"
    }, [_vm._v(" “")]), _vm._v(" "), _c('span', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.comments[_vm.randomIndex].commentText)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "priv-result"
    }, [_vm._v("\n                                " + _vm._s(item.comments[_vm.randomIndex].privResult)), _c('span', {
      staticClass: "result"
    }, [_vm._v(_vm._s(item.comments[_vm.randomIndex].result))])]), _vm._v(" "), _c('p', {
      staticClass: "comment-from"
    }, [_vm._v(_vm._s(item.comments[_vm.randomIndex].commentFrom))])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-bg"
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "btn-buyvip"
  }, [_c('p', {
    staticClass: "btn-text",
    on: {
      "click": function($event) {
        return _vm.buyVipDialog('pc-cvip-huiyuantequan-zhangxianzunguishenfeb')
      }
    }
  }, [_vm._v("立即开启与众不同")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "priv-title"
  }, [_vm._v("身份特权")]), _vm._v(" "), _c('div', {
    staticClass: "priv-desc"
  }, [_vm._v("彰显尊贵身份，随时随地与众不同")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('div', {
    staticClass: "hidden-line"
  })])
}]}

/***/ }),

/***/ "mEEr":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("QEZq")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("iI1v"),
  /* template */
  __webpack_require__("K81n"),
  /* scopeId */
  "data-v-0458f5da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mffe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'help',
	props: {}
});

/***/ }),

/***/ "mrRV":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip"
  }, [_c('titles', {
    attrs: {
      "vipState": _vm.vipState
    }
  }), _vm._v(" "), _c('headers', {
    attrs: {
      "vipState": _vm.vipState,
      "card-state": _vm.cardState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  }), _vm._v(" "), _c('my-privileges', {
    attrs: {
      "vipState": _vm.vipState,
      "card-state": _vm.cardState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showCompensateDialog": _vm.showCompensateDialog,
      "showAuthDialog": _vm.showAuthDialog
    }
  }), _vm._v(" "), _c('job-analysis', {
    attrs: {
      "vipState": _vm.vipState
    }
  }), _vm._v(" "), _c('footers'), _vm._v(" "), _c('help'), _vm._v(" "), (_vm.showTbts) ? _c('tbts-dialog', {
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAuth) ? _c('AuthDialog', {
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('BuyDialog', {
    attrs: {
      "cardChoose": _vm.cardChoose
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHyxy) ? _c('hyxy-dialog', {
    attrs: {
      "stopPrevent": false
    },
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "mw8X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wxsxDialog',
  data: function data() {
    return {
      title: '免费刷新',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: ''
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    cvipMes: 'cvipMes'
  }),
  methods: {
    vipBuy: function vipBuy() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-wxsx-ljkt-' + this.cvipMes.cvipstate);
      this.$emit('buyDialog');
    },
    close: function close() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-wxsx-close-' + this.cvipMes.cvipstate);
      this.$emit('closeDialog');
    }
  },
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-wxsx-tanchuang-show-' + this.cvipMes.cvipstate);
  }
});

/***/ }),

/***/ "nAjm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-qzbz-big.png";

/***/ }),

/***/ "nHvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_title_Title__ = __webpack_require__("EUXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_title_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_title_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_header_Header__ = __webpack_require__("YK2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_vipIntroduce_VipIntroduce__ = __webpack_require__("s1Tl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_vipIntroduce_VipIntroduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_vipIntroduce_VipIntroduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_privileges_JobPrivilege__ = __webpack_require__("Gzcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_privileges_JobPrivilege___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_privileges_JobPrivilege__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_privileges_JobSafeguard__ = __webpack_require__("ub8e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_privileges_JobSafeguard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_privileges_JobSafeguard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_privileges_IdenPrivilege__ = __webpack_require__("wfM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_privileges_IdenPrivilege___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modules_privileges_IdenPrivilege__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_vipCards_VipCard__ = __webpack_require__("DeHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_vipCards_VipCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modules_vipCards_VipCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_jobAnalysis_JobAnalysis__ = __webpack_require__("Fp8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_jobAnalysis_JobAnalysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modules_jobAnalysis_JobAnalysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_footer_Footer__ = __webpack_require__("YrtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modules_footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dialog_BuyDialog__ = __webpack_require__("Ware");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dialog_BuyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modules_dialog_BuyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_dialog_HyxyDialog__ = __webpack_require__("Rj2D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_dialog_HyxyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modules_dialog_HyxyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_dialog_JlzdDialog__ = __webpack_require__("5bV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_dialog_JlzdDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modules_dialog_JlzdDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_dialog_YpyxDialog__ = __webpack_require__("gqJ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_dialog_YpyxDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modules_dialog_YpyxDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_dialog_WxsxDialog__ = __webpack_require__("3NXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_dialog_WxsxDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__modules_dialog_WxsxDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_dialog_TdtqDialog__ = __webpack_require__("KDpj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_dialog_TdtqDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__modules_dialog_TdtqDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_dialog_QzfxDialog__ = __webpack_require__("O5TR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_dialog_QzfxDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__modules_dialog_QzfxDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_dialog_QzbzDialog__ = __webpack_require__("C/Se");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_dialog_QzbzDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__modules_dialog_QzbzDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_dialog_CcaqDialog__ = __webpack_require__("p+Y0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_dialog_CcaqDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__modules_dialog_CcaqDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_dialog_ZskfDialog__ = __webpack_require__("cEZJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_dialog_ZskfDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__modules_dialog_ZskfDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_dialog_ZgbsDialog__ = __webpack_require__("FJcN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_dialog_ZgbsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__modules_dialog_ZgbsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_dialog_GrrzDialog__ = __webpack_require__("AvFD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_dialog_GrrzDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__modules_dialog_GrrzDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_dialog_HjldDialog__ = __webpack_require__("0BnJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_dialog_HjldDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__modules_dialog_HjldDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuex__ = __webpack_require__("NYxO");



























/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Titles: __WEBPACK_IMPORTED_MODULE_1__modules_title_Title___default.a,
        Headers: __WEBPACK_IMPORTED_MODULE_2__modules_header_Header___default.a,
        VipIntroduce: __WEBPACK_IMPORTED_MODULE_3__modules_vipIntroduce_VipIntroduce___default.a,
        JobPrivilege: __WEBPACK_IMPORTED_MODULE_4__modules_privileges_JobPrivilege___default.a,
        JobSafeguard: __WEBPACK_IMPORTED_MODULE_5__modules_privileges_JobSafeguard___default.a,
        IdenPrivilege: __WEBPACK_IMPORTED_MODULE_6__modules_privileges_IdenPrivilege___default.a,
        VipCard: __WEBPACK_IMPORTED_MODULE_7__modules_vipCards_VipCard___default.a,
        JobAnalysis: __WEBPACK_IMPORTED_MODULE_8__modules_jobAnalysis_JobAnalysis___default.a,
        Footers: __WEBPACK_IMPORTED_MODULE_9__modules_footer_Footer___default.a,
        BuyDialog: __WEBPACK_IMPORTED_MODULE_10__modules_dialog_BuyDialog___default.a,
        HyxyDialog: __WEBPACK_IMPORTED_MODULE_11__modules_dialog_HyxyDialog___default.a,
        JlzdDialog: __WEBPACK_IMPORTED_MODULE_12__modules_dialog_JlzdDialog___default.a,
        YpyxDialog: __WEBPACK_IMPORTED_MODULE_13__modules_dialog_YpyxDialog___default.a,
        WxsxDialog: __WEBPACK_IMPORTED_MODULE_14__modules_dialog_WxsxDialog___default.a,
        TdtqDialog: __WEBPACK_IMPORTED_MODULE_15__modules_dialog_TdtqDialog___default.a,
        QzfxDialog: __WEBPACK_IMPORTED_MODULE_16__modules_dialog_QzfxDialog___default.a,
        QzbzDialog: __WEBPACK_IMPORTED_MODULE_17__modules_dialog_QzbzDialog___default.a,
        CcaqDialog: __WEBPACK_IMPORTED_MODULE_18__modules_dialog_CcaqDialog___default.a,
        ZskfDialog: __WEBPACK_IMPORTED_MODULE_19__modules_dialog_ZskfDialog___default.a,
        ZgbsDialog: __WEBPACK_IMPORTED_MODULE_20__modules_dialog_ZgbsDialog___default.a,
        GrrzDialog: __WEBPACK_IMPORTED_MODULE_21__modules_dialog_GrrzDialog___default.a,
        HjldDialog: __WEBPACK_IMPORTED_MODULE_22__modules_dialog_HjldDialog___default.a },
    data: function data() {
        var _this = this;
        return {
            vipState: 'loginNo',

            cardChose: 8,
            currentPage: 0,

            options: {
                licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
                scrollBar: false,
                sectionsColor: ['#232020', '#232020', '#232020', '#232020', '#232020', '#232020', '#232020'],
                onLeave: _this.onLeave
            },

            actionType: ['one', 'two', 'three', 'four', 'five', 'six', 'seven'],
            buyDialog: false,
            showHyxy: false,
            showJlzd: false,
            showWxsx: false,
            showYpyx: false,
            showQzfx: false,
            showTdtq: false,
            showWxbp: false,
            showCcaq: false,
            showZskf: false,
            showZgbs: false,
            showGrrz: false,
            showHjld: false };
    },

    props: ['pageZoom'],
    created: function created() {},

    methods: {
        closeDialog: function closeDialog() {
            this.showHyxy = false;
            this.buyDialog = false;

            this.showWxsx = false;
            this.showYpyx = false;
            this.showQzfx = false;
            this.showJlzd = false;
            this.showJsgt = false;
            this.showTdtq = false;

            this.showWxbp = false;

            this.showCcaq = false;
            this.showZskf = false;

            this.showZgbs = false;
            this.showGrrz = false;
            this.showHjld = false;
        },
        buyVipDialog: function buyVipDialog() {
            window.location.href = '//passport.58.com/login/?path=' + 'https://cvip.58.com/view/pc';
        },
        showDialog: function showDialog() {
            var cardType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

            this.buyDialog = true;
            this.cardChose = cardType;
        },
        showPrivilDialog: function showPrivilDialog(type) {
            switch (type) {
                case 'ypyx':
                    this.showYpyx = true;
                    break;
                case 'tdfb':
                    this.showTdtq = true;
                    break;
                case 'wxsx':
                    this.showWxsx = true;
                    break;
                case 'jlzd':
                    this.showJlzd = true;
                    break;
                case 'qzfx':
                    this.showQzfx = true;
                    break;

                case 'wxbp':
                    this.showWxbp = true;
                    break;

                case 'ccaq':
                    this.showCcaq = true;
                    break;
                case 'zskf':
                    this.showZskf = true;
                    break;

                case 'zgbs':
                    this.showZgbs = true;
                    break;
                case 'grrz':
                    this.showGrrz = true;
                    break;
                case 'hjld':
                    this.showHjld = true;
                    break;
            };
        },
        showHyxyDialog: function showHyxyDialog() {
            this.showHyxy = true;
        },
        onLeave: function onLeave(origin, destination, direction) {
            this.currentPage = destination.index;
        },
        changePage: function changePage(index, actionType) {
            fullpage_api.moveTo(index);
            window.clickLog && window.clickLog('from=pc-cvip-louti--' + actionType);
        },
        nextPrev: function nextPrev(actionType) {
            window.clickLog && window.clickLog('from=pc-cvip-louti--' + actionType);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        pageNum: function pageNum() {
            return this.options.sectionsColor.length;
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_vuex__["a" /* mapGetters */])({
        mealInfo: 'mealInfo' }))
});

/***/ }),

/***/ "oOGr":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("TfLx")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("aqof"),
  /* template */
  __webpack_require__("G0mj"),
  /* scopeId */
  "data-v-ddb78db4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "oTdE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ooJt":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grrz-dialog-wrap"
  }, [((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[11]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("个人认证")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：会员可以免费进行芝麻认证，核实自己的真实身份，获得更高的信用，更容易博得企业信赖！")])]), _vm._v(" "), _c('div', {
    staticClass: "grrz-bg"
  }, [_c('img', {
    staticClass: "grrz-bg-img",
    attrs: {
      "src": __webpack_require__("UJcf")
    }
  })])]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[11]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title2,
      "btnTxt": _vm.btnTxt2
    },
    on: {
      "btnClick": function($event) {
        return _vm.certification()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("个人认证")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：会员可以免费进行芝麻认证，核实自己的真实身份，获得更高的信用，更容易博得企业信赖！")])]), _vm._v(" "), _c('div', {
    staticClass: "grrz-bg"
  }, [_c('img', {
    staticClass: "grrz-bg-img",
    attrs: {
      "src": __webpack_require__("UJcf")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("会员可以免费进行芝麻认证，核实自己的真实身份，获得更高的信用，更容易博得企业信赖！")])]), _vm._v(" "), _c('div', {
    staticClass: "grrz-bg"
  }, [_c('img', {
    staticClass: "grrz-bg-img",
    attrs: {
      "src": __webpack_require__("UJcf")
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "ossX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-ccaq-big.png";

/***/ }),

/***/ "p+Y0":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("5op6")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("s6tE"),
  /* template */
  __webpack_require__("fzEA"),
  /* scopeId */
  "data-v-401edb33",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "pPzb":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box",
    class: {
      'title-fixed': _vm.noVip
    }
  }, [_c('div', {
    staticClass: "titles clearfix",
    class: {
      'newV-titles': _vm.noVip
    }
  }, [_c('span', {
    staticClass: "fl tit-logo",
    class: {
      'newV-tit-logo': _vm.noVip
    }
  }), _vm._v(" "), (_vm.noVip) ? _c('span', {
    staticClass: "newV-tit-text"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr clearfix tit-userMes"
  }, [(_vm.vipState === 'loginNo') ? _c('a', {
    staticClass: "tit-icon-login fl",
    on: {
      "click": function($event) {
        return _vm.toLogin('https://cvip.58.com/view/pc', 'pc-cvip-topbar-dl')
      }
    }
  }, [_vm._v("登录")]) : _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "tit-icon fl"
  }, [(_vm.vipState === 1 || _vm.vipState === 10) ? _c('span', {
    staticClass: "tit-vip"
  }) : _vm._e(), _vm._v(" "), (_vm.userInfo.profile) ? _c('img', {
    attrs: {
      "src": '//pic1.58cdn.com.cn' + _vm.userInfo.profile
    }
  }) : _c('img', {
    attrs: {
      "src": "//img.58cdn.com.cn/ui6/my/images/touxiang_default.gif"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "tit-name fl",
    class: {
      'newV-tit-my': _vm.noVip
    }
  }, [_vm._v(_vm._s(_vm.userInfo.nickname))])]), _vm._v(" "), _c('a', {
    staticClass: "tit-my fl",
    class: {
      'newV-tit-my': _vm.noVip
    },
    on: {
      "click": function($event) {
        return _vm.toLogin('https://my.58.com/pro/myjob/index', 'pc-cvip-topbar-wdqz')
      }
    }
  }, [_vm._v("我的求职")]), _vm._v(" "), _c('a', {
    staticClass: "tit-my fl",
    class: {
      'newV-tit-my': _vm.noVip
    },
    on: {
      "click": function($event) {
        return _vm.toLogin('https://my.58.com/index', 'pc-cvip-topbar-grzx')
      }
    }
  }, [_vm._v("个人中心")])])])])
},staticRenderFns: []}

/***/ }),

/***/ "pUfj":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("SNgt")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("aqsg"),
  /* template */
  __webpack_require__("xQzT"),
  /* scopeId */
  "data-v-436439b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "pd5+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/priv-tdtq-big.png";

/***/ }),

/***/ "px5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");


var echarts = __webpack_require__("Icdr");

__webpack_require__("4UDB");

__webpack_require__("Oq2I");

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ResumeChart',
	props: [],
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		cvipMes: 'cvipMes'
	}),
	data: function data() {
		return {
			analysis: '',

			xAxisData: [],
			seriesDataResumeSee: [],
			seriesDataResume: [],
			seriesDataCompanySee: [],
			seriesDataCompany: []
		};
	},

	methods: {
		randerChart: function randerChart(id) {
			var h_size = parseInt(document.getElementsByTagName('html')[0].style.fontSize);
			this.chart = echarts.init(document.getElementById(id));
			this.chart.showLoading();
			var option = {
				color: ['#4886FF', '#EE0035'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'line',
						lineStyle: {
							color: '#D4B277',
							width: 1
						}
					},
					formatter: function formatter(params) {
						var res = '<div class=\'chart_tip clear\'>\n\t\t\t\t\t\t\t<div class=\'time\'>' + params[0].axisValue + '</div>\n\t\t\t\t\t\t\t<div class=\'data\'><span class=\'blue\'></span>\u884C\u4E1A\u5E73\u5747\uFF1A' + params[0].value + '</div>\n\t\t\t\t\t\t\t<div class=\'data\'><span class=\'red\'></span>\u7B80\u5386\u88AB\u67E5\u770B\u6B21\u6570\uFF1A' + params[1].value + '</div>\n\t\t\t\t\t\t</div>';
						return res;
					}
				},
				dataZoom: {
					show: false,
					realtime: true,
					start: 0,
					end: 100,
					fillerColor: '#FFBB80',
					handleColor: '#D0AD71'
				},
				xAxis: [{
					type: 'category',
					axisTick: {
						show: false
					},
					splitLine: {
						lineStyle: {
							color: "#D0AD71",
							type: 'dashed',
							width: 3
						}
					},
					axisLine: {
						lineStyle: {
							color: '#ddd',
							width: 1
						}
					},
					axisLabel: {
						textStyle: {
							color: "#aaa",
							fontSize: 12,
							fontFamily: 'Microsoft YaHei'
						},
						margin: 8,
						interval: 0
					},
					data: this.xAxisData
				}],
				yAxis: [{
					type: 'value',

					axisLine: {
						show: false,
						lineStyle: {
							color: '#ddd',
							width: 1
						}
					},
					splitLine: {
						lineStyle: {
							color: "#E0E0E0;",
							type: 'solid',
							width: 1
						}
					},
					axisLabel: {
						show: true,
						textStyle: {
							color: "#aaa",
							fontSize: 12,
							fontFamily: 'Microsoft YaHei'
						},
						margin: 10,
						interval: 0
					}
				}],
				grid: {
					left: 30,
					top: 24,
					width: '90%',
					height: '75%',
					borderWidth: 0
				},
				series: [{
					name: '本地同行平均',
					type: 'line',
					symbolSize: 0,
					lineStyle: {
						normal: {
							color: '#1EC8EA',
							width: 0
						}
					},
					areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: ' #FFBB80'
							}, {
								offset: 1,
								color: 'rgba(255,226,183,0.33)'
							}])
						}
					},
					smooth: true,
					data: this.seriesDataResume
				}, {
					name: '简历被查看次数',
					type: 'line',
					symbolSize: 0,
					lineStyle: {
						normal: {
							color: '#D4B277',
							width: 3
						}
					},
					smooth: true,
					data: this.seriesDataResumeSee
				}]
			};
			option.xAxis[0].axisLabel.textStyle.fontSize = 24 / 75 * h_size;
			option.yAxis[0].axisLabel.textStyle.fontSize = 24 / 75 * h_size;

			this.chart.setOption(option);
			this.chart.hideLoading();
		},
		randerChartCompany: function randerChartCompany(id) {
			var h_size = parseInt(document.getElementsByTagName('html')[0].style.fontSize);
			this.chart = echarts.init(document.getElementById(id));
			this.chart.showLoading();
			var option = {
				color: ['#4886FF', '#EE0035'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'line',
						lineStyle: {
							color: '#D4B277',
							width: 1
						}
					},
					formatter: function formatter(params) {
						var res = '<div class=\'chart_tip clear\'>\n\t\t\t\t\t\t\t<div class=\'time\'>' + params[0].axisValue + '</div>\n\t\t\t\t\t\t\t<div class=\'data\'><span class=\'blue\'></span>\u884C\u4E1A\u5E73\u5747\uFF1A' + params[0].value + '</div>\n\t\t\t\t\t\t\t<div class=\'data\'><span class=\'red\'></span>\u5BF9\u4F60\u611F\u5174\u8DA3\u7684\u4F01\u4E1A\uFF1A' + params[1].value + '</div>\n\t\t\t\t\t\t</div>';
						return res;
					}
				},
				dataZoom: {
					show: false,
					realtime: true,
					start: 0,
					end: 100,
					fillerColor: 'rgba(128,183,249,0.2)',
					handleColor: '#4B89FF'
				},
				xAxis: [{
					type: 'category',
					axisTick: {
						show: false
					},
					splitLine: {
						lineStyle: {
							color: "#D0AD71",
							type: 'dashed',
							width: 1
						}
					},
					axisLine: {
						lineStyle: {
							color: '#ddd',
							width: 1
						}
					},
					axisLabel: {
						textStyle: {
							color: "#aaa",
							fontSize: 12,
							fontFamily: 'Microsoft YaHei'
						},
						margin: 8
					},
					data: this.xAxisData
				}],
				yAxis: [{
					type: 'value',

					axisLine: {
						show: false,
						lineStyle: {
							color: '#ddd',
							width: 1
						}
					},
					splitLine: {
						lineStyle: {
							color: "#E0E0E0",
							type: 'solid',
							width: 1
						}
					},
					axisLabel: {
						show: true,
						textStyle: {
							color: "#aaa",
							fontSize: 12,
							fontFamily: 'Microsoft YaHei'
						},
						margin: 10
					}
				}],
				grid: {
					left: 30,
					top: 24,
					width: '90%',
					height: '75%',
					borderWidth: 0
				},
				series: [{
					name: '行业平均',
					type: 'line',
					symbolSize: 0,
					lineStyle: {
						normal: {
							color: '#FFBB80',
							width: 0
						}
					},
					areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#FFBB80'
							}, {
								offset: 1,
								color: 'rgba(255,226,183,0.33)'
							}])
						}
					},
					smooth: true,
					data: this.seriesDataCompany
				}, {
					name: '对你感兴趣的企业',
					type: 'line',
					symbolSize: 0,
					lineStyle: {
						normal: {
							color: '#D4B277',
							width: 3
						}
					},
					smooth: true,
					data: this.seriesDataCompanySee
				}]
			};
			option.xAxis[0].axisLabel.textStyle.fontSize = 24 / 75 * h_size;
			option.yAxis[0].axisLabel.textStyle.fontSize = 24 / 75 * h_size;

			this.chart.setOption(option);
			this.chart.hideLoading();
		},
		chartData: function chartData() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.analysis.jobSeekingData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var v = _step.value;

					this.xAxisData.push(v.date);
					this.seriesDataResumeSee.push(v.browseCount);
					this.seriesDataResume.push(v.industryBrowseCount);
					this.seriesDataCompanySee.push(v.downloadCount);
					this.seriesDataCompany.push(v.industryDownloadCount);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	},
	created: function created() {
		this.analysis = this.cvipMes.analysis;
		this.chartData();
		this.$nextTick(function () {
			this.randerChart('chartResume');
			this.randerChartCompany('chartCompany');
		});
	}
});

/***/ }),

/***/ "px9A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rVy6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'zgbsDialog',
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
  },
  data: function data() {
    return {
      title: '尊贵标识',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: '',
      btnTxt2: '立即体验'
    };
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-zgbs-tanchuang-show-' + this.cvipMes.cvipstate);
  },

  methods: {
    vipBuy: function vipBuy() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-zgbs-ljkt-' + this.cvipMes.cvipstate);
      this.$emit("buyDialog");
    },
    close: function close() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-zgbs-close-' + this.cvipMes.cvipstate);
      this.$emit("closeDialog");
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed' })
});

/***/ }),

/***/ "rY9p":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("cZgk")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xOY6"),
  /* template */
  __webpack_require__("Nqoy"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "s1Tl":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("E+Eo")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("g9Mj"),
  /* template */
  __webpack_require__("tOvU"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "s6tE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'qzywDialog',
    components: {
        CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
    },
    props: {
        vipState: {
            default: function _default() {
                return 0;
            }
        },
        insuranceState: {
            type: Number,
            default: function _default() {
                return 0;
            }
        }
    },
    data: function data() {
        return {
            title: '财产安全险',
            btnTxt: '开通会员尊享特权',
            title1: '',
            btnTxt1: '',
            title2: '',
            btnTxt2: '立即投保'
        };
    },
    created: function created() {
        window.clickLog && window.clickLog('from=pc-cvip-qzyw-tanchuang-show-' + this.cvipMes.cvipstate + '-new');
    },

    methods: {
        vipBuy: function vipBuy() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-qzyw-ljkt-' + this.cvipMes.cvipstate + '-new');
            this.$emit("buyDialog");
        },
        applyCompensate: function applyCompensate() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-qzyw-bxbx-' + this.cvipMes.cvipstate + '-new');
            this.$emit("compensateDialog");
        },
        close: function close() {
            window.clickLog && window.clickLog('from=pc-cvip-tqtc-qzyw-close-' + this.cvipMes.cvipstate + '-new');
            this.$emit("closeDialog");
        }
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
        cvipMes: 'cvipMes',
        rightUsed: 'rightUsed' })

});

/***/ }),

/***/ "tOvU":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page2"
  }, [_c('div', {
    staticClass: "vip-introduce"
  }, [_vm._l((_vm.introData), function(item, i) {
    return (i === _vm.currentIndex) ? _c('div', {
      key: i,
      staticClass: "swiper-page"
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('div', [(i === _vm.currentIndex) ? _c('div', {
      staticClass: "intro-left"
    }, [_c('p', {
      staticClass: "intro-title"
    }, [_vm._v("\n                                " + _vm._s(item.introTitle) + "\n                                "), _c('i', {
      staticClass: "under-line"
    })]), _vm._v(" "), _c('div', {
      staticClass: "intro-desc"
    }, [_vm._l((item.introDesc), function(content) {
      return _c('p', {
        staticClass: "desc-content"
      }, [_c('i', {
        staticClass: "desc-icon"
      }), _vm._v(" "), _c('span', {
        staticClass: "desc-text"
      }, [_vm._v(_vm._s(content))])])
    }), _vm._v(" "), _c('div', {
      staticClass: "btn-buyvip",
      on: {
        "click": function($event) {
          return _vm.showDialog(item.actionType)
        }
      }
    }, [_c('p', {
      staticClass: "btn-text"
    }, [_vm._v(_vm._s(item.introBtnText))])])], 2)]) : _vm._e(), _vm._v(" "), (i === _vm.currentIndex) ? _c('div', {
      staticClass: "intro-right"
    }, [_c('img', {
      staticClass: "intro-demoimmg",
      attrs: {
        "src": item.introDemoImg,
        "alt": ""
      }
    })]) : _vm._e()])])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "vip-intro-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }, [_c('div', {
    staticClass: "intro-nav"
  }, [_c('ul', _vm._l((_vm.introData), function(item, i) {
    return _c('li', {
      staticClass: "custom-index",
      on: {
        "click": function($event) {
          return _vm.changeIndex(i, item.tabActionType)
        }
      }
    }, [_c('i', {
      staticClass: "active-bg",
      class: {
        'active': i === _vm.currentIndex
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "custom-text",
      class: {
        'active-text': i === _vm.currentIndex
      }
    }, [_vm._v(_vm._s(item.introTitle))])])
  }), 0)])])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "tlXl":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("7Lah")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("voRi"),
  /* template */
  __webpack_require__("DWx1"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "uLCS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABqCAYAAABUIcSXAAAAAXNSR0IArs4c6QAABS5JREFUeAHtnNtuG0UYx7+xvYntxCGJGkwaaKEojRBIRanEHU8A4Yar8gJwU27yNByuW6kSEgLegHvEBRTa0FDTEDtpEh+7XnvtXXZSNrYsOx4fdjyz+x8psr2encPv5+/bWXsUIhQQAAEQAAEQAAEQAAEQAAEQAAEQAAEQAAEQAAEQAAEQAAEQAAEQAAEQAAEQAAEQiB4BJmvKlV+/vmk79k7MdTKy+hTpZ+HKG2fGtfi3jO2YIvVnVScmq2MVJfG5G3Op1dYztmvtP9iSxWKcfqSJUi2SumElDCNuzGfutPa/+6T7uErPpYlSadL9xhKLxSieWtxu5r7/0nV/TPerM8tjENVDX9VUCFE9ovhLFVMhRPURxQ+plgohaoAo/7AqqTCw+yjr8f2PXKKvyHU3/Emr8Gi88uaZdfzwG9uuW3w8S6/d8KInMXRojuOQ2zB/Sdz49IehlQOoEJio+uP7B6pJ4vyS2ffJbVst6/SvB43q0V56+SrNpReF0drN+kxukINLfYpFUrcJFk8mUq++eye9trlj1o6JR4tomVUqDE6U6MxnVo+xuaVr25nsrbv1ciHZNGuesJbQaPxVoSXxBnl4chYaur6V4snl1XT21i5PhWZhf2/EmWx79aVcsyIcUR0l3amwc1StZxB14eP/VLhx+65hpJIXhxV5AlE9Is5T4cb27nwmu9nz1kxfRk6UK7BgUDEVRk6U06wKRoZaqTByouzaoXcfLrYM50ZVSYWRE0Vtmxqnj6htFUkkDXJZnVR482P+ehYlmvdRniy7nBuVN/+67bb399OoJ06jfvQiahrUZtCGchFlVov0/HCPWnZjqjgSxjytXd2kdGZlqu3Kaky5iApCEofJxfO2dS3KidIVZNDjVk4UT088TU27+Klv2u3Kak+5axS/hlzf+kDW/LXpR7mI0oac5IFClGTg43anXOoTnYhllqlWOiTLtOjK+luUXFgWPVXLelpGVLPxgionT6nVsKhh1Sife3j+qKUBwUFrJ6rValLl+G/yvlklfwuV47Sp8PR34u+FtWglyvWElAv7nU0ovinPDpfEZXFpYSxaiSp6kdRun++b7OuCp8GjZ3/2fU/3g9qIKj3Pedek2lDeZvWMTvJPhtbTrYIWomqlI2qaRWG25dND4n9hKsqLqr8oklnO92fedY3qrcCjikdXWIrSovgyvHr6z0DWl3g6P4dfr/h1KwxFWVHtln2xDB8E2luhX1r8ZTtvS/eirKhaqdBZhg+gzNiwmHq5bC+dHAxoQZ/DyopiF7ez+sAMcqTKilpYyXq/Sy1MOHdGqfQSLa+9PmE7sz9d2S9l43GDVr0fEf3y5Lef/adCj2+/96FQPV0qKRtRugCUNU6IkkV6wn4gakKAsk6HKFmkJ+wHoiYEKOt0iJJFesJ+IGpCgLJO10bUKJsyR6krC/Sk/WgjSnQHre47YgcJVfabid4BR30HrTYR1Ssuaq+1iah87g+q18R+jk8trtD69XdC5TKUEcXYkF8UNVSoTUSFLUJG/ayEMqJGhaBDfW0iqnKW9zaqiP2z//lkmpZW14Pnz1gl+E5e9hDKiJJxhXJYrBqPzUn7VwbDd4eM+ZGpP7ong9eYoxv/tNTWZ4Exu2xUoYyoyyas63sQpYk5iIIoTQhoMkxEVORFMfavJgzEh8noQLzydGsGFlHeGvZzCpMsby7eNusvposfrYEACIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACIAACISPwH+5nXL7oUc5aAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "ub8e":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("WXzV")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xj10"),
  /* template */
  __webpack_require__("wq62"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "vAXI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/expir-dialog.png";

/***/ }),

/***/ "vEX7":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('titles', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    }
  }), _vm._v(" "), _c('full-page', {
    ref: "fullpage",
    attrs: {
      "options": _vm.options,
      "id": "fullpage"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('headers', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('vip-introduce', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage === 1),
      expression: "currentPage === 1"
    }],
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.showDialog
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('job-privilege', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showPrivilDialog": _vm.showPrivilDialog,
      "buyDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('job-safeguard', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.showDialog,
      "showPrivilDialog": _vm.showPrivilDialog,
      "buyDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('iden-privilege', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.showDialog,
      "showPrivilDialog": _vm.showPrivilDialog,
      "buyDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('vip-card', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.showDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('job-analysis', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.showDialog
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "controller"
  }, [_c('ul', [_vm._l((_vm.pageNum), function(index) {
    return _c('li', {
      key: 'controller-' + index,
      staticClass: "controller-item",
      class: {
        current: index === _vm.currentPage + 1
      },
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          return _vm.changePage(index, 'pc-cvip-louti-' + _vm.actionType[index - 1])
        }
      }
    }, [_vm._v(_vm._s(index > 10 ? index : '0' + index))])
  }), _vm._v(" "), _c('li', {
    staticClass: "ciecle-svg-wrap"
  }, [_c('div', {
    staticClass: "ciecle-svg"
  }), _vm._v(" "), _c('div', {
    staticClass: "arror-top",
    on: {
      "click": function($event) {
        return _vm.nextPrev('top')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arror-down",
    on: {
      "click": function($event) {
        return _vm.nextPrev('down')
      }
    }
  })])], 2)]), _vm._v(" "), (_vm.buyDialog === true) ? _c('BuyDialog', {
    attrs: {
      "cardChoose": _vm.cardChoose
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHyxy) ? _c('hyxy-dialog', {
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showJlzd) ? _c('jlzd-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showYpyx) ? _c('ypyx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWxsx) ? _c('wxsx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTdtq) ? _c('tdtq-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQzfx) ? _c('qzfx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWxbp) ? _c('qzbz-dialog', {
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCcaq) ? _c('ccaq-dialog', {
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZskf) ? _c('zskf-dialog', {
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZgbs) ? _c('zgbs-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGrrz) ? _c('grrz-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHjld) ? _c('hjld-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "voRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_index_js__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_VipLoginNo_vue__ = __webpack_require__("4it6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_VipLoginNo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__app_VipLoginNo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_Vip_vue__ = __webpack_require__("kg7A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_Vip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__app_Vip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_VipNo_vue__ = __webpack_require__("hj+5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_VipNo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__app_VipNo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_VipExpir_vue__ = __webpack_require__("hscH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_VipExpir_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__app_VipExpir_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {
		VipLogin: __WEBPACK_IMPORTED_MODULE_4__app_VipLoginNo_vue___default.a,
		Vip: __WEBPACK_IMPORTED_MODULE_5__app_Vip_vue___default.a,
		VipNo: __WEBPACK_IMPORTED_MODULE_6__app_VipNo_vue___default.a,
		VipExpir: __WEBPACK_IMPORTED_MODULE_7__app_VipExpir_vue___default.a
	},
	data: function data() {
		return {
			vipState: '',
			cardState: 0,
			pageZoom: false,
			loading: true
		};
	},
	created: function created() {
		this.changeZoom();
		this.getUserMesFn();
		this.getEnterCvipFn(this.fromSource);
		this.getMealInfo();
	},

	methods: {
		getUserMesFn: function getUserMesFn() {
			var _this = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["a" /* getUserMes */])().then(function (result) {
				if (result.isSuccess) {
					if (!result.entity) {
						_this.$store.commit('IS_LOGIN', false);
						window.clickLog && window.clickLog('from=pc-cvip-shouyeshow-' + 1 + '-new');

						_this.loading = false;
						return;
					}
					_this.$store.commit('IS_LOGIN', true);

					_this.$store.commit('USER_INFO', {
						nickname: result.entity.nickname,
						profile: result.entity.profile
					});
					_this.getCvipinfoFn();
					_this.getCvipMainFn('pc');
					_this.getInsurance();
					_this.getAccidentInsuranceState();
					_this.getResumeHighlightFn('pc', 5);
				}
			}).catch(function (err) {
				console.error('网络异常-------------getUserMes');
			});
		},
		getCvipinfoFn: function getCvipinfoFn() {
			var _this2 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["b" /* getCvipinfo */])().then(function (result) {
				if (result.isSuccess) {
					_this2.vipState = result.entity.state;
					_this2.cardState = result.entity.cardState || 1;

					window.clickLog && window.clickLog('from=pc-cvip-shouyeshow-' + _this2.vipState + '-new');

					_this2.loading = false;
				} else {
					console.log('网络异常---------getCvipinfo----result');
				}
			}).catch(function (err) {
				console.error('网络异常-------------getCvipinfoFn');
			});
		},
		getCvipMainFn: function getCvipMainFn(ft) {
			var _this3 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["c" /* getCvipMain */])(ft).then(function (result) {
				if (result.isSuccess) {
					_this3.$store.commit({
						type: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["a" /* CHANGE_CVIP_MES */],
						state: result.entity
					});
					if (result.entity.advice) {
						_this3.$store.commit('RIGHT_USED', result.entity.advice.resourceUsedResult.resourceUsedMap);
					}
					_this3.$store.commit('LEFT_TOP', result.entity.leftTop);

					_this3.$store.commit('RENEW_STATE', result.entity.renew);
				} else {
					console.log('网络异常-----------getCvipMain----result');
				}
			}).catch(function (err) {
				console.log('网络异常-----------getCvipMain');
			});
		},
		getInsurance: function getInsurance() {
			var _this4 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["d" /* getinsurance */])().then(function (result) {
				_this4.$store.commit('CVIP_STATE', result);
			}).catch(function (err) {
				console.log('网络异常');
			});
		},
		getAccidentInsuranceState: function getAccidentInsuranceState() {
			var _this5 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["e" /* getAccidentInsuranceState */])().then(function (result) {
				if (result.isSuccess) {
					_this5.$store.commit('INSURANCE_STATE', result);
				} else {
					console.log('网络异常');
				}
			}).catch(function (err) {
				console.log('网络异常');
			});
		},
		getEnterCvipFn: function getEnterCvipFn(from) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["f" /* getEnterCvip */])(from).then(function (res) {
				console.log('********** 记录入口 **********');
			}).catch(function (err) {
				console.log('网络异常');
			});
		},
		changeZoom: function changeZoom() {
			if (outerWidth <= 1440) {
				this.pageZoom = true;
			}
		},
		getResumeHighlightFn: function getResumeHighlightFn(ft, productid) {
			var _this6 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["g" /* getResumeHighlight */])(ft, productid).then(function (result) {
				if (result.isSuccess) {
					var num = result.entity && result.entity.resumes ? result.entity.resumes.length : 0;
					_this6.$store.commit('RESUME_NUM', num);
				} else {
					console.log('网络异常');
				}
			}).catch(function (err) {
				console.log('网络异常 --------- getResumeHighlightFn');
			});
		},
		getMealInfo: function getMealInfo() {
			var _this7 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_index_js__["h" /* getPrice */])().then(function (result) {
				if (result.isSuccess) {
					_this7.$store.commit('MEAL_INFO', result.entity);
				} else {
					console.error('网络异常-----result-----getprice');
				}
			}).catch(function (err) {
				console.log('网络异常-------getprice');
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		cvipMes: 'cvipMes',
		loginIs: 'loginIs',
		fromSource: 'fromSource'
	}))

});

/***/ }),

/***/ "wNpd":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jlzd-dialog-wrap"
  }, [((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[5]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("简历置顶")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：使用置顶后您的全职简历将在列表顶端展示，更多HR将会看到您的简历。功能有天数限制，基础版增送4天，升级版增送8天")])]), _vm._v(" "), _c('div', {
    staticClass: "jlzd-bg"
  }, [_c('img', {
    staticClass: "jlzd-bg-img",
    attrs: {
      "src": __webpack_require__("/rVf")
    }
  })])]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[5]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.resumeListNum ? '立即体验' : '创建简历'
    },
    on: {
      "btnClick": function($event) {
        return _vm.topResumefn()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit tit-nouse"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("简历置顶")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：使用置顶后您的全职简历将在列表顶端展示，更多HR将会看到您的简历。功能有天数限制，基础版增送4天，升级版增送8天")])]), _vm._v(" "), _c('div', {
    staticClass: "jlzd-bg"
  }, [_c('img', {
    staticClass: "jlzd-bg-img",
    attrs: {
      "src": __webpack_require__("/rVf")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("使用置顶后您的全职简历将在列表顶端展示，更多HR将会看到您的简历。功能有天数限制，基础版增送4天，升级版增送8天")])]), _vm._v(" "), _c('div', {
    staticClass: "jlzd-bg"
  }, [_c('img', {
    staticClass: "jlzd-bg-img",
    attrs: {
      "src": __webpack_require__("/rVf")
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "wfM2":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("iJb9")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("iJWV"),
  /* template */
  __webpack_require__("lNgb"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "wlP2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__ = __webpack_require__("TkdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_CvipDialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'grrzDialog',
  components: {
    CvipDialog: __WEBPACK_IMPORTED_MODULE_1__common_CvipDialog___default.a
  },
  data: function data() {
    return {
      title: '个人认证',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: '',
      btnTxt2: '免费认证'
    };
  },
  created: function created() {
    window.clickLog && window.clickLog('from=pc-cvip-grrz-tanchuang-show-' + this.cvipMes.cvipstate);
  },

  methods: {
    vipBuy: function vipBuy() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-grrz-ljkt-' + this.cvipMes.cvipstate);
      this.$emit('buyDialog');
    },
    close: function close() {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-grrz-close-' + this.cvipMes.cvipstate);
      this.$emit('closeDialog');
    },
    certification: function certification() {
      this.$emit('authDialog');
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed' })
});

/***/ }),

/***/ "wq62":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page4"
  }, [_c('div', {
    staticClass: "jobSafe-privilege"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "job-comment"
  }, [_c('div', {
    staticClass: "job-swiper-pagination"
  }, [_c('div', {
    staticClass: "jobPrivi-icon"
  }, [_c('ul', _vm._l((_vm.commentData), function(item, index) {
    return _c('li', {
      staticClass: "icon-page hover-class",
      on: {
        "mouseenter": function($event) {
          return _vm.enter(index)
        },
        "mouseleave": function($event) {
          return _vm.leave()
        },
        "click": function($event) {
          return _vm.show(item.clickShow, item.actionType)
        }
      }
    }, [_c('div', {
      staticClass: "icon-radius"
    }, [_c('div', {
      staticClass: "icon-box",
      class: {
        'active': index === _vm.currentIndex
      }
    }, [_c('div', {
      staticClass: "icon",
      style: ({
        backgroundImage: 'url(' + item.iconUrl + ')',
        backgroundSize: 'contain'
      })
    })])]), _vm._v(" "), _c('p', {
      staticClass: "detail-text"
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('div', {
      staticClass: "icon-title"
    }, [_vm._v(_vm._s(item.privTitle))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "comment-display"
  }, [_vm._l((_vm.commentData), function(item, index) {
    var _obj;

    return (index === _vm.currentIndex) ? _c('div', {
      key: index,
      staticClass: "comment-box",
      class: ( _obj = {
        'dialog-box-active': index === _vm.currentIndex
      }, _obj[item.itemClass] = index === _vm.currentIndex, _obj )
    }, [_c('div', {
      staticClass: "comment"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "dialog-box"
    }, [_c('p', {
      staticClass: "comment-text"
    }, [_c('span', {
      staticClass: "mark-max"
    }, [_vm._v(" “")]), _vm._v(" "), _c('span', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.comments[_vm.randomIndex].commentText)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "priv-result"
    }, [_vm._v("\n                                " + _vm._s(item.comments[_vm.randomIndex].privResult)), _c('span', {
      staticClass: "result"
    }, [_vm._v(_vm._s(item.comments[_vm.randomIndex].result))])]), _vm._v(" "), _c('p', {
      staticClass: "comment-from"
    }, [_vm._v(_vm._s(item.comments[_vm.randomIndex].commentFrom))])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-bg"
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "btn-buyvip"
  }, [_c('p', {
    staticClass: "btn-text",
    on: {
      "click": function($event) {
        return _vm.buyVipDialog('pc-cvip-huiyuantequan-kaiqiqiuzhibaozhang')
      }
    }
  }, [_vm._v("立即开启求职保障")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "priv-title"
  }, [_vm._v("求职保障")]), _vm._v(" "), _c('div', {
    staticClass: "priv-desc"
  }, [_vm._v("求职路上为你保驾护航，求职无效果可获得6倍赔偿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('div', {
    staticClass: "hidden-line"
  })])
}]}

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ "xOY6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dialog_ResumeTopDialog__ = __webpack_require__("pUfj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dialog_ResumeTopDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_dialog_ResumeTopDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dialog_GoldLightDialog__ = __webpack_require__("ZvIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dialog_GoldLightDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_dialog_GoldLightDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dialog_ZgbsDialog__ = __webpack_require__("FJcN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dialog_ZgbsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_dialog_ZgbsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_dialog_WxsxDialog__ = __webpack_require__("3NXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_dialog_WxsxDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_dialog_WxsxDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_dialog_QzfxDialog__ = __webpack_require__("O5TR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_dialog_QzfxDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_dialog_QzfxDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dialog_GrrzDialog__ = __webpack_require__("AvFD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dialog_GrrzDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modules_dialog_GrrzDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dialog_JlzdDialog__ = __webpack_require__("5bV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dialog_JlzdDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modules_dialog_JlzdDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dialog_HjldDialog__ = __webpack_require__("0BnJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dialog_HjldDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modules_dialog_HjldDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dialog_TdtqDialog__ = __webpack_require__("KDpj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dialog_TdtqDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modules_dialog_TdtqDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dialog_QzbzDialog__ = __webpack_require__("C/Se");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dialog_QzbzDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modules_dialog_QzbzDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_dialog_CcaqDialog__ = __webpack_require__("p+Y0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_dialog_CcaqDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modules_dialog_CcaqDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_dialog_YpyxDialog__ = __webpack_require__("gqJ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_dialog_YpyxDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modules_dialog_YpyxDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_dialog_ZskfDialog__ = __webpack_require__("cEZJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_dialog_ZskfDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modules_dialog_ZskfDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_alert_Alert__ = __webpack_require__("oOGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_alert_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_alert_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__("NYxO");



















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'myPrivileges',
	components: {
		ResumeTopDialog: __WEBPACK_IMPORTED_MODULE_1__modules_dialog_ResumeTopDialog___default.a,
		GoldLightDialog: __WEBPACK_IMPORTED_MODULE_2__modules_dialog_GoldLightDialog___default.a,
		ZgbsDialog: __WEBPACK_IMPORTED_MODULE_3__modules_dialog_ZgbsDialog___default.a,
		WxsxDialog: __WEBPACK_IMPORTED_MODULE_4__modules_dialog_WxsxDialog___default.a,
		QzfxDialog: __WEBPACK_IMPORTED_MODULE_5__modules_dialog_QzfxDialog___default.a,
		GrrzDialog: __WEBPACK_IMPORTED_MODULE_6__modules_dialog_GrrzDialog___default.a,
		JlzdDialog: __WEBPACK_IMPORTED_MODULE_7__modules_dialog_JlzdDialog___default.a,
		HjldDialog: __WEBPACK_IMPORTED_MODULE_8__modules_dialog_HjldDialog___default.a,

		TdtqDialog: __WEBPACK_IMPORTED_MODULE_9__modules_dialog_TdtqDialog___default.a,
		QzbzDialog: __WEBPACK_IMPORTED_MODULE_10__modules_dialog_QzbzDialog___default.a,
		CcaqDialog: __WEBPACK_IMPORTED_MODULE_11__modules_dialog_CcaqDialog___default.a,
		CvipAlert: __WEBPACK_IMPORTED_MODULE_14__components_alert_Alert___default.a,
		YpyxDialog: __WEBPACK_IMPORTED_MODULE_12__modules_dialog_YpyxDialog___default.a,
		ZskfDialog: __WEBPACK_IMPORTED_MODULE_13__modules_dialog_ZskfDialog___default.a
	},
	props: ['vipState', 'cardState'],
	data: function data() {
		return {
			mark: 0,
			showTop: false,
			showLight: false,
			showZgbs: false,
			showWxsx: false,
			showQzfx: false,
			showGrrz: false,
			showJlzd: false,
			showHjld: false,
			showTdtq: false,
			showQzbz: false,
			showCcaq: false,
			showYpyx: false,
			showZskf: false,
			nowIndex: 0,
			isShow: true,
			inv: 5000,
			slides: [{
				src: '',
				title: 'xxx1'
			}, {
				src: '',
				title: 'xxx2'
			}],
			alertTxt: '',
			showSuccess: false,
			privilegesCategorys: ['求职特权', '求职保障']
		};
	},
	created: function created() {
		this.play();
	},
	mounted: function mounted() {
		this.runInv();
	},

	methods: {
		hightResume: function hightResume() {
			this.closeDialog();
			if (!this.resumeListNum) {
				window.open("//jianli.58.com/resumepost/view/fulltime/");
				return;
			}
			this.showLight = true;
			window.clickLog && window.clickLog('from=pc-cvip-gerentequan-hjbq-szbq-' + this.cvipMes.cvipstate + '-new');
		},
		topResume: function topResume() {
			this.closeDialog();
			if (!this.resumeListNum) {
				window.open("//jianli.58.com/resumepost/view/fulltime/");
				return;
			}
			this.showTop = true;
			window.clickLog && window.clickLog('from=pc-cvip-gerentequan-jlzd-ljzd-' + this.cvipMes.cvipstate + '-new');
		},
		closeDialog: function closeDialog() {
			this.showTop = false;
			this.showLight = false;
			this.showZgbs = false;
			this.showWxsx = false;
			this.showQzfx = false;
			this.showGrrz = false;
			this.showJlzd = false;
			this.showHjld = false;
			this.showJsgt = false;
			this.showTdtq = false;
			this.showQzbz = false;

			this.showCcaq = false;
			this.showYpyx = false;
			this.showZskf = false;
		},
		compensateDialog: function compensateDialog() {
			this.closeDialog();
			this.$emit('showCompensateDialog');
		},
		showAuthDialog: function showAuthDialog() {
			this.closeDialog();
			this.$emit('showAuthDialog');
		},
		lightBtnChange: function lightBtnChange() {
			this.$store.commit('RIGHT_USED', {
				'4': true
			});
		},
		topBtnChange: function topBtnChange() {
			this.$store.commit('RIGHT_USED', {
				'5': true
			});
		},
		certification: function certification() {
			this.$emit('showAuthDialog');
		},
		show: function show(type) {
			window.clickLog && window.clickLog('from=pc-cvip-gerentequan-' + type + '-dj-' + this.cvipMes.cvipstate + '-new');

			switch (type) {
				case 'tdtq':
					this.showTdtq = true;
					break;
				case 'qzbz':
					this.showQzbz = true;
					break;

				case 'ccaq':
					this.showCcaq = true;
					break;
				case 'zgbs':
					this.showZgbs = true;
					break;
				case 'wxsx':
					this.showWxsx = true;
					break;
				case 'qzfx':
					this.showQzfx = true;
					break;
				case 'grrz':
					this.showGrrz = true;
					break;
				case 'jlzd':
					this.showJlzd = true;
					break;
				case 'hjld':
					this.showHjld = true;
					break;
				case 'ypyx':
					this.showYpyx = true;
					break;
				case 'zskf':
					this.showZskf = true;
					break;
			}
		},
		buyDialog: function buyDialog() {
			this.closeDialog();
			this.$emit('showDialog');
		},
		autoPlay: function autoPlay() {
			this.mark++;
			if (this.mark === 2) {
				this.mark = 0;
			}
		},
		play: function play() {
			if (this.cardState === 20) this.slides.push({});
			setInterval(this.autoPlay, 5000);
		},
		change: function change(i) {
			this.mark = i;
		},
		goto: function goto(index) {
			var _this = this;

			this.isShow = false;
			setTimeout(function () {
				_this.isShow = true;
				_this.nowIndex = index;
			}, 10);
		},
		runInv: function runInv() {
			var _this2 = this;

			this.invId = setInterval(function () {
				_this2.goto(_this2.nextIndex);
			}, this.inv);
		},
		clearInv: function clearInv() {
			clearInterval(this.invId);
		},
		showAlert: function showAlert(txt) {
			var _this3 = this;

			this.alertTxt = txt;
			setTimeout(function () {
				_this3.showSuccess = true;
			}, 500);
		},
		onHide: function onHide() {
			this.showSuccess = false;
		},
		goIntegrityReport: function goIntegrityReport() {
			window.top.open('//certify.58.com/self/index?utm_source=pc-jinkatequan');
			window.clickLog && window.clickLog('from=pc-cvip-gerentequan_certify');
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["a" /* mapGetters */])({
		cvipMes: 'cvipMes',
		leftTop: 'leftTop',
		rightUsed: 'rightUsed',
		resumeListNum: 'resumeListNum'
	}), {
		prevIndex: function prevIndex() {
			if (this.nowIndex === 0) {
				return this.slides.length - 1;
			} else {
				return this.nowIndex - 1;
			}
		},
		nextIndex: function nextIndex() {
			if (this.nowIndex === this.slides.length - 1) {
				return 0;
			} else {
				return this.nowIndex + 1;
			}
		},
		vipVersionState: function vipVersionState() {
			return this.$store.getters.getinsurance.code;
		},
		insuranceState: function insuranceState() {
			return this.$store.getters.getAccidentInsuranceState.code;
		}
	})
});

/***/ }),

/***/ "xQzT":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDialog),
      expression: "showDialog"
    }],
    staticClass: "rtop-dialog-wrap"
  }, [(_vm.daysUse > 0) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt,
      "disabled": _vm.daysUse === 0
    },
    on: {
      "btnClick": function($event) {
        return _vm.topBtnClick()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("使用置顶后您的全职简历将在列表顶端展示，更多HR将会看到您的简历。您剩余置顶天数为："), _c('em', [_vm._v(_vm._s(_vm.daysUse) + "天")])]), _vm._v(" "), _c('div', {
    staticClass: "resume-chose clear"
  }, [_c('p', {
    staticClass: "tit inline fl"
  }, [_vm._v("选择简历：")]), _vm._v(" "), _c('ul', {
    staticClass: "resume-list fl"
  }, _vm._l((_vm.resumeList), function(item, index) {
    return _c('li', {
      key: item.confuseResumeId,
      staticClass: "resume",
      class: {
        checked: _vm.choseIndex === index, 'status-toping': item.resumeTopState
      },
      on: {
        "click": function($event) {
          return _vm.choseResume(index, item.confuseResumeId)
        }
      }
    }, [_vm._v(_vm._s(item.resumeName))])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "tit inline fl"
  }, [_vm._v("置顶天数：")]), _vm._v(" "), _c('ul', {
    staticClass: "days-list fl"
  }, _vm._l((_vm.dayList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "day",
      class: {
        checked: item.daysid === _vm.dayChose, 'unable-day': _vm.daysUse < item.daysid
      },
      on: {
        "click": function($event) {
          return _vm.choseDay(item.daysid)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 0)]) : _c('cvip-alert', {
    attrs: {
      "buttonTxt": "去看看",
      "widthnew": "600px",
      "heightnew": "260px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-close": _vm.closeConfirm,
      "on-confirm": _vm.onConfirm
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("尊贵的会员")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "2"
    }
  }, [_vm._v("会员套餐中的简历置顶已使用完毕，您可以使用超低的会员价对简历置顶单独购买~")]), _vm._v(" "), _c('p', [_vm._v("(设置方式：我的简历--置顶按钮)")])]), _vm._v(" "), (_vm.showWarn) ? _c('cvip-alert', {
    attrs: {
      "buttonTxt": "我知道了",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-warn"
  }), _vm._v(" "), _c('span', [_vm._v("请选择简历或者置顶天数！")])]) : _vm._e(), _vm._v(" "), (_vm.showCancelWarn) ? _c('cvip-alert', {
    staticClass: "cancel-warn",
    attrs: {
      "cancelBtnTxt": "取消",
      "buttonTxt": "确定",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide,
      "on-confirm": _vm.cancelResumeTop
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-warn"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cancelWarnTipText))])]) : _vm._e(), _vm._v(" "), (_vm.showDayUseWarn) ? _c('cvip-alert', {
    staticClass: "cancel-warn",
    attrs: {
      "cancelBtnTxt": "取消",
      "buttonTxt": "去充值",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide,
      "on-confirm": _vm.goRecharge
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-warn"
  }), _vm._v(" "), _c('span', [_vm._v("您的置顶剩余资源不够")])]) : _vm._e(), _vm._v(" "), _c('toast', {
    staticClass: "cancel-toast",
    attrs: {
      "text": _vm.toastText
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "xTQa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/demo-img-resume.png";

/***/ }),

/***/ "xj10":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_data_js__ = __webpack_require__("cK/P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_index_js__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'jobSafeguard',
    data: function data() {
        return {
            currentIndex: 0,
            prevIndex: 0,
            nextIndex: 0,
            randomIndex: 0,
            commentData: __WEBPACK_IMPORTED_MODULE_1__data_data_js__["b" /* commentData */].jobSafeData,

            jobSTimer: null
        };
    },
    mounted: function mounted() {
        this.randomIndex = this.randomNum();
        this.autoplay();
    },

    methods: {
        autoplay: function autoplay() {
            this.play();
            this.jobSTimer = setInterval(this.play, 5000);
        },
        randomNum: function randomNum() {
            return Math.floor(Math.random() * (__WEBPACK_IMPORTED_MODULE_1__data_data_js__["b" /* commentData */].jobSafeData.length - 1));
        },
        play: function play() {
            this.currentIndex++;

            this.prevIndex = this.currentIndex === 0 ? 5 : this.currentIndex - 1;
            this.nextIndex = this.currentIndex === 2 ? 0 : this.currentIndex + 1;

            if (this.currentIndex === this.commentData.length) {
                this.currentIndex = 0;
                this.nextIndex = this.currentIndex + 1;
            }
        },
        enter: function enter(index) {
            this.currentIndex = index - 1;
            this.play();
            clearInterval(this.jobSTimer);
        },
        leave: function leave(index) {
            this.jobSTimer = setInterval(this.play, 5000);
        },
        show: function show(type, actionType) {
            window.clickLog && window.clickLog('from=' + actionType);
            this.$emit('showPrivilDialog', type, actionType);
        },
        buyVipDialog: function buyVipDialog(actionType) {
            this.$emit('buyDialog');
            window.clickLog && window.clickLog('from=' + actionType);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
        cvipMes: 'cvipMes',
        rightUsed: 'rightUsed',
        resumeListNum: 'resumeListNum',
        getinsurance: ''
    }), {
        vipState: function vipState() {
            return this.$store.getters.getinsurance.code;
        },
        insuranceState: function insuranceState() {
            return this.$store.getters.getAccidentInsuranceState.code;
        }
    })
});

/***/ }),

/***/ "yH38":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zsV4":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("+kS2")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("BXzT"),
  /* template */
  __webpack_require__("MjTV"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// js/app.js